/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `BigInt` scalar type represents non-fractional whole numeric values.
   * `BigInt` is not constrained to 32-bit like the `Int` type and thus is a less
   * compatible type.
   */
  BigInt: any;
  ClaimAttachmentUpload: any;
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: any;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: any;
  DocumentFileUpload: any;
  /** ISO-8601 Duration */
  Duration: any;
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: any;
  ImageUpload: any;
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: any;
  /** String that adheres to slug formatting specs */
  Slug: any;
};

/** An enumeration. */
export enum AccountTypes {
  Checking = 'CHECKING',
  Savings = 'SAVINGS'
}

export type AcknowledgeRejectedClaimRequestInput = {
  claimRequest: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type AcknowledgeRejectedClaimRequestPayload = {
  __typename?: 'AcknowledgeRejectedClaimRequestPayload';
  claimRequest?: Maybe<ClaimRequestNode>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ActionInterface = {
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<ProfessionalNode>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  icon?: Maybe<Scalars['String']>;
  important: Scalars['Boolean'];
  label: Scalars['String'];
  lastEditedBy?: Maybe<ProfessionalNode>;
  slug: Scalars['String'];
  status: ActionStatus;
  subtitle?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  viewingDraft: Scalars['Boolean'];
};

export type ActionNode = BaseActionNode | BookingPetActionNode | GenericCarePlanActionNode | IipPurchasePetActionNode | InPersonVisitActionNode | PetActionNode | PrescriptionPetActionNode | PrescriptionsPetActionNode | RxVirtualVisitActionNode | ScheduleAppointmentCarePlanActionNode | ViewCarePlanPetActionNode | VirtualVisitActionNode;

/**
 * Pet fields that may be required to be set in order to take certain membership
 * related actions (such as adding a pet to an insurance policy / emergency protection
 * when purchasing).
 */
export enum ActionRequiredPetFields {
  Birthday = 'BIRTHDAY',
  Breed = 'BREED',
  Gender = 'GENDER',
  Name = 'NAME',
  Type = 'TYPE'
}

/**
 * User fields that may be required to be set in order to take certain membership
 * related actions (such as purchasing EmergencyProtection)
 */
export enum ActionRequiredUserFields {
  Email = 'EMAIL',
  FullAddress = 'FULL_ADDRESS',
  FullName = 'FULL_NAME',
  PhoneNumber = 'PHONE_NUMBER',
  StateOfResidence = 'STATE_OF_RESIDENCE',
  VerifiedEmail = 'VERIFIED_EMAIL',
  VerifiedPhoneNumber = 'VERIFIED_PHONE_NUMBER'
}

/**
 * ASSIGNED - Action has been assigned to some user
 * PENDING - Assigned user has been made aware that a action was assigned and we are
 *     waiting for that user to take an action
 * STARTED - User has taken some action to acknowledge that they are aware of the task
 *     and/or taken steps to complete a action (ex: started filling out a form) but have
 *     not fully completed the action yet
 * COMPLETED - Action is completed
 * CANCELLED - Action will not be completed
 * EXPIRED - Action reached expired_by date before being completed
 * ARCHIVED - Action has been archived by a PRO. Can be restored later on
 *
 * Actions can potentially skip statuses (like jumping directly from PENDING to DONE)
 */
export enum ActionStatus {
  Archived = 'ARCHIVED',
  Assigned = 'ASSIGNED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  Started = 'STARTED'
}

export type ActivateAddOnInput = {
  addOn: PlanAddOnInput;
  attribution?: InputMaybe<AttributionInput>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** @deprecated Multiple payment methods no longer supported */
  paymentMethod?: InputMaybe<Scalars['ID']>;
};

export type ActivateAddOnPayload = {
  __typename?: 'ActivateAddOnPayload';
  addOn: AddOnStatusNode;
  clientMutationId?: Maybe<Scalars['String']>;
  userPlan: UserPlanNode;
};

export type AddClinicPetDetailInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  clinic: Scalars['ID'];
  pet: Scalars['ID'];
  slug: Scalars['String'];
};

/** Specific mutaion to add the different type of clinics (primary, secondary, etc) */
export type AddClinicPetDetailPayload = {
  __typename?: 'AddClinicPetDetailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  petDetail: PetDetailNode;
};

export type AddExternalPaymentMethodInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  partner: Scalars['ID'];
  processorMetadata?: InputMaybe<Scalars['JSONString']>;
  token: Scalars['String'];
};

export type AddExternalPaymentMethodPayload = {
  __typename?: 'AddExternalPaymentMethodPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  paymentMethod: ExternalPaymentMethodNode;
};

export type AddModelPetDetailsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pet: Scalars['ID'];
  slug: Scalars['String'];
  values: Array<InputMaybe<Scalars['ID']>>;
};

/** Specific mutation to add multiple model_value pet details */
export type AddModelPetDetailsPayload = {
  __typename?: 'AddModelPetDetailsPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  petDetails: Array<PetDetailNode>;
};

export type AddOnConnection = {
  __typename?: 'AddOnConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AddOnEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AddOn` and its cursor. */
export type AddOnEdge = {
  __typename?: 'AddOnEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AddOnNode>;
};

export type AddOnInterface = {
  activationFee?: Maybe<Scalars['Decimal']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  pricing?: Maybe<Array<AddOnPriceNode>>;
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type AddOnNode = EmergencyFundAddOnNode | VcprAddOnNode;

export type AddOnPriceNode = {
  __typename?: 'AddOnPriceNode';
  isActive: Scalars['Boolean'];
  price: PriceNode;
};

export type AddOnStatusConnection = {
  __typename?: 'AddOnStatusConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AddOnStatusEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AddOnStatus` and its cursor. */
export type AddOnStatusEdge = {
  __typename?: 'AddOnStatusEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AddOnStatusNode>;
};

export type AddOnStatusInterface = {
  isBundled: Scalars['Boolean'];
  price?: Maybe<PriceNode>;
  status: PlanStatus;
  validUntil?: Maybe<Scalars['DateTime']>;
};

export type AddOnStatusNode = EmergencyFundStatusNode | VcprStatusNode;

export type AddOrUpdateUserState = {
  __typename?: 'AddOrUpdateUserState';
  user?: Maybe<UserType>;
};

export type AddPaymentMethodInput = {
  /** @deprecated Replaced by 'setAsDefault' */
  applyToUserPlan?: InputMaybe<Scalars['Boolean']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  payOutstandingInvoices?: InputMaybe<Scalars['Boolean']>;
  paymentMethod: CreateUserPaymentMethodInput;
  setAsDefault?: InputMaybe<Scalars['Boolean']>;
};

export type AddPaymentMethodPayload = {
  __typename?: 'AddPaymentMethodPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<PaymentMethodNode>;
};

export type AddPetDetailEntryInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  petDetail: Scalars['ID'];
};

export type AddPetDetailEntryPayload = {
  __typename?: 'AddPetDetailEntryPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  response: NextResponse;
};

export type AddUserActivity = {
  __typename?: 'AddUserActivity';
  user?: Maybe<UserType>;
};

export type AddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

/** An enumeration. */
export enum AddressState {
  /** Alaska */
  Ak = 'AK',
  /** Alabama */
  Al = 'AL',
  /** Arkansas */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Arizona */
  Az = 'AZ',
  /** California */
  Ca = 'CA',
  /** Colorado */
  Co = 'CO',
  /** Connecticut */
  Ct = 'CT',
  /** District Of Columbia */
  Dc = 'DC',
  /** Delaware */
  De = 'DE',
  /** Florida */
  Fl = 'FL',
  /** Federated States Of Micronesia */
  Fm = 'FM',
  /** Georgia */
  Ga = 'GA',
  /** Guam */
  Gu = 'GU',
  /** Hawaii */
  Hi = 'HI',
  /** Iowa */
  Ia = 'IA',
  /** Idaho */
  Id = 'ID',
  /** Illinois */
  Il = 'IL',
  /** Indiana */
  In = 'IN',
  /** Kansas */
  Ks = 'KS',
  /** Kentucky */
  Ky = 'KY',
  /** Louisiana */
  La = 'LA',
  /** Massachusetts */
  Ma = 'MA',
  /** Maryland */
  Md = 'MD',
  /** Maine */
  Me = 'ME',
  /** Marshall Islands */
  Mh = 'MH',
  /** Michigan */
  Mi = 'MI',
  /** Minnesota */
  Mn = 'MN',
  /** Missouri */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Mississippi */
  Ms = 'MS',
  /** Montana */
  Mt = 'MT',
  /** North Carolina */
  Nc = 'NC',
  /** North Dakota */
  Nd = 'ND',
  /** Nebraska */
  Ne = 'NE',
  /** New Hampshire */
  Nh = 'NH',
  /** New Jersey */
  Nj = 'NJ',
  /** New Mexico */
  Nm = 'NM',
  /** Nevada */
  Nv = 'NV',
  /** New York */
  Ny = 'NY',
  /** Ohio */
  Oh = 'OH',
  /** Oklahoma */
  Ok = 'OK',
  /** Oregon */
  Or = 'OR',
  /** Pennsylvania */
  Pa = 'PA',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palau */
  Pw = 'PW',
  /** Rhode Island */
  Ri = 'RI',
  /** South Carolina */
  Sc = 'SC',
  /** South Dakota */
  Sd = 'SD',
  /** Tennessee */
  Tn = 'TN',
  /** Texas */
  Tx = 'TX',
  /** Utah */
  Ut = 'UT',
  /** Virginia */
  Va = 'VA',
  /** Virgin Islands */
  Vi = 'VI',
  /** Vermont */
  Vt = 'VT',
  /** Washington */
  Wa = 'WA',
  /** Wisconsin */
  Wi = 'WI',
  /** West Virginia */
  Wv = 'WV',
  /** Wyoming */
  Wy = 'WY'
}

export type AddressType = {
  __typename?: 'AddressType';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  formattedAddress?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['Decimal']>;
  longitude?: Maybe<Scalars['Decimal']>;
  neighborhood?: Maybe<Array<Scalars['String']>>;
  poBox?: Maybe<Scalars['String']>;
  state?: Maybe<AddressState>;
  zip?: Maybe<Scalars['String']>;
};

export type AdministrationRouteNode = Node & {
  __typename?: 'AdministrationRouteNode';
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Sig template for this route. This is used to generate the sig for the prescription. */
  sigTemplate: Scalars['String'];
  slug: Scalars['String'];
};

/** Mapping to algolia object keys, so the frontend can parse results as `ChoiceOption`. */
export type AlgoliaMapping = {
  __typename?: 'AlgoliaMapping';
  iconUrl?: Maybe<Scalars['String']>;
  /** Slotted for deprecation - Not relevant for this type */
  isPositive?: Maybe<Scalars['String']>;
  /** Slotted for deprecation - Not relevant for this type */
  isUnique?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

/** An enumeration. */
export enum AllergyCategory {
  Environmental = 'ENVIRONMENTAL',
  Food = 'FOOD',
  Medication = 'MEDICATION'
}

export type AllergyNode = Node & {
  __typename?: 'AllergyNode';
  category?: Maybe<AllergyCategory>;
  /** The ID of the object */
  id: Scalars['ID'];
  isApproved: Scalars['Boolean'];
  name: Scalars['String'];
  petTypes: Array<PetTypes>;
  picture?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type AllergyNodeConnection = {
  __typename?: 'AllergyNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AllergyNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `AllergyNode` and its cursor. */
export type AllergyNodeEdge = {
  __typename?: 'AllergyNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AllergyNode>;
};

/** Deprecated. Use AllergyNode instead. */
export type AllergyType = {
  __typename?: 'AllergyType';
  id: Scalars['ID'];
  isApproved: Scalars['Boolean'];
  name: Scalars['String'];
  petTypes: Array<PetTypes>;
  picture?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type AnswerInput = {
  choice?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clinicId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  dateLower?: InputMaybe<Scalars['Date']>;
  dateUpper?: InputMaybe<Scalars['Date']>;
  datetime?: InputMaybe<Scalars['DateTime']>;
  datetimeLower?: InputMaybe<Scalars['DateTime']>;
  datetimeUpper?: InputMaybe<Scalars['DateTime']>;
  decimal?: InputMaybe<Scalars['Decimal']>;
  decimalLower?: InputMaybe<Scalars['Decimal']>;
  decimalUpper?: InputMaybe<Scalars['Decimal']>;
  /** @deprecated Use `images` list input */
  image?: InputMaybe<Scalars['ImageUpload']>;
  images?: InputMaybe<Array<Scalars['ImageUpload']>>;
  instanceId?: InputMaybe<Scalars['ID']>;
  int?: InputMaybe<Scalars['Int']>;
  intLower?: InputMaybe<Scalars['Int']>;
  intUpper?: InputMaybe<Scalars['Int']>;
  isChecked?: InputMaybe<Scalars['Boolean']>;
  questionSlug: Scalars['String'];
  text?: InputMaybe<Scalars['String']>;
  type: QuestionType;
};

export type AnswerNode = {
  __typename?: 'AnswerNode';
  address?: Maybe<AddressType>;
  choice?: Maybe<Array<Maybe<Scalars['String']>>>;
  clinic?: Maybe<ClinicLocationType>;
  date?: Maybe<Scalars['Date']>;
  dateLower?: Maybe<Scalars['Date']>;
  dateUpper?: Maybe<Scalars['Date']>;
  datetime?: Maybe<Scalars['DateTime']>;
  datetimeLower?: Maybe<Scalars['DateTime']>;
  datetimeUpper?: Maybe<Scalars['DateTime']>;
  decimal?: Maybe<Scalars['Decimal']>;
  decimalLower?: Maybe<Scalars['Decimal']>;
  decimalUpper?: Maybe<Scalars['Decimal']>;
  image?: Maybe<Scalars['String']>;
  int?: Maybe<Scalars['Int']>;
  intLower?: Maybe<Scalars['Int']>;
  intUpper?: Maybe<Scalars['Int']>;
  isChecked?: Maybe<Scalars['Boolean']>;
  paymentMethod?: Maybe<PaymentMethodNode>;
  pet?: Maybe<PetType>;
  text?: Maybe<Scalars['String']>;
  /** Determines which fields are populated */
  type: QuestionType;
};

export type ArticleRecommendationNode = Node & {
  __typename?: 'ArticleRecommendationNode';
  externalId: Scalars['String'];
  externalService?: Maybe<RecommendationExternalService>;
  /** The ID of the object */
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type AttributionInput = {
  channel: Scalars['String'];
  clickId?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['JSONString']>;
};

export enum AuthFlow {
  Login = 'LOGIN',
  Signup = 'SIGNUP',
  SoftSignup = 'SOFT_SIGNUP'
}

export type AuthInstructions = {
  __typename?: 'AuthInstructions';
  authFlow: AuthFlow;
  authMethods: Array<AuthMethod>;
};

export enum AuthMethod {
  Otp = 'OTP',
  Password = 'PASSWORD'
}

export type AuthorizationCodeLoginInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
};

export type AuthorizationCodeLoginPayload = {
  __typename?: 'AuthorizationCodeLoginPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  login: LoginType;
};

export type AutoshipPlanNode = Node & {
  __typename?: 'AutoshipPlanNode';
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  interval: Scalars['Int'];
  orders?: Maybe<OrderNodeConnection>;
  period: Period;
  shippingAddress: ShippingAddressType;
  subscription: SubscriptionNode;
};


export type AutoshipPlanNodeOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
};

export type AutoshipPlanNodeConnection = {
  __typename?: 'AutoshipPlanNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AutoshipPlanNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `AutoshipPlanNode` and its cursor. */
export type AutoshipPlanNodeEdge = {
  __typename?: 'AutoshipPlanNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AutoshipPlanNode>;
};

export type BaseActionNode = ActionInterface & Node & {
  __typename?: 'BaseActionNode';
  assignedTo?: Maybe<UserType>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<ProfessionalNode>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  icon?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  important: Scalars['Boolean'];
  label: Scalars['String'];
  lastEditedBy?: Maybe<ProfessionalNode>;
  slug: Scalars['String'];
  status: ActionStatus;
  subtitle?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  viewingDraft: Scalars['Boolean'];
};

/** Inputs that mutate the billing cycle. */
export type BillingCycleInput = {
  anchorDate: Scalars['DateTime'];
};

export type BillingPlanNode = Node & {
  __typename?: 'BillingPlanNode';
  addOns?: Maybe<AddOnConnection>;
  conversationLimit?: Maybe<Scalars['Int']>;
  conversationRefreshPeriod?: Maybe<Scalars['Duration']>;
  createdAt: Scalars['DateTime'];
  dunningPlan?: Maybe<BillingPlanNode>;
  firstConversationDelay: Scalars['Duration'];
  freeTrialDuration?: Maybe<Scalars['Duration']>;
  /** The ID of the object */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  offersFreeTrial: Scalars['Boolean'];
  prices?: Maybe<PlanSubscriptionPriceConnection>;
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  videoLimit?: Maybe<Scalars['Int']>;
  videoRefreshPeriod?: Maybe<Scalars['Duration']>;
};


export type BillingPlanNodeAddOnsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type BillingPlanNodePricesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type BillingPlanNodeConnection = {
  __typename?: 'BillingPlanNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BillingPlanNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `BillingPlanNode` and its cursor. */
export type BillingPlanNodeEdge = {
  __typename?: 'BillingPlanNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<BillingPlanNode>;
};

export type BirthdayInput = {
  accuracyLevel: Scalars['String'];
  birthday: Scalars['String'];
};

export type BookRxWithPurchaseConsumableInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  conditionGroup?: InputMaybe<Scalars['ID']>;
  consumable: PurchaseConsumableInput;
  pet: Scalars['ID'];
  productFamily?: InputMaybe<Scalars['ID']>;
  startsAt: Scalars['DateTime'];
};

export type BookRxWithPurchaseConsumablePayload = {
  __typename?: 'BookRXWithPurchaseConsumablePayload';
  booking: RxBookingNode;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type BookRxVisit = {
  __typename?: 'BookRxVisit';
  conditionGroup?: Maybe<Scalars['ID']>;
  petId: Scalars['ID'];
};

export type BookingAvailability = {
  __typename?: 'BookingAvailability';
  onWaitlist?: Maybe<Scalars['Boolean']>;
  startTimes: Array<Scalars['DateTime']>;
};

/** An enumeration. */
export enum BookingIntakeStatus {
  Complete = 'COMPLETE',
  /** Booking took place or changed before completion */
  Incomplete = 'INCOMPLETE',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  NoIntakeAvailable = 'NO_INTAKE_AVAILABLE'
}

/** Interface for all Booking types. */
export type BookingInterface = {
  canCancelWithoutPenalty: Scalars['Boolean'];
  canCheckInAfter?: Maybe<Scalars['DateTime']>;
  canReschedule: Scalars['Boolean'];
  cancelledAt?: Maybe<Scalars['DateTime']>;
  confirmedAt?: Maybe<Scalars['DateTime']>;
  conversation?: Maybe<ConversationType>;
  inQueuePosition?: Maybe<Scalars['Int']>;
  inQueueWaitTime?: Maybe<Scalars['Duration']>;
  intakeStatus: BookingIntakeStatus;
  pet: PetType;
  placedAt?: Maybe<Scalars['DateTime']>;
  startsAt: Scalars['DateTime'];
  status: BookingStatus;
};

export type BookingPetActionNode = ActionInterface & Node & PetTodoInterface & {
  __typename?: 'BookingPetActionNode';
  booking: BookingInterface;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<ProfessionalNode>;
  ctaAction?: Maybe<TodoClientAction>;
  ctaText?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  extendedSubtitle?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  important: Scalars['Boolean'];
  label: Scalars['String'];
  lastEditedBy?: Maybe<ProfessionalNode>;
  pet: PetType;
  slug: Scalars['String'];
  status: ActionStatus;
  subtitle: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  viewingDraft: Scalars['Boolean'];
};

/** An enumeration. */
export enum BookingRxStatus {
  Denied = 'DENIED',
  /** The booking didn't take place (missed / cancelled) */
  NoBooking = 'NO_BOOKING',
  /** Booking is over, waiting for vet to create the rx or reject the request */
  Pending = 'PENDING',
  /** The booking hasn't finished yet */
  PendingBooking = 'PENDING_BOOKING',
  /** RX was approved and is ready for use */
  Ready = 'READY'
}

/** An enumeration. */
export enum BookingServiceType {
  Rx = 'RX'
}

/**
 * Bookings start out as needs user action if they are requiring
 * intake forms (otherwise they start as scheduled).
 */
export enum BookingStatus {
  Cancelled = 'CANCELLED',
  /** They are already in the waiting room */
  CheckedIn = 'CHECKED_IN',
  Completed = 'COMPLETED',
  /** They are in the appointment (conversation has started)  */
  InProgress = 'IN_PROGRESS',
  /** The appointment has finished and is being reviewed */
  InReview = 'IN_REVIEW',
  /** They missed the waiting room time but, it still hasn't been cancelled yet. If there is availability we will still let them check in */
  Late = 'LATE',
  /** They missed the appointment (past the end date) */
  Missed = 'MISSED',
  /** User needs to do something (like filling out the intake forms)before they will be able to check in */
  NeedsUserAction = 'NEEDS_USER_ACTION',
  Rescheduled = 'RESCHEDULED',
  Scheduled = 'SCHEDULED',
  /** They can check in (ie. waiting room is open) */
  WaitingRoomOpen = 'WAITING_ROOM_OPEN'
}

/** Booking capacity waitlist node. */
export type BookingWaitlistNode = Node & {
  __typename?: 'BookingWaitlistNode';
  expiresAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  pet: PetType;
  serviceType: BookingServiceType;
  user: UserType;
  userState: UsStates;
};

export type BooleanPetDetailNode = Node & PetDetailInterface & {
  __typename?: 'BooleanPetDetailNode';
  booleanValue?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  diagnosticQuestion: DiagnosticQuestionNode;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  meetsTarget?: Maybe<Scalars['Boolean']>;
  occurredAfter?: Maybe<Scalars['DateTime']>;
  occurredBefore?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  slug: Scalars['String'];
  staleAt?: Maybe<Scalars['DateTime']>;
  triggersInPersonVisit?: Maybe<Scalars['Boolean']>;
  triggersLiveVisit?: Maybe<Scalars['Boolean']>;
};

export type BottomSheetNode = {
  __typename?: 'BottomSheetNode';
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  instructions?: Maybe<Array<Maybe<Scalars['String']>>>;
  load: BottomSheetType;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

/** An enumeration. */
export enum BottomSheetType {
  OnLoad = 'ON_LOAD',
  OnSubmit = 'ON_SUBMIT'
}

/** An enumeration. */
export enum BreedFamilyCategory {
  ClimateAdaptation = 'CLIMATE_ADAPTATION',
  CoatBased = 'COAT_BASED',
  EnergyLevel = 'ENERGY_LEVEL',
  Other = 'OTHER',
  PurposeBased = 'PURPOSE_BASED',
  SizeBased = 'SIZE_BASED',
  SpecializedPhysicalTraits = 'SPECIALIZED_PHYSICAL_TRAITS'
}

export type BreedFamilyNode = Node & {
  __typename?: 'BreedFamilyNode';
  category: BreedFamilyCategory;
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
  petType: PetTypes;
};

export type BreedType = {
  __typename?: 'BreedType';
  breedFamilies?: Maybe<Array<BreedFamilyNode>>;
  efMarketingImage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  petType: PetTypes;
};

export type BundleCancellationPreview = {
  __typename?: 'BundleCancellationPreview';
  effectiveCancellationDate: Scalars['DateTime'];
  /** Refund amount for immediate cancellation. $0 for end-of-cycle. */
  refund?: Maybe<Scalars['Decimal']>;
  subscribedFeatures: Array<SubscribedFeatureInterface>;
};

export type BuyProduct = {
  __typename?: 'BuyProduct';
  productId: Scalars['ID'];
};

export type CancelAutoshipPlanInput = {
  autoshipPlanId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CancelAutoshipPlanPayload = {
  __typename?: 'CancelAutoshipPlanPayload';
  autoshipPlan?: Maybe<AutoshipPlanNode>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CancelBookingInput = {
  booking: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CancelBookingPayload = {
  __typename?: 'CancelBookingPayload';
  booking: BookingInterface;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CancelBundleInput = {
  bundle: Scalars['Slug'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type CancelBundlePayload = {
  __typename?: 'CancelBundlePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  subscribedFeatures: Array<SubscribedFeatureInterface>;
};

export type CancelClaimRequestInput = {
  claimRequest: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CancelClaimRequestPayload = {
  __typename?: 'CancelClaimRequestPayload';
  claimRequest?: Maybe<ClaimRequestNode>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CancelFeatureInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  feature: Scalars['Slug'];
  reason?: InputMaybe<Scalars['String']>;
};

export type CancelFeaturePayload = {
  __typename?: 'CancelFeaturePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  subscribedFeature: SubscribedFeatureInterface;
};

export type CancellationPreview = {
  __typename?: 'CancellationPreview';
  effectiveCancellationDate: Scalars['DateTime'];
  /** Refund amount for immediate cancellation. $0 for end-of-cycle. */
  refund?: Maybe<Scalars['Decimal']>;
  subscribedFeature: SubscribedFeatureInterface;
};

export type CardPaymentMethod = Node & PaymentMethodInterface & {
  __typename?: 'CardPaymentMethod';
  brand?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  expiration?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  lastFour?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user: UserType;
};

/**
 * This is an abridged version of the `CarePlanActionType` except these are always top level
 * categories so subcategory fields have been stripped out to avoid confusion.
 */
export type CarePlanActionCategoryType = {
  __typename?: 'CarePlanActionCategoryType';
  archived: Scalars['Boolean'];
  category: Scalars['String'];
  categorySlug: Scalars['String'];
  icon?: Maybe<Scalars['String']>;
  isLegacy: Scalars['Boolean'];
  label: Scalars['String'];
  oneActiveActionPerPet: Scalars['Boolean'];
  slug: Scalars['Slug'];
};

export type CarePlanActionComplianceStatusRecordNode = Node & {
  __typename?: 'CarePlanActionComplianceStatusRecordNode';
  complianceStatus: ComplianceLevel;
  createdAt: Scalars['DateTime'];
  feedback?: Maybe<CarePlanActionFeedbackNode>;
  /** The ID of the object */
  id: Scalars['ID'];
};

export type CarePlanActionComplianceStatusRecordNodeConnection = {
  __typename?: 'CarePlanActionComplianceStatusRecordNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CarePlanActionComplianceStatusRecordNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `CarePlanActionComplianceStatusRecordNode` and its cursor. */
export type CarePlanActionComplianceStatusRecordNodeEdge = {
  __typename?: 'CarePlanActionComplianceStatusRecordNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CarePlanActionComplianceStatusRecordNode>;
};

/** An enumeration. */
export enum CarePlanActionDurationUnit {
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Second = 'SECOND'
}

export type CarePlanActionFeedbackNode = Node & {
  __typename?: 'CarePlanActionFeedbackNode';
  action: GenericCarePlanActionNode;
  createdAt: Scalars['DateTime'];
  feedbackType: CarePlanActionFeedbackType;
  /** The ID of the object */
  id: Scalars['ID'];
  notes: Scalars['String'];
};

export type CarePlanActionFeedbackNodeConnection = {
  __typename?: 'CarePlanActionFeedbackNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CarePlanActionFeedbackNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `CarePlanActionFeedbackNode` and its cursor. */
export type CarePlanActionFeedbackNodeEdge = {
  __typename?: 'CarePlanActionFeedbackNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CarePlanActionFeedbackNode>;
};

/** An enumeration. */
export enum CarePlanActionFeedbackType {
  NotHelpful = 'NOT_HELPFUL',
  Other = 'OTHER',
  SomewhatHelpful = 'SOMEWHAT_HELPFUL',
  TooBusyThisTime = 'TOO_BUSY_THIS_TIME'
}

export type CarePlanActionInterface = {
  actionType: CarePlanActionType;
  carePlan: CarePlanNode;
  complianceStatus?: Maybe<ComplianceLevel>;
  complianceStatusRecords?: Maybe<CarePlanActionComplianceStatusRecordNodeConnection>;
  createdBy?: Maybe<ProfessionalNode>;
  lastEditedBy?: Maybe<ProfessionalNode>;
  notes: Scalars['String'];
  reasoningContent: Scalars['String'];
  reasoningTitle: Scalars['String'];
  sortingWeight: Scalars['Int'];
};


export type CarePlanActionInterfaceComplianceStatusRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type CarePlanActionNode = GenericCarePlanActionNode | InPersonVisitActionNode | RxVirtualVisitActionNode | RecommendationCarePlanActionNode | RelatedResourceCarePlanActionNode | ScheduleAppointmentCarePlanActionNode | VirtualVisitActionNode;

/** An enumeration. */
export enum CarePlanActionPeriod {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

/** An enumeration. */
export enum CarePlanActionQuantityUnit {
  Capsule = 'CAPSULE',
  Chewable = 'CHEWABLE',
  Dose = 'DOSE',
  Drop = 'DROP',
  Hour = 'HOUR',
  Inch = 'INCH',
  Minute = 'MINUTE',
  Ml = 'ML',
  Pill = 'PILL',
  Second = 'SECOND',
  Serving = 'SERVING',
  Tablet = 'TABLET',
  Time = 'TIME'
}

export type CarePlanActionType = {
  __typename?: 'CarePlanActionType';
  allowedQuantityUnits: Array<Maybe<CarePlanActionQuantityUnit>>;
  archived: Scalars['Boolean'];
  category: Scalars['String'];
  categorySlug: Scalars['String'];
  icon?: Maybe<Scalars['String']>;
  isLegacy: Scalars['Boolean'];
  label: Scalars['String'];
  oneActiveActionPerPet: Scalars['Boolean'];
  slug: Scalars['Slug'];
  subCategory: Scalars['String'];
  subCategorySlug: Scalars['String'];
};

export type CarePlanNode = Node & {
  __typename?: 'CarePlanNode';
  actions?: Maybe<Array<Maybe<CarePlanActionNode>>>;
  conversation: ConversationType;
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  nextPublishAt?: Maybe<Scalars['DateTime']>;
  pet: PetType;
  prescriptions: Array<PrescriptionNode>;
  /** @deprecated Use next_publish_at instead */
  publishScheduledAt?: Maybe<Scalars['DateTime']>;
  soapAssessment: Scalars['String'];
  soapPlan: Scalars['String'];
  status: CarePlanStatus;
  updatedAt: Scalars['DateTime'];
  viewedAt?: Maybe<Scalars['DateTime']>;
  writtenBy?: Maybe<ConversationProfessionalType>;
};


export type CarePlanNodeActionsArgs = {
  showDrafts?: InputMaybe<Scalars['Boolean']>;
};

export type CarePlanNodeConnection = {
  __typename?: 'CarePlanNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CarePlanNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `CarePlanNode` and its cursor. */
export type CarePlanNodeEdge = {
  __typename?: 'CarePlanNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CarePlanNode>;
};

/** An enumeration. */
export enum CarePlanStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

/** Deprecated - here for backwards compatibility with product_v2 */
export type CartLineItem = {
  __typename?: 'CartLineItem';
  discount: Scalars['Decimal'];
  id: Scalars['ID'];
  interval?: Maybe<Scalars['Int']>;
  period?: Maybe<Period>;
  productVariant: ProductVariantNode;
  quantity: Scalars['Int'];
  subtotal: Scalars['Decimal'];
  tax: Scalars['Decimal'];
  total: Scalars['Decimal'];
};

/** Deprecated - here for backwards compatability with product_v2 */
export type CartNode = Node & {
  __typename?: 'CartNode';
  buyer: MemberType;
  /** The ID of the object */
  id: Scalars['ID'];
  lineItems: Array<CartLineItem>;
  subtotal: Scalars['Decimal'];
  total: Scalars['Decimal'];
  totalDiscount?: Maybe<Scalars['Decimal']>;
  totalTax: Scalars['Decimal'];
};

export type CartNodeV2 = Node & {
  __typename?: 'CartNodeV2';
  discount: Scalars['Decimal'];
  /** The ID of the object */
  id: Scalars['ID'];
  interval?: Maybe<Scalars['Int']>;
  lineItems: OrderLineNodeConnection;
  order?: Maybe<OrderV2Node>;
  period?: Maybe<Period>;
  shipping: Scalars['Decimal'];
  shopCart: Scalars['Boolean'];
  subtotal: Scalars['Decimal'];
  tax: Scalars['Decimal'];
  total: Scalars['Decimal'];
  user: UserType;
};


export type CartNodeV2LineItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type CategoryType = {
  __typename?: 'CategoryType';
  backgroundColor: Scalars['String'];
  color: Scalars['String'];
  iconUrl: Scalars['String'];
  name: Scalars['String'];
};

export type ChangeCurrentRoleInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  newRole: Roles;
};

export type ChangeCurrentRolePayload = {
  __typename?: 'ChangeCurrentRolePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  currentRole: Roles;
};

export type ChangePassword = {
  __typename?: 'ChangePassword';
  success?: Maybe<Scalars['Boolean']>;
};

export type ChatChannelType = {
  __typename?: 'ChatChannelType';
  id: Scalars['ID'];
  twilioServiceSid: Scalars['String'];
  twilioSid: Scalars['String'];
};

export type CheckInToBookingInput = {
  booking: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  requesterVideoAspectRatio?: InputMaybe<Scalars['String']>;
};

export type CheckInToBookingPayload = {
  __typename?: 'CheckInToBookingPayload';
  booking: BookingInterface;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type Checkout = {
  __typename?: 'Checkout';
  order: OrderNode;
  orderV2: OrderV2Node;
};

export type CheckoutInput = {
  cart: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<Scalars['ID']>;
};

export type CheckoutLineItem = EmergencyProtectionQuoteLine | MembershipQuoteLine | PrescriptionQuoteLine;

export type ChoiceAlgoliaNode = {
  __typename?: 'ChoiceAlgoliaNode';
  facetFilters?: Maybe<Array<Array<Scalars['String']>>>;
  iconUrl?: Maybe<Scalars['String']>;
  /** Algolia index to fetch objects from */
  index: Scalars['String'];
  /** Slotted for deprecation - Use fields directly on type */
  mapping: AlgoliaMapping;
  pluralModelLabel: Scalars['String'];
  searchPlaceholder: Scalars['String'];
  singularModelLabel: Scalars['String'];
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type ChoicePetDetailNode = Node & PetDetailInterface & {
  __typename?: 'ChoicePetDetailNode';
  choiceValue?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt: Scalars['DateTime'];
  diagnosticQuestion: DiagnosticQuestionNode;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  meetsTarget?: Maybe<Scalars['Boolean']>;
  occurredAfter?: Maybe<Scalars['DateTime']>;
  occurredBefore?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  slug: Scalars['String'];
  staleAt?: Maybe<Scalars['DateTime']>;
  triggersInPersonVisit?: Maybe<Scalars['Boolean']>;
  triggersLiveVisit?: Maybe<Scalars['Boolean']>;
};

export type ChoiceStaticOption = {
  __typename?: 'ChoiceStaticOption';
  iconUrl?: Maybe<Scalars['String']>;
  isPositive?: Maybe<Scalars['Boolean']>;
  isUnique?: Maybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ChoiceStaticOptionsNode = {
  __typename?: 'ChoiceStaticOptionsNode';
  /** List of available options */
  staticOptions: Array<Maybe<ChoiceStaticOption>>;
};

export type ChoiceUnion = ChoiceAlgoliaNode | ChoiceStaticOptionsNode | ImageStaticOptionsNode;

/** An enumeration. */
export enum ClaimAttachmentAttachmentType {
  Approval = 'APPROVAL',
  Invoice = 'INVOICE',
  MedicalRecord = 'MEDICAL_RECORD',
  Other = 'OTHER',
  Rejection = 'REJECTION'
}

export type ClaimAttachmentNode = Node & {
  __typename?: 'ClaimAttachmentNode';
  attachmentType: ClaimAttachmentAttachmentType;
  clinicLocation?: Maybe<ClinicLocationType>;
  contentType: Scalars['String'];
  file: Scalars['String'];
  filename: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
  rejectionReasonMessages?: Maybe<Array<Maybe<Scalars['String']>>>;
  size: Scalars['Int'];
  status: ClaimAttachmentStatus;
};

export type ClaimAttachmentNodeConnection = {
  __typename?: 'ClaimAttachmentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClaimAttachmentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `ClaimAttachmentNode` and its cursor. */
export type ClaimAttachmentNodeEdge = {
  __typename?: 'ClaimAttachmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ClaimAttachmentNode>;
};

/** An enumeration. */
export enum ClaimAttachmentStatus {
  Approved = 'APPROVED',
  Attached = 'ATTACHED',
  Rejected = 'REJECTED'
}

/** An enumeration. */
export enum ClaimCategories {
  AccidentalInjury = 'ACCIDENTAL_INJURY',
  Illness = 'ILLNESS'
}

export type ClaimRequestNode = Node & {
  __typename?: 'ClaimRequestNode';
  adjustedAmount?: Maybe<Scalars['Decimal']>;
  allowsCustomCheckPayoutAddress: Scalars['Boolean'];
  attachments: ClaimAttachmentNodeConnection;
  category?: Maybe<ClaimCategories>;
  claimedAmount?: Maybe<Scalars['Decimal']>;
  clinicLocations: Array<ClinicLocationType>;
  conversation?: Maybe<ConversationType>;
  createdAt: Scalars['DateTime'];
  date?: Maybe<Scalars['Date']>;
  description: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  insurancePolicy?: Maybe<InsurancePolicyNode>;
  pet?: Maybe<PetType>;
  reasonForNoConversation?: Maybe<ClaimRequestReasonForNoConversation>;
  rejectionReasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  requestedActionDetails?: Maybe<Scalars['String']>;
  status: ClaimRequestStatus;
  submittedAt?: Maybe<Scalars['DateTime']>;
  userAcknowledgedRejection?: Maybe<Scalars['Date']>;
};


export type ClaimRequestNodeAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ClaimRequestNodeConnection = {
  __typename?: 'ClaimRequestNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClaimRequestNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `ClaimRequestNode` and its cursor. */
export type ClaimRequestNodeEdge = {
  __typename?: 'ClaimRequestNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ClaimRequestNode>;
};

/**
 * This is identical to ReasonsForNoConversation but needs to be duplicated for
 * backwards compatibility with older versions of the app.
 */
export enum ClaimRequestReasonForNoConversation {
  ConditionWorsened = 'CONDITION_WORSENED',
  MemberNotPresent = 'MEMBER_NOT_PRESENT',
  Other = 'OTHER',
  SevereAccident = 'SEVERE_ACCIDENT',
  Unaware = 'UNAWARE'
}

/** An enumeration. */
export enum ClaimRequestStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Initiated = 'INITIATED',
  InReview = 'IN_REVIEW',
  NeedsUserAction = 'NEEDS_USER_ACTION',
  PaymentFailed = 'PAYMENT_FAILED',
  PaymentScheduled = 'PAYMENT_SCHEDULED',
  PaymentSent = 'PAYMENT_SENT',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED',
  Unclaimed = 'UNCLAIMED'
}

export type ClientUploadNode = Node & {
  __typename?: 'ClientUploadNode';
  contentType: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  filename: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  purpose: ClientUploadPurpose;
  referenceKey: Scalars['String'];
  size: Scalars['BigInt'];
  uploadedAt?: Maybe<Scalars['DateTime']>;
};

/** An enumeration. */
export enum ClientUploadPurpose {
  AiTriageMedia = 'AI_TRIAGE_MEDIA'
}

export type ClinicLocationNode = Node & {
  __typename?: 'ClinicLocationNode';
  claimed: Scalars['Boolean'];
  emergency: Scalars['Boolean'];
  fullAddress: Scalars['String'];
  googlePlaceId?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ClinicLocationNodeConnection = {
  __typename?: 'ClinicLocationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClinicLocationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `ClinicLocationNode` and its cursor. */
export type ClinicLocationNodeEdge = {
  __typename?: 'ClinicLocationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ClinicLocationNode>;
};

export type ClinicLocationRatingType = {
  __typename?: 'ClinicLocationRatingType';
  clinicLocation: ClinicLocationType;
  id: Scalars['ID'];
  rating: Scalars['Int'];
  review?: Maybe<Scalars['String']>;
};

/** To be deprecated in favor of ClinicLocationNode */
export type ClinicLocationType = {
  __typename?: 'ClinicLocationType';
  claimed: Scalars['Boolean'];
  emergency: Scalars['Boolean'];
  fullAddress: Scalars['String'];
  googlePlaceId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Deprecated - replaced by ProductCategory */
export type CollectionNode = Node & {
  __typename?: 'CollectionNode';
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
  products: Array<ProductNode>;
};

export type CollectionNodeConnection = {
  __typename?: 'CollectionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CollectionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `CollectionNode` and its cursor. */
export type CollectionNodeEdge = {
  __typename?: 'CollectionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CollectionNode>;
};

export type CompleteActionInput = {
  action: Scalars['ID'];
  cancel?: InputMaybe<Scalars['Boolean']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CompleteActionPayload = {
  __typename?: 'CompleteActionPayload';
  action?: Maybe<ActionNode>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CompleteClientUploadInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type CompleteClientUploadPayload = {
  __typename?: 'CompleteClientUploadPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  upload: ClientUploadNode;
};

/** An enumeration. */
export enum ComplianceLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type ConditionDrugInteractionNode = Node & {
  __typename?: 'ConditionDrugInteractionNode';
  condition: ConditionNode;
  /** The ID of the object */
  id: Scalars['ID'];
  interactionType: ConditionDrugInteractionType;
  medication: MedicationNode;
};

export type ConditionDrugInteractionNodeConnection = {
  __typename?: 'ConditionDrugInteractionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ConditionDrugInteractionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `ConditionDrugInteractionNode` and its cursor. */
export type ConditionDrugInteractionNodeEdge = {
  __typename?: 'ConditionDrugInteractionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ConditionDrugInteractionNode>;
};

/** An enumeration. */
export enum ConditionDrugInteractionType {
  Contraindication = 'CONTRAINDICATION',
  /** FDA Approved Treatment */
  Fda = 'FDA',
  /** Non-FDA Approved Treatment */
  NonFda = 'NON_FDA'
}

export type ConditionGroupNode = Node & {
  __typename?: 'ConditionGroupNode';
  backgroundColor: Scalars['String'];
  color: Scalars['String'];
  iconUrl: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
  pawpRxEligible: Scalars['Boolean'];
  slug: Scalars['String'];
};

export type ConditionGroupNodeConnection = {
  __typename?: 'ConditionGroupNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ConditionGroupNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `ConditionGroupNode` and its cursor. */
export type ConditionGroupNodeEdge = {
  __typename?: 'ConditionGroupNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ConditionGroupNode>;
};

export type ConditionNode = Node & {
  __typename?: 'ConditionNode';
  drugInteractions: ConditionDrugInteractionNodeConnection;
  groups: ConditionGroupNodeConnection;
  /** The ID of the object */
  id: Scalars['ID'];
  isApproved: Scalars['Boolean'];
  name: Scalars['String'];
  petTypes: Array<PetTypes>;
  picture?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};


export type ConditionNodeDrugInteractionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  interactionType?: InputMaybe<ConditionDrugInteractionType>;
  interactionType_In?: InputMaybe<Array<InputMaybe<ConditionDrugInteractionType>>>;
  last?: InputMaybe<Scalars['Int']>;
  medication?: InputMaybe<Scalars['ID']>;
  medication_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ConditionNodeGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ConditionNodeConnection = {
  __typename?: 'ConditionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ConditionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `ConditionNode` and its cursor. */
export type ConditionNodeEdge = {
  __typename?: 'ConditionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ConditionNode>;
};

/** Deprecated. Use ConditionNode instead. */
export type ConditionType = {
  __typename?: 'ConditionType';
  drugInteractions: ConditionDrugInteractionNodeConnection;
  id: Scalars['ID'];
  isApproved: Scalars['Boolean'];
  name: Scalars['String'];
  petTypes: Array<PetTypes>;
  picture?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};


/** Deprecated. Use ConditionNode instead. */
export type ConditionTypeDrugInteractionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  interactionType?: InputMaybe<ConditionDrugInteractionType>;
  interactionType_In?: InputMaybe<Array<InputMaybe<ConditionDrugInteractionType>>>;
  last?: InputMaybe<Scalars['Int']>;
  medication?: InputMaybe<Scalars['ID']>;
  medication_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ConfigureFeaturesInput = {
  bundles?: InputMaybe<Array<ModifyBundleInput>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  modifyEmergencyProtection?: InputMaybe<ModifyEmergencyProtectionInput>;
  modifyMembership?: InputMaybe<ModifyMembershipInput>;
  purchaseConsumables?: InputMaybe<Array<PurchaseConsumableInput>>;
};

export type ConfigureFeaturesPayload = {
  __typename?: 'ConfigureFeaturesPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  featureAccess: FeatureAccess;
};

export type ConfigureMembershipInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  newPaymentMethod?: InputMaybe<CreateUserPaymentMethodInput>;
  params: QuoteInput;
};

export type ConfigureMembershipPayload = {
  __typename?: 'ConfigureMembershipPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  userPlan: UserPlanNode;
};

export type ConfirmBookingInput = {
  booking: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type ConfirmBookingPayload = {
  __typename?: 'ConfirmBookingPayload';
  booking: BookingInterface;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ConnectUserToPartnerInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  partnerSlug: Scalars['Slug'];
};

/**
 * Connects a guest to a partner if it has not been already connected
 * with another partner
 */
export type ConnectUserToPartnerPayload = {
  __typename?: 'ConnectUserToPartnerPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  userPartner: UserPartnerNode;
};

/** Categories of user consent types */
export enum ConsentCategory {
  AiUsage = 'AI_USAGE',
  DataSharing = 'DATA_SHARING',
  InsuranceDataSharing = 'INSURANCE_DATA_SHARING',
  Marketing = 'MARKETING',
  PrivacyPolicy = 'PRIVACY_POLICY',
  TermsOfService = 'TERMS_OF_SERVICE'
}

export type ConsentTypeNode = Node & {
  __typename?: 'ConsentTypeNode';
  createdAt: Scalars['DateTime'];
  /** Optional external links related to this consent type */
  externalUrls: Array<Scalars['String']>;
  /** Optional files (e.g., privacy policy documents) associated with this consent type */
  files: GenericFileNodeConnection;
  /** The ID of the object */
  id: Scalars['ID'];
  /** Client-friendly name of the consent. (user-facing) */
  name: Scalars['String'];
  slug: Scalars['String'];
  /** Configurable version identifier (e.g., 'v1.0', '2023-q1') used in slug generation */
  versionId: Scalars['String'];
};


export type ConsentTypeNodeFilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ConsentTypeNodeConnection = {
  __typename?: 'ConsentTypeNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ConsentTypeNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `ConsentTypeNode` and its cursor. */
export type ConsentTypeNodeEdge = {
  __typename?: 'ConsentTypeNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ConsentTypeNode>;
};

export type ConsumableFeatureInterface = {
  purchaseOptions: Array<ConsumableFeatureTier>;
};


export type ConsumableFeatureInterfacePurchaseOptionsArgs = {
  maxQuantity?: InputMaybe<Scalars['Int']>;
  minQuantity?: InputMaybe<Scalars['Int']>;
};

export type ConsumableFeaturePrice = Node & {
  __typename?: 'ConsumableFeaturePrice';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** The ID of the object */
  id: Scalars['ID'];
  minimumMembershipRank: Scalars['Int'];
  price: Scalars['Decimal'];
};

export type ConsumableFeatureTier = Node & {
  __typename?: 'ConsumableFeatureTier';
  description: Scalars['String'];
  featurePrices: Array<ConsumableFeaturePrice>;
  id: Scalars['ID'];
  name: Scalars['String'];
  price?: Maybe<Scalars['Decimal']>;
  purchasedType: Scalars['String'];
  quantity: Scalars['Int'];
  slug: Scalars['Slug'];
  useByDuration?: Maybe<Scalars['Duration']>;
};

export type ConsumableQuoteLineInterface = {
  currentQuantity: Scalars['Int'];
  feature: ConsumableFeatureTier;
  newQuantity: Scalars['Int'];
  useNewItemsBy?: Maybe<Scalars['Date']>;
};

export type ContextualAddOn = {
  __typename?: 'ContextualAddOn';
  addOn: AddOnNode;
  pet?: Maybe<PetType>;
};

export type ConversationActionInterface = {
  conversation: ConversationType;
};

/** An enumeration. */
export enum ConversationEndedByType {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Professional = 'PROFESSIONAL',
  System = 'SYSTEM'
}

export type ConversationFeedbackType = {
  __typename?: 'ConversationFeedbackType';
  audioVisualRating?: Maybe<Scalars['Int']>;
  conversationId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<ConversationUserType>;
  createdById?: Maybe<Scalars['String']>;
  feedbackComments?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  otherParticipantRating?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type ConversationPaginatedType = {
  __typename?: 'ConversationPaginatedType';
  conversations: Array<ConversationType>;
  count: Scalars['Int'];
  hasNext: Scalars['Boolean'];
  pages: Scalars['Int'];
};

export type ConversationProfessionalHistoryType = {
  __typename?: 'ConversationProfessionalHistoryType';
  joinedAt: Scalars['DateTime'];
  leftAt?: Maybe<Scalars['DateTime']>;
  professional?: Maybe<ConversationProfessionalType>;
};

/**
 * Deprecated type - use `marketplace.graphql.types.ProfessionalNode` instead
 * This one is kept in telemedicine code for ios/android use
 */
export type ConversationProfessionalType = {
  __typename?: 'ConversationProfessionalType';
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isSystem: Scalars['Boolean'];
  isVideoChatAvailable?: Maybe<Scalars['Boolean']>;
  jobTitle: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  professionalName?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum ConversationRequestLevel {
  AsyncStandard = 'ASYNC_STANDARD',
  Emergency = 'EMERGENCY',
  Standard = 'STANDARD',
  Triage = 'TRIAGE'
}

/** An enumeration. */
export enum ConversationRequestSource {
  AiTriage = 'AI_TRIAGE',
  Booking = 'BOOKING',
  InitialAssessment = 'INITIAL_ASSESSMENT',
  LifestageTransition = 'LIFESTAGE_TRANSITION',
  PeriodicCheckin = 'PERIODIC_CHECKIN',
  PetInsight = 'PET_INSIGHT'
}

/** An enumeration. */
export enum ConversationSeverityLevel {
  Emergency = 'EMERGENCY',
  Minor = 'MINOR',
  NonUrgent = 'NON_URGENT',
  Resuscitation = 'RESUSCITATION',
  Serious = 'SERIOUS',
  Wellness = 'WELLNESS'
}

export type ConversationTopicType = {
  __typename?: 'ConversationTopicType';
  category: Scalars['String'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identifier: Scalars['String'];
  name: Scalars['String'];
  rank: Scalars['Int'];
  type: Scalars['String'];
};

export type ConversationType = VisitInterface & {
  __typename?: 'ConversationType';
  actions?: Maybe<Array<Maybe<GenericCarePlanActionNode>>>;
  booking?: Maybe<BookingInterface>;
  canStartVideo: Scalars['Boolean'];
  carePlans?: Maybe<Array<CarePlanNode>>;
  chatChannel?: Maybe<ChatChannelType>;
  createdAt: Scalars['DateTime'];
  date: Scalars['DateTime'];
  endedByType?: Maybe<ConversationEndedByType>;
  feedback?: Maybe<ConversationFeedbackType>;
  hasTranscript: Scalars['Boolean'];
  id: Scalars['ID'];
  medicalRecords: MedicalRecordNodeConnection;
  memberLocation?: Maybe<AddressType>;
  messages?: Maybe<MessagePaginatedType>;
  nextSteps: Array<PetTodoInterface>;
  pets?: Maybe<Array<PetType>>;
  platform: Scalars['String'];
  /** @deprecated Use top level `recommendedProducts` instead */
  productRecommendations?: Maybe<Array<Maybe<ProductRecommendationNodeV2>>>;
  professional?: Maybe<ConversationProfessionalType>;
  professionalHistory?: Maybe<Array<ConversationProfessionalHistoryType>>;
  recommendations?: Maybe<Array<Maybe<RecommendationNode>>>;
  requestLevel?: Maybe<Scalars['String']>;
  requestSource?: Maybe<ConversationRequestSource>;
  severity?: Maybe<ConversationSeverityLevel>;
  status: Scalars['String'];
  summary?: Maybe<Scalars['GenericScalar']>;
  symptomCheckerResult?: Maybe<PetSymptomCheckerResultType>;
  title: Scalars['String'];
  topic?: Maybe<ConversationTopicType>;
  topicName: Scalars['String'];
  user?: Maybe<ConversationUserType>;
  userFacingSummary?: Maybe<Scalars['String']>;
  userReviewedAt?: Maybe<Scalars['DateTime']>;
  videoRoom?: Maybe<VideoRoomType>;
  waitingRoomOfferCopy: Scalars['String'];
};


export type ConversationTypeActionsArgs = {
  excludedCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ConversationTypeMedicalRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ConversationTypeMessagesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  reversed?: InputMaybe<Scalars['Boolean']>;
  size?: InputMaybe<Scalars['Int']>;
};


export type ConversationTypeProductRecommendationsArgs = {
  generatedByAgent?: InputMaybe<Scalars['Boolean']>;
  productCategorySlugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ConversationUserType = {
  __typename?: 'ConversationUserType';
  conversationCount?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  emergencyFundsUsed?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAda: Scalars['Boolean'];
  isVcprAddOnSupported?: Maybe<Scalars['Boolean']>;
  isVip: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  location?: Maybe<AddressType>;
  media?: Maybe<MessageAttachmentPaginatedType>;
  partner?: Maybe<PartnerNode>;
  pets?: Maybe<Array<PetType>>;
  primaryClinic?: Maybe<ClinicLocationType>;
  userPlan?: Maybe<UserPlanNode>;
};


export type ConversationUserTypeMediaArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pet?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
};

export type CoreClinicMeta = {
  __typename?: 'CoreClinicMeta';
  google?: Maybe<CoreClinicMetaGoogle>;
};

export type CoreClinicMetaGoogle = {
  __typename?: 'CoreClinicMetaGoogle';
  businessStatus?: Maybe<Scalars['String']>;
  placeId: Scalars['String'];
  rating?: Maybe<Scalars['Decimal']>;
  userRatingsTotal?: Maybe<Scalars['Int']>;
  vicinity?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type CoreClinicNode = Node & {
  __typename?: 'CoreClinicNode';
  address?: Maybe<AddressType>;
  /** The ID of the object */
  id: Scalars['ID'];
  meta: CoreClinicMeta;
  name: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
};

export type CoreClinicNodeConnection = {
  __typename?: 'CoreClinicNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CoreClinicNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `CoreClinicNode` and its cursor. */
export type CoreClinicNodeEdge = {
  __typename?: 'CoreClinicNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CoreClinicNode>;
};

export type CoreIngredientLineNode = Node & {
  __typename?: 'CoreIngredientLineNode';
  /** The ID of the object */
  id: Scalars['ID'];
  ingredient: CoreIngredientNode;
  medication: CoreMedicationNode;
  quantityType: QuantityType;
  quantityValue: Scalars['Decimal'];
  rank: Scalars['Int'];
};

export type CoreIngredientLineNodeConnection = {
  __typename?: 'CoreIngredientLineNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CoreIngredientLineNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CoreIngredientLineNode` and its cursor. */
export type CoreIngredientLineNodeEdge = {
  __typename?: 'CoreIngredientLineNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CoreIngredientLineNode>;
};

export type CoreIngredientNode = Node & {
  __typename?: 'CoreIngredientNode';
  benefit?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  /** Actual medication name; not the brand name. */
  name: Scalars['String'];
};

/** Stub for product v2 compat */
export type CoreMedicationNode = Node & {
  __typename?: 'CoreMedicationNode';
  category?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  ingredientLineItems?: Maybe<CoreIngredientLineNodeConnection>;
  isApproved: Scalars['Boolean'];
  isGeneral?: Maybe<Scalars['Boolean']>;
  isPrescriptionRequired?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  usageDirections: Scalars['String'];
};


/** Stub for product v2 compat */
export type CoreMedicationNodeIngredientLineItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type CoreMedicationNodeConnection = {
  __typename?: 'CoreMedicationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CoreMedicationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `CoreMedicationNode` and its cursor. */
export type CoreMedicationNodeEdge = {
  __typename?: 'CoreMedicationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CoreMedicationNode>;
};

/** Here for backwards compat with product v2 */
export type CorePrescriptionNode = Node & {
  __typename?: 'CorePrescriptionNode';
  clinic: CoreClinicNode;
  /** The ID of the object */
  id: Scalars['ID'];
  pet: PetType;
  processedAt?: Maybe<Scalars['DateTime']>;
  processedBy?: Maybe<ProfessionalNode>;
};

/** Stub for product v2 compat */
export type CoreProductDetailsNode = CoreMedicationNode;

/** Deprecated */
export type CoreProductMeta = {
  __typename?: 'CoreProductMeta';
  externalUrl?: Maybe<Scalars['String']>;
};

export type CoreReviveAddOnInput = {
  addOnStatus: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CoreReviveAddOnPayload = {
  __typename?: 'CoreReviveAddOnPayload';
  addOn: AddOnStatusNode;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CoreReviveUserPlanInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  newPaymentMethod?: InputMaybe<CreateUserPaymentMethodInput>;
};

export type CoreReviveUserPlanPayload = {
  __typename?: 'CoreReviveUserPlanPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  user: UserType;
  userPlan: UserPlanNode;
};

/** An enumeration. */
export enum CouponDuration {
  Forever = 'FOREVER',
  Once = 'ONCE',
  Repeating = 'REPEATING'
}

export type CouponNode = Node & {
  __typename?: 'CouponNode';
  createdAt: Scalars['DateTime'];
  durationInMonths?: Maybe<Scalars['Int']>;
  durationType: CouponDuration;
  flatDiscount?: Maybe<Scalars['Decimal']>;
  /** The ID of the object */
  id: Scalars['ID'];
  maxRedemptions?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  percentDiscount?: Maybe<Scalars['Decimal']>;
  processorId: Scalars['String'];
  redeemBy?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type CouponNodeConnection = {
  __typename?: 'CouponNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CouponNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `CouponNode` and its cursor. */
export type CouponNodeEdge = {
  __typename?: 'CouponNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CouponNode>;
};

export type CreateAssessmentResultFollowUpInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pet: Scalars['ID'];
};

export type CreateAssessmentResultFollowUpPayload = {
  __typename?: 'CreateAssessmentResultFollowUpPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  response: NextResponse;
};

export type CreateCheckInResultFollowUpInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pet: Scalars['ID'];
};

export type CreateCheckInResultFollowUpPayload = {
  __typename?: 'CreateCheckInResultFollowUpPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  response: NextResponse;
};

export type CreateClaimRequestInput = {
  category?: InputMaybe<ClaimCategories>;
  claimedAmount?: InputMaybe<Scalars['Decimal']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  clinicLocations?: InputMaybe<Array<Scalars['ID']>>;
  conversation?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  insurancePolicy?: InputMaybe<Scalars['ID']>;
  pet?: InputMaybe<Scalars['ID']>;
  reasonForNoConversation?: InputMaybe<ReasonsForNoConversation>;
};

export type CreateClaimRequestPayload = {
  __typename?: 'CreateClaimRequestPayload';
  claimRequest?: Maybe<ClaimRequestNode>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateClinicLocationInput = {
  addressParts?: InputMaybe<AddressInput>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  googlePlace?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type CreateClinicLocationPayload = {
  __typename?: 'CreateClinicLocationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  clinicLocation?: Maybe<ClinicLocationType>;
};

export type CreateConversationFromSymptomCheckerResult = {
  __typename?: 'CreateConversationFromSymptomCheckerResult';
  conversation: ConversationType;
  twilioAccessToken: Scalars['String'];
};

export type CreateConversationV2 = {
  __typename?: 'CreateConversationV2';
  conversation: ConversationType;
  twilioAccessToken: Scalars['String'];
};

export type CreateInitialAssessmentFromPetInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pet: Scalars['ID'];
};

export type CreateInitialAssessmentFromPetPayload = {
  __typename?: 'CreateInitialAssessmentFromPetPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  response: NextResponse;
};

export type CreateInsightVisitFollowUpInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  petInsight: Scalars['ID'];
};

export type CreateInsightVisitFollowUpPayload = {
  __typename?: 'CreateInsightVisitFollowUpPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  response: NextResponse;
};

export type CreateLoginAuthorizationCodeInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CreateLoginAuthorizationCodePayload = {
  __typename?: 'CreateLoginAuthorizationCodePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
};

export type CreatePet = {
  __typename?: 'CreatePet';
  pet?: Maybe<PetType>;
};

export type CreateRxBookingInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  conditionGroup?: InputMaybe<Scalars['ID']>;
  hold?: InputMaybe<Scalars['Boolean']>;
  pet: Scalars['ID'];
  productFamily?: InputMaybe<Scalars['ID']>;
  startsAt: Scalars['DateTime'];
};

export type CreateRxBookingPayload = {
  __typename?: 'CreateRXBookingPayload';
  booking: RxBookingNode;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateShippingAddress = {
  __typename?: 'CreateShippingAddress';
  shippingAddress?: Maybe<ShippingAddressType>;
};

export type CreateSymptomCheckerFollowUpFromConversationInput = {
  carePlanAction?: InputMaybe<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  conversation: Scalars['ID'];
};

export type CreateSymptomCheckerFollowUpFromConversationPayload = {
  __typename?: 'CreateSymptomCheckerFollowUpFromConversationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  response: NextResponse;
};

export type CreateSymptomCheckerForPetInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pet: Scalars['ID'];
};

export type CreateSymptomCheckerForPetPayload = {
  __typename?: 'CreateSymptomCheckerForPetPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  response: NextResponse;
};

export type CreateUserPaymentMethodInput = {
  nickname?: InputMaybe<Scalars['String']>;
  processorId?: InputMaybe<Scalars['String']>;
  source: PaymentSource;
  token?: InputMaybe<Scalars['String']>;
};

export type DatePetDetailNode = Node & PetDetailInterface & {
  __typename?: 'DatePetDetailNode';
  createdAt: Scalars['DateTime'];
  diagnosticQuestion: DiagnosticQuestionNode;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  meetsTarget?: Maybe<Scalars['Boolean']>;
  occurredAfter?: Maybe<Scalars['DateTime']>;
  occurredBefore?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  slug: Scalars['String'];
  staleAt?: Maybe<Scalars['DateTime']>;
  triggersInPersonVisit?: Maybe<Scalars['Boolean']>;
  triggersLiveVisit?: Maybe<Scalars['Boolean']>;
};

export type DefaultPartnerDiscount = {
  __typename?: 'DefaultPartnerDiscount';
  flatDiscount?: Maybe<Scalars['Decimal']>;
  percentDiscount?: Maybe<Scalars['Decimal']>;
};

export type DeletePet = {
  __typename?: 'DeletePet';
  deleted?: Maybe<Scalars['Boolean']>;
  pet?: Maybe<PetType>;
};

export type DeletePetDetailInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  detail: Scalars['ID'];
};

/** Used to soft delete pet details by current user. */
export type DeletePetDetailPayload = {
  __typename?: 'DeletePetDetailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  pet: PetType;
};

export type DeletePetMedicalRecordInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  medicalRecord: Scalars['ID'];
};

export type DeletePetMedicalRecordPayload = {
  __typename?: 'DeletePetMedicalRecordPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type DeleteShippingAddress = {
  __typename?: 'DeleteShippingAddress';
  deleted?: Maybe<Scalars['Boolean']>;
};

export type DeleteUser = {
  __typename?: 'DeleteUser';
  deleted?: Maybe<Scalars['Boolean']>;
};

export type DeviceInput = {
  advertisingId?: InputMaybe<Scalars['String']>;
  applicationVersion?: InputMaybe<Scalars['String']>;
  appsFlyerId?: InputMaybe<Scalars['String']>;
  deviceIdentifier?: InputMaybe<Scalars['String']>;
  deviceName?: InputMaybe<Scalars['String']>;
  deviceType: DeviceType;
  /** @deprecated The 'externalIds' are the responsibility of the server, not clients. */
  externalIds?: InputMaybe<Scalars['JSONString']>;
  isAdTrackingEnabled?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  notificationPermission?: InputMaybe<DeviceNotificationPermission>;
  osVersion?: InputMaybe<Scalars['String']>;
  pushToken?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  trackingStatus?: InputMaybe<Scalars['String']>;
};

export type DeviceNode = Node & {
  __typename?: 'DeviceNode';
  advertisingId: Scalars['String'];
  applicationVersion: Scalars['String'];
  appsFlyerId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deviceIdentifier: Scalars['String'];
  deviceName: Scalars['String'];
  deviceType: DeviceType;
  /** The ID of the object */
  id: Scalars['ID'];
  isAdTrackingEnabled?: Maybe<Scalars['Boolean']>;
  locale: Scalars['String'];
  notificationPermission?: Maybe<DeviceNotificationPermission>;
  osVersion: Scalars['String'];
  timezone: Scalars['String'];
  trackingStatus: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type DeviceNodeConnection = {
  __typename?: 'DeviceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DeviceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `DeviceNode` and its cursor. */
export type DeviceNodeEdge = {
  __typename?: 'DeviceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DeviceNode>;
};

/**
 * The status of the permission
 * Values:
 * - NOT_DETERMINED :The user hasn't yet made a choice about whether the app is allowed to schedule notifications.
 * - GRANTED: The app is authorized to schedule or receive notifications.
 * - DENIED: The app isn't authorized to schedule or receive notifications.
 * - PROVISIONAL: The application is provisionally authorized to post non-interruptive user notifications.
 * - EPHEMERAL: The app is authorized to schedule or receive notifications for a limited amount of time.
 * iOS can send any of them
 * Android will only send NOT_DETERMINED, GRANTED or DENIED
 */
export enum DeviceNotificationPermission {
  Denied = 'DENIED',
  Ephemeral = 'EPHEMERAL',
  Granted = 'GRANTED',
  NotDetermined = 'NOT_DETERMINED',
  Provisional = 'PROVISIONAL'
}

/** An enumeration. */
export enum DeviceType {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export type DiagnosticAnswerNode = Node & {
  __typename?: 'DiagnosticAnswerNode';
  /** For answers that need better wording */
  customerFacingLabel: Scalars['String'];
  forcesSingleSelect: Scalars['Boolean'];
  /** The ID of the object */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isDefault: Scalars['Boolean'];
  label: Scalars['String'];
  numericalValue?: Maybe<Scalars['Int']>;
  /** True if only pros can see this answer */
  prosOnly: Scalars['Boolean'];
  question: DiagnosticQuestionNode;
  slug: Scalars['String'];
};

export type DiagnosticQuestionNode = Node & {
  __typename?: 'DiagnosticQuestionNode';
  aggregated: Scalars['Boolean'];
  answers?: Maybe<Array<DiagnosticAnswerNode>>;
  diagnosticType: DiagnosticType;
  /** The ID of the object */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  label: Scalars['String'];
  petTypes: Array<PetTypes>;
  prosOnly: Scalars['Boolean'];
  questionType: DiagnosticQuestionQuestionType;
  slug: Scalars['String'];
};

/** An enumeration. */
export enum DiagnosticQuestionQuestionType {
  Boolean = 'BOOLEAN',
  Choice = 'CHOICE',
  Date = 'DATE',
  Flat = 'FLAT',
  Image = 'IMAGE',
  Model = 'MODEL',
  MultipleChoice = 'MULTIPLE_CHOICE',
  Text = 'TEXT'
}

export type DiagnosticQuestionTargetValuesNode = Node & {
  __typename?: 'DiagnosticQuestionTargetValuesNode';
  /** If the question type is boolean match this target value if it is this field is non-null. If not specified and the question type is boolean then apply this target value (assuming detail and pet filtering conditions are satisfied). */
  booleanMatch?: Maybe<Scalars['Boolean']>;
  /** If the question type is choice or multiple choice and the detail's value is in this list (or any of its values for multiple choice) then this target value applies. */
  choiceSlugs: Array<Scalars['String']>;
  diagnosticQuestion: DiagnosticQuestionNode;
  /** The ID of the object */
  id: Scalars['ID'];
  /** For flat value questions types. Matches if the detail's resolved value is below the above limit (if null there is no lower limit for this) */
  lowerLimit?: Maybe<Scalars['Float']>;
  /** This is the opposite of the `occurred_before_duration` in that it is checking if something happened more recently than <duration>. If this target value is only supposed to apply for things that happened within the last 30 days this value would be set to `-30 days`. It does this by comparing the `occurred_after` timestamp of the PetDetail against its `created_at` timestamp. */
  occurredAfterDuration?: Maybe<Scalars['Duration']>;
  /** This sets a value for the 'if a thing happened more than <duration> ago where the duration to compare is the delta between the PetDetail's `created_at` timestamp and its `occurred_before` timestamp. So if this target value is supposed to apply for things that happened MORE than one year ago this value would be set to `-365 days`. */
  occurredBeforeDuration?: Maybe<Scalars['Duration']>;
  triggersInPersonVisit: Scalars['Boolean'];
  triggersLiveVisit: Scalars['Boolean'];
  /** For flat value questions types. Matches if the detail's resolved value is below the upper limit (if null there is no upper limit for this) */
  upperLimit?: Maybe<Scalars['Float']>;
};

/** An enumeration. */
export enum DiagnosticType {
  Objective = 'OBJECTIVE',
  Subjective = 'SUBJECTIVE'
}

export type DiscountNode = {
  __typename?: 'DiscountNode';
  createdAt: Scalars['DateTime'];
  flatDiscount?: Maybe<Scalars['Decimal']>;
  percentDiscount?: Maybe<Scalars['Decimal']>;
  source: DiscountSource;
};

export type DiscountSource = CouponNode | DefaultPartnerDiscount | PromoCodeNode;

export type DispatchStatsMemberType = {
  __typename?: 'DispatchStatsMemberType';
  estimatedWaitTimeV2?: Maybe<Scalars['Int']>;
  isAvailabilityExpected?: Maybe<Scalars['Boolean']>;
  pendingConversationCountV2?: Maybe<Scalars['Int']>;
};

export type DoRxBookingIntakeInput = {
  booking: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type DoRxBookingIntakePayload = {
  __typename?: 'DoRxBookingIntakePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  response: NextResponse;
};

export type DrugInteractionNode = Node & {
  __typename?: 'DrugInteractionNode';
  /** The ID of the object */
  id: Scalars['ID'];
  /** In the context of a parent medication this will always be the interactive medication otherwise it will match its true database value. */
  interactsWith: MedicationNode;
  /** In the context of a parent medication this will always be the parent medication otherwise it will match its true database value. */
  medication: MedicationNode;
  symptoms: SymptomNodeConnection;
};


export type DrugInteractionNodeSymptomsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type EmergencyFundAddOnNode = AddOnInterface & Node & {
  __typename?: 'EmergencyFundAddOnNode';
  activationFee?: Maybe<Scalars['Decimal']>;
  claimLimit?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  gracePeriod: Scalars['Duration'];
  /** The ID of the object */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  maxPayout: Scalars['Decimal'];
  name: Scalars['String'];
  pricing?: Maybe<Array<AddOnPriceNode>>;
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type EmergencyFundPolicyNode = InsurancePolicyInterface & Node & {
  __typename?: 'EmergencyFundPolicyNode';
  /** @deprecated Use 'pets' with necessary filters */
  activePets: Array<EmergencyFundPolicyPetNode>;
  annualLimit: Scalars['Decimal'];
  annualLimitUsed: Scalars['Decimal'];
  boundDate?: Maybe<Scalars['DateTime']>;
  coinsurancePercentage: Scalars['Int'];
  deductible: Scalars['Decimal'];
  deductibleUsed: Scalars['Decimal'];
  documents?: Maybe<InsurancePolicyDocumentNodeConnection>;
  /** The ID of the object */
  id: Scalars['ID'];
  insuredAddress?: Maybe<AddressType>;
  pets: Array<EmergencyFundPolicyPetNode>;
  policyExpirationDate?: Maybe<Scalars['Date']>;
  policyNumber: Scalars['String'];
  policyStartDate: Scalars['Date'];
  provider: InsuranceProvider;
};


export type EmergencyFundPolicyNodeDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<InsurancePolicyDocumentType>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};


export type EmergencyFundPolicyNodePetsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  claimEligibleOnly?: InputMaybe<Scalars['Boolean']>;
  includeWaitingPeriodPets?: InputMaybe<Scalars['Boolean']>;
};

export type EmergencyFundPolicyNodeConnection = {
  __typename?: 'EmergencyFundPolicyNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EmergencyFundPolicyNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `EmergencyFundPolicyNode` and its cursor. */
export type EmergencyFundPolicyNodeEdge = {
  __typename?: 'EmergencyFundPolicyNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<EmergencyFundPolicyNode>;
};

export type EmergencyFundPolicyPetNode = {
  __typename?: 'EmergencyFundPolicyPetNode';
  canFileClaim: Scalars['Boolean'];
  coverageEndsAt?: Maybe<Scalars['Date']>;
  coverageStartsAt: Scalars['Date'];
  lossDateLowerBound?: Maybe<Scalars['Date']>;
  lossDateUpperBound?: Maybe<Scalars['Date']>;
  pet: PetType;
};

export type EmergencyFundStatusNode = AddOnStatusInterface & Node & {
  __typename?: 'EmergencyFundStatusNode';
  activePolicy?: Maybe<EmergencyFundPolicyNode>;
  addOn: EmergencyFundAddOnNode;
  canFileClaim: Scalars['Boolean'];
  canFileClaimUntil?: Maybe<Scalars['DateTime']>;
  /** When the grace period for this user plan ends. This value will never change. */
  coverageStartsAt?: Maybe<Scalars['DateTime']>;
  currentCycleEnd?: Maybe<Scalars['DateTime']>;
  currentCycleStart?: Maybe<Scalars['DateTime']>;
  firstStatusAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  isBundled: Scalars['Boolean'];
  /** Next date the user can claim an emergency. This value automatically adjusts when an emergency is claimed. */
  nextClaimDate?: Maybe<Scalars['DateTime']>;
  price?: Maybe<PriceNode>;
  status: PlanStatus;
  subscription?: Maybe<SubscriptionNode>;
  validUntil?: Maybe<Scalars['DateTime']>;
  version: EmergencyFundStatusVersion;
};

/** An enumeration. */
export enum EmergencyFundStatusVersion {
  V1 = 'V1',
  V2 = 'V2'
}

export type EmergencyProtection = EmergencyProtectionFeatures & PurchasedTierInterface & SubscribedFeatureInterface & {
  __typename?: 'EmergencyProtection';
  activatedAt?: Maybe<Scalars['DateTime']>;
  activePolicy?: Maybe<EmergencyFundPolicyNode>;
  bundle?: Maybe<FeatureBundle>;
  canFileClaim: Scalars['Boolean'];
  coverageStartsAt?: Maybe<Scalars['DateTime']>;
  coveredPets: Array<EmergencyProtectionPet>;
  downgradeOptions: Array<SubscribableFeatureInterface>;
  nextClaimDate?: Maybe<Scalars['DateTime']>;
  partner?: Maybe<PartnerNode>;
  /** All policies a user has been linked to ever */
  policies: EmergencyFundPolicyNodeConnection;
  price?: Maybe<PriceNode>;
  purchaseAmount?: Maybe<Scalars['Decimal']>;
  purchasedAt?: Maybe<Scalars['DateTime']>;
  requiresUserAction: Scalars['Boolean'];
  subscription?: Maybe<SubscriptionNode>;
  subsidized: Scalars['Boolean'];
  terminatedAt?: Maybe<Scalars['DateTime']>;
  /** Feature user currently is subscribed to, if any, or the feature the user will be subscribed to if in the context of a quote. */
  tier?: Maybe<EmergencyProtectionConfig>;
  trialDuration?: Maybe<Scalars['Duration']>;
  trialEndsAt?: Maybe<Scalars['DateTime']>;
  trialing: Scalars['Boolean'];
  upgradeOptions: Array<SubscribableFeatureInterface>;
};


export type EmergencyProtectionDowngradeOptionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type EmergencyProtectionPoliciesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type EmergencyProtectionUpgradeOptionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type EmergencyProtectionConfig = Node & SubscribableFeatureInterface & {
  __typename?: 'EmergencyProtectionConfig';
  defaultRenewalCadence: RenewalCadence;
  description: Scalars['String'];
  gracePeriod: Scalars['Duration'];
  id: Scalars['ID'];
  incidentLookbackWindow: Scalars['Duration'];
  maxPayout: Scalars['Decimal'];
  name: Scalars['String'];
  slug: Scalars['Slug'];
};

export type EmergencyProtectionFeatures = {
  activePolicy?: Maybe<EmergencyFundPolicyNode>;
  canFileClaim: Scalars['Boolean'];
  coverageStartsAt?: Maybe<Scalars['DateTime']>;
  coveredPets: Array<EmergencyProtectionPet>;
  nextClaimDate?: Maybe<Scalars['DateTime']>;
  /** All policies a user has been linked to ever */
  policies: EmergencyFundPolicyNodeConnection;
  /** Feature user currently is subscribed to, if any, or the feature the user will be subscribed to if in the context of a quote. */
  tier?: Maybe<EmergencyProtectionConfig>;
};


export type EmergencyProtectionFeaturesPoliciesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type EmergencyProtectionPet = {
  __typename?: 'EmergencyProtectionPet';
  canFileClaim: Scalars['Boolean'];
  coverageEndsAt?: Maybe<Scalars['Date']>;
  coverageStartsAt: Scalars['Date'];
  lossDateLowerBound?: Maybe<Scalars['Date']>;
  lossDateUpperBound?: Maybe<Scalars['Date']>;
  pet: PetType;
};

export type EmergencyProtectionQuoteLine = EmergencyProtectionFeatures & QuoteLineInterface & RenewalQuoteLineInterface & SubscribableQuoteLineInterface & {
  __typename?: 'EmergencyProtectionQuoteLine';
  activePolicy?: Maybe<EmergencyFundPolicyNode>;
  /** Amount user needs to pay at checkout. */
  amountDue: Scalars['Decimal'];
  canFileClaim: Scalars['Boolean'];
  coverageStartsAt?: Maybe<Scalars['DateTime']>;
  coveredPets: Array<EmergencyProtectionPet>;
  /** Current net price the user pays, if any. */
  currentNetPrice?: Maybe<Scalars['Decimal']>;
  /** What the user currently pays for this feature, if any. */
  currentPrice?: Maybe<Scalars['Decimal']>;
  /** Current subsidy amount, if any. */
  currentSubsidy?: Maybe<Scalars['Decimal']>;
  discount: Scalars['Decimal'];
  existingSubscription?: Maybe<SubscriptionNode>;
  feature: EmergencyProtectionConfig;
  missingOrIncompletePetFields: Array<IncompletePetDataType>;
  /** List of pet attributes required to checkout. Omits fields already properly set. */
  missingOrIncompleteUserFields: Array<ActionRequiredUserFields>;
  netPrice: Scalars['Decimal'];
  nextClaimDate?: Maybe<Scalars['DateTime']>;
  /** All policies a user has been linked to ever */
  policies: EmergencyFundPolicyNodeConnection;
  price: Scalars['Decimal'];
  /** Null if this is fully subsidized. */
  renewalCadence?: Maybe<RenewalCadence>;
  subsidizedBy?: Maybe<PartnerNode>;
  subsidy: Scalars['Decimal'];
  /** Feature user currently is subscribed to, if any, or the feature the user will be subscribed to if in the context of a quote. */
  tier?: Maybe<EmergencyProtectionConfig>;
};


export type EmergencyProtectionQuoteLinePoliciesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** An enumeration. */
export enum EmergencyRequestGumColor {
  Blue = 'BLUE',
  Pink = 'PINK',
  Unavailable = 'UNAVAILABLE',
  White = 'WHITE'
}

/** An enumeration. */
export enum EmergencyRequestIssueLength {
  MoreThanWeek = 'MORE_THAN_WEEK',
  MultipleDays = 'MULTIPLE_DAYS',
  OneDay = 'ONE_DAY'
}

export type EmergencyRequestQuestionnaireInput = {
  colorOfGums: EmergencyRequestGumColor;
  hasSeenVet: Scalars['Boolean'];
  isEatingDrinking: Scalars['Boolean'];
  isPresent: Scalars['Boolean'];
  issueLength: EmergencyRequestIssueLength;
};

export type EmergencyStateType = {
  __typename?: 'EmergencyStateType';
  conversation: ConversationType;
  expiresAt: Scalars['DateTime'];
};

export type EndConversationV2 = {
  __typename?: 'EndConversationV2';
  conversation?: Maybe<ConversationType>;
};

export type EndVideoV2 = {
  __typename?: 'EndVideoV2';
  videoRoom?: Maybe<VideoRoomType>;
};

export type EscalateTriageConversationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  threadId: Scalars['String'];
};

export type EscalateTriageConversationPayload = {
  __typename?: 'EscalateTriageConversationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  conversation?: Maybe<ConversationType>;
};

export type ExploreFinancialProtection = {
  __typename?: 'ExploreFinancialProtection';
  petId: Scalars['ID'];
};

export type ExternalAccesTokensType = {
  __typename?: 'ExternalAccesTokensType';
  algolia?: Maybe<Scalars['String']>;
  intercomIos?: Maybe<Scalars['String']>;
  intercomWeb?: Maybe<Scalars['String']>;
};

export type ExternalLinkRecommendationNode = Node & {
  __typename?: 'ExternalLinkRecommendationNode';
  externalThumbnailUrl: Scalars['String'];
  externalUrl: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type ExternalPaymentMethodNode = Node & {
  __typename?: 'ExternalPaymentMethodNode';
  brand?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  expiration?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  lastFour?: Maybe<Scalars['String']>;
  syncedAt?: Maybe<Scalars['DateTime']>;
  token?: Maybe<Scalars['String']>;
};

export type FeatureAccess = {
  __typename?: 'FeatureAccess';
  emergencyProtection: EmergencyProtection;
  membership: Membership;
  prescriptions: PrescriptionFeature;
  status: MembershipStatus;
  user: UserType;
};

export type FeatureAvailability = {
  __typename?: 'FeatureAvailability';
  enabled: Scalars['Boolean'];
  nextAvailableAt?: Maybe<Scalars['DateTime']>;
  remaining: RemainingUses;
};

export type FeatureBundle = Node & {
  __typename?: 'FeatureBundle';
  consumables: Array<ConsumableFeatureTier>;
  consumablesPrice: Scalars['Decimal'];
  deactivatedAt?: Maybe<Scalars['DateTime']>;
  effectiveAt: Scalars['DateTime'];
  emergencyProtection?: Maybe<EmergencyProtectionConfig>;
  /** The ID of the object */
  id: Scalars['ID'];
  membership?: Maybe<MembershipTierConfig>;
  monthlyPrice?: Maybe<Scalars['Decimal']>;
  slug: Scalars['String'];
  subscribedConsumables: Array<Maybe<SubscribableFeatureInterface>>;
  /** If set, the duration of the trial a user can get when purchasing this bundle. Bundled consumables must always be purchased up front (and are non refundable). All bundled subscribable features will get the same trial as defined here. Any trial duration settings for individual features are always ignored when bundled - this is the only source of truth. */
  trialDuration?: Maybe<Scalars['Duration']>;
  yearlyPrice?: Maybe<Scalars['Decimal']>;
};

/** GraphQL node for uploaded files. */
export type FileNode = Node & {
  __typename?: 'FileNode';
  contentType: Scalars['String'];
  createdAt: Scalars['DateTime'];
  fileUrl: Scalars['String'];
  filename: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  notes: Scalars['String'];
  owner: UserType;
  size: Scalars['Int'];
  uploadedBy?: Maybe<UserType>;
};

export type FileType = {
  __typename?: 'FileType';
  fileType: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type FlatPetDetailNode = Node & PetDetailInterface & {
  __typename?: 'FlatPetDetailNode';
  createdAt: Scalars['DateTime'];
  diagnosticQuestion: DiagnosticQuestionNode;
  expiresAt?: Maybe<Scalars['DateTime']>;
  flatValue?: Maybe<Scalars['Decimal']>;
  id: Scalars['ID'];
  meetsTarget?: Maybe<Scalars['Boolean']>;
  occurredAfter?: Maybe<Scalars['DateTime']>;
  occurredBefore?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  slug: Scalars['String'];
  staleAt?: Maybe<Scalars['DateTime']>;
  triggersInPersonVisit?: Maybe<Scalars['Boolean']>;
  triggersLiveVisit?: Maybe<Scalars['Boolean']>;
};

export type ForgotPassword = {
  __typename?: 'ForgotPassword';
  success?: Maybe<Scalars['Boolean']>;
};

export type FormResponseNode = Node & {
  __typename?: 'FormResponseNode';
  completedAt?: Maybe<Scalars['DateTime']>;
  /** The ID of the object */
  id: Scalars['ID'];
  responses?: Maybe<Array<Maybe<QuestionGroupNode>>>;
};

export type FormResponseType = Node & {
  __typename?: 'FormResponseType';
  completedAt?: Maybe<Scalars['DateTime']>;
  /** The ID of the object */
  id: Scalars['ID'];
  responses?: Maybe<Array<Maybe<QuestionGroupNode>>>;
};

export type FulfillmentNode = Node & {
  __typename?: 'FulfillmentNode';
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  order: OrderV2Node;
  orderLine: OrderLineNode;
  orderLineItems?: Maybe<Array<OrderLineItem>>;
  quantity: Scalars['Int'];
  shipmentStatus: FulfillmentShipmentStatus;
  statusHistory: Array<FullfillmentStatusRecord>;
  trackingCompany: FulfillmentTrackingCompany;
  trackingNumber: Scalars['String'];
  /** @deprecated Replaced by 'trackingNumber' */
  trackingNumbers?: Maybe<Array<Scalars['String']>>;
  trackingUrl?: Maybe<Scalars['String']>;
  /** @deprecated Replaced by 'trackingUrl' */
  trackingUrls?: Maybe<Array<Scalars['String']>>;
  updatedAt: Scalars['DateTime'];
};

export type FulfillmentNodeConnection = {
  __typename?: 'FulfillmentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FulfillmentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `FulfillmentNode` and its cursor. */
export type FulfillmentNodeEdge = {
  __typename?: 'FulfillmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<FulfillmentNode>;
};

/** An enumeration. */
export enum FulfillmentShipmentStatus {
  AttemptedDelivery = 'ATTEMPTED_DELIVERY',
  Confirmed = 'CONFIRMED',
  Delivered = 'DELIVERED',
  Failure = 'FAILURE',
  InTransit = 'IN_TRANSIT',
  LabelPrinted = 'LABEL_PRINTED',
  LabelPurchased = 'LABEL_PURCHASED',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  ReadyForPickup = 'READY_FOR_PICKUP'
}

/** The tracking companies supported by Shopify in the US on 2021/11/10. */
export enum FulfillmentTrackingCompany {
  AmazonLogisticsUk = 'AMAZON_LOGISTICS_UK',
  AmazonLogisticsUs = 'AMAZON_LOGISTICS_US',
  AnjunLogistics = 'ANJUN_LOGISTICS',
  Apc = 'APC',
  AustraliaPost = 'AUSTRALIA_POST',
  Bluedart = 'BLUEDART',
  CanadaPost = 'CANADA_POST',
  Canpar = 'CANPAR',
  ChinaPost = 'CHINA_POST',
  Chukou1 = 'CHUKOU1',
  Correios = 'CORREIOS',
  CouriersPlease = 'COURIERS_PLEASE',
  Delhivery = 'DELHIVERY',
  DhlEcommerce = 'DHL_ECOMMERCE',
  DhlEcommerceAsia = 'DHL_ECOMMERCE_ASIA',
  DhlExpress = 'DHL_EXPRESS',
  Dpd = 'DPD',
  DpdLocal = 'DPD_LOCAL',
  DpdUk = 'DPD_UK',
  Eagle = 'EAGLE',
  Fedex = 'FEDEX',
  FourPx = 'FOUR_PX',
  Fsc = 'FSC',
  Globegistics = 'GLOBEGISTICS',
  Gls = 'GLS',
  GlsUs = 'GLS_US',
  JapanPost = 'JAPAN_POST',
  LaPoste = 'LA_POSTE',
  Newgistics = 'NEWGISTICS',
  NewZealandPost = 'NEW_ZEALAND_POST',
  Other = 'OTHER',
  Postnl = 'POSTNL',
  Postnord = 'POSTNORD',
  Purolator = 'PUROLATOR',
  RoyalMail = 'ROYAL_MAIL',
  Sagawa = 'SAGAWA',
  Sendle = 'SENDLE',
  SfcFulfilllment = 'SFC_FULFILLLMENT',
  SfExpress = 'SF_EXPRESS',
  SingaporePost = 'SINGAPORE_POST',
  Startrack = 'STARTRACK',
  Tnt = 'TNT',
  TollIpec = 'TOLL_IPEC',
  Ups = 'UPS',
  Usps = 'USPS',
  Whistl = 'WHISTL',
  Yamato = 'YAMATO',
  Yunexpress = 'YUNEXPRESS'
}

export type FullPerksContractNode = Node & {
  __typename?: 'FullPerksContractNode';
  endDate: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  startDate: Scalars['DateTime'];
};

export type FullfillmentStatusRecord = {
  __typename?: 'FullfillmentStatusRecord';
  createdAt: Scalars['DateTime'];
  shipmentStatus: FulfillmentShipmentStatus;
};

export type FundingSource = FullPerksContractNode | SubscriptionNode;

export type GenerateExternalQuoteInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  offer: Scalars['ID'];
  offerPosition?: InputMaybe<Scalars['Int']>;
};

/**
 * Generate a purchasable external URL for selected IIPQuote estimate(s).
 * Creates or updates the BindableQuote with the external URL.
 */
export type GenerateExternalQuotePayload = {
  __typename?: 'GenerateExternalQuotePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  offer: IipOfferNode;
};

export type GenerateIipQuotesInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** @deprecated This does not do anything */
  flattenGroupQuotes?: InputMaybe<Scalars['Boolean']>;
  giveConsent?: InputMaybe<Scalars['Boolean']>;
  pets?: InputMaybe<Array<Scalars['ID']>>;
  /** @deprecated This does not do anything */
  refresh?: InputMaybe<Scalars['Boolean']>;
  skipConsentCheck?: InputMaybe<Scalars['Boolean']>;
};

export type GenerateIipQuotesPayload = {
  __typename?: 'GenerateIIPQuotesPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  quotes: Array<IipOfferNode>;
};


export type GenerateIipQuotesPayloadQuotesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  limitPerOffer?: InputMaybe<Scalars['Int']>;
  offer?: InputMaybe<Scalars['ID']>;
  surface?: InputMaybe<IipSurface>;
  targetAnnualLimit?: InputMaybe<Scalars['Int']>;
  targetDeductible?: InputMaybe<Scalars['Int']>;
  targetReimbursementPercentage?: InputMaybe<Scalars['Int']>;
};

export type GenericCarePlanActionNode = ActionInterface & CarePlanActionInterface & Node & VisitInterface & {
  __typename?: 'GenericCarePlanActionNode';
  actionType: CarePlanActionType;
  administrationRoute?: Maybe<AdministrationRouteNode>;
  carePlan: CarePlanNode;
  complianceStatus?: Maybe<ComplianceLevel>;
  complianceStatusRecords?: Maybe<CarePlanActionComplianceStatusRecordNodeConnection>;
  conditionGroup?: Maybe<ConditionGroupNode>;
  conversation?: Maybe<ConversationType>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<ProfessionalNode>;
  currentFeedback?: Maybe<CarePlanActionFeedbackNode>;
  date: Scalars['DateTime'];
  deadline?: Maybe<Scalars['DateTime']>;
  duration?: Maybe<Scalars['Int']>;
  durationUnit?: Maybe<CarePlanActionDurationUnit>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  feedback: CarePlanActionFeedbackNodeConnection;
  firstVersion: Scalars['Boolean'];
  icon?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  important: Scalars['Boolean'];
  interval?: Maybe<Scalars['Int']>;
  label: Scalars['String'];
  lastEditedBy?: Maybe<ProfessionalNode>;
  notes: Scalars['String'];
  pausedUntil?: Maybe<Scalars['DateTime']>;
  period?: Maybe<CarePlanActionPeriod>;
  prescriptions: Array<PrescriptionNode>;
  quantityDecimal?: Maybe<Scalars['Decimal']>;
  quantityUnit?: Maybe<CarePlanActionQuantityUnit>;
  reasoningContent: Scalars['String'];
  reasoningTitle: Scalars['String'];
  recommendations?: Maybe<Array<Maybe<RecommendationNode>>>;
  recommendedProducts: Array<ProductRecommendationNodeV2>;
  slug: Scalars['String'];
  sortingWeight: Scalars['Int'];
  status: ActionStatus;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  topicName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  versioningId: Scalars['String'];
  viewingDraft: Scalars['Boolean'];
};


export type GenericCarePlanActionNodeComplianceStatusRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type GenericCarePlanActionNodeFeedbackArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type GenericCarePlanActionNodeConnection = {
  __typename?: 'GenericCarePlanActionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GenericCarePlanActionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `GenericCarePlanActionNode` and its cursor. */
export type GenericCarePlanActionNodeEdge = {
  __typename?: 'GenericCarePlanActionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<GenericCarePlanActionNode>;
};

export type GenericFileNode = Node & {
  __typename?: 'GenericFileNode';
  fileUrl: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type GenericFileNodeConnection = {
  __typename?: 'GenericFileNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GenericFileNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `GenericFileNode` and its cursor. */
export type GenericFileNodeEdge = {
  __typename?: 'GenericFileNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<GenericFileNode>;
};

export type GenericInstanceInput = {
  app: Scalars['String'];
  instanceId: Scalars['String'];
  model: Scalars['String'];
};

export type GuestSessionInput = {
  identifier: Scalars['String'];
  token: Scalars['String'];
};

export type HealthGoalType = {
  __typename?: 'HealthGoalType';
  activeIcon?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  emoji?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identifier?: Maybe<Scalars['String']>;
  isSelectable: Scalars['Boolean'];
  name: Scalars['String'];
  petTypes: Array<PetTypes>;
};

/** An enumeration. */
export enum Holiday {
  Christmas = 'CHRISTMAS',
  Halloween = 'HALLOWEEN',
  IndependenceDay = 'INDEPENDENCE_DAY',
  MemorialDay = 'MEMORIAL_DAY',
  NewYears = 'NEW_YEARS',
  Thanksgiving = 'THANKSGIVING',
  ValentinesDay = 'VALENTINES_DAY'
}

/** IIP offer node - based on IIPQuote */
export type IipOfferNode = Node & {
  __typename?: 'IIPOfferNode';
  converted: Scalars['Boolean'];
  coverage: Scalars['String'];
  ctaText: Scalars['String'];
  deductible: Scalars['Decimal'];
  externalQuoteId?: Maybe<Scalars['String']>;
  externalUrl?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  isGroupPolicy: Scalars['Boolean'];
  /** @deprecated Replaced by 'isGroupPolicy' */
  isGroupQuote: Scalars['Boolean'];
  monthlyPremium: Scalars['Decimal'];
  offerIconUrl: Scalars['String'];
  offerImageUrl: Scalars['String'];
  partner: PartnerNode;
  pets: Array<PetType>;
  policyNumber?: Maybe<Scalars['String']>;
  primaryColor: Scalars['String'];
  primaryContrastColor: Scalars['String'];
  provider: InsuranceProvider;
  providerColoredLogoUrl?: Maybe<Scalars['String']>;
  providerLogoUrl: Scalars['String'];
  providerName: Scalars['String'];
  quoteCustomizationEnabled: Scalars['Boolean'];
  quoteRequirements: Array<QuoteRequirement>;
  /** @deprecated Replaced by 'pets' */
  quotedPets: Array<IipPetOfferNode>;
  reasons: Array<Scalars['String']>;
  reimbursementPercentage: Scalars['Int'];
  savedPaymentMethods: Array<ExternalPaymentMethodNode>;
  secondaryColor: Scalars['String'];
  secondaryContrastColor: Scalars['String'];
};

export type IipPetOfferNode = {
  __typename?: 'IIPPetOfferNode';
  coverage: Scalars['String'];
  deductible?: Maybe<Scalars['Decimal']>;
  monthlyPremium?: Maybe<Scalars['Decimal']>;
  pet: PetType;
  reimbursementPercentage?: Maybe<Scalars['Int']>;
};

export type IipPurchasePetActionNode = ActionInterface & Node & PetTodoInterface & {
  __typename?: 'IIPPurchasePetActionNode';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<ProfessionalNode>;
  ctaAction?: Maybe<TodoClientAction>;
  ctaText?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  extendedSubtitle?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  iipOffer: IipOfferNode;
  important: Scalars['Boolean'];
  label: Scalars['String'];
  lastEditedBy?: Maybe<ProfessionalNode>;
  pet: PetType;
  slug: Scalars['String'];
  status: ActionStatus;
  subtitle: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  viewingDraft: Scalars['Boolean'];
};

/** An enumeration. */
export enum IipSurface {
  HealthAssessment = 'HEALTH_ASSESSMENT',
  PetActions = 'PET_ACTIONS',
  PetInsights = 'PET_INSIGHTS',
  ProtectTab = 'PROTECT_TAB',
  WaitingRoom = 'WAITING_ROOM'
}

export type ImagePetDetailNode = Node & PetDetailInterface & {
  __typename?: 'ImagePetDetailNode';
  createdAt: Scalars['DateTime'];
  diagnosticQuestion: DiagnosticQuestionNode;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  imageValue?: Maybe<Scalars['String']>;
  meetsTarget?: Maybe<Scalars['Boolean']>;
  occurredAfter?: Maybe<Scalars['DateTime']>;
  occurredBefore?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  slug: Scalars['String'];
  staleAt?: Maybe<Scalars['DateTime']>;
  triggersInPersonVisit?: Maybe<Scalars['Boolean']>;
  triggersLiveVisit?: Maybe<Scalars['Boolean']>;
  uploadedFiles?: Maybe<Array<FileNode>>;
};

export type ImageStaticOption = {
  __typename?: 'ImageStaticOption';
  imageUrl: Scalars['String'];
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type ImageStaticOptionsNode = {
  __typename?: 'ImageStaticOptionsNode';
  /** List of available image options */
  imageOptions: Array<Maybe<ImageStaticOption>>;
};

export type ImageType = {
  __typename?: 'ImageType';
  extension?: Maybe<Scalars['String']>;
  hasFullBackground: Scalars['Boolean'];
  id: Scalars['ID'];
  picture?: Maybe<Scalars['String']>;
};

export type InPersonVisitActionNode = ActionInterface & CarePlanActionInterface & ConversationActionInterface & Node & PetTodoInterface & VisitInterface & {
  __typename?: 'InPersonVisitActionNode';
  actionType: CarePlanActionType;
  carePlan: CarePlanNode;
  complianceStatus?: Maybe<ComplianceLevel>;
  complianceStatusRecords?: Maybe<CarePlanActionComplianceStatusRecordNodeConnection>;
  conversation: ConversationType;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<ProfessionalNode>;
  ctaAction?: Maybe<TodoClientAction>;
  ctaText?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  deadline?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  extendedSubtitle?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  important: Scalars['Boolean'];
  label: Scalars['String'];
  lastEditedBy?: Maybe<ProfessionalNode>;
  notes: Scalars['String'];
  pet: PetType;
  reasoningContent: Scalars['String'];
  reasoningTitle: Scalars['String'];
  slug: Scalars['String'];
  sortingWeight: Scalars['Int'];
  status: ActionStatus;
  subtitle: Scalars['String'];
  title: Scalars['String'];
  topicName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  viewingDraft: Scalars['Boolean'];
};


export type InPersonVisitActionNodeComplianceStatusRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type InPersonVisitResultNode = Node & {
  __typename?: 'InPersonVisitResultNode';
  action: GenericCarePlanActionNode;
  actualVisitDate?: Maybe<Scalars['DateTime']>;
  clinicLocation?: Maybe<ClinicLocationType>;
  clinicLocationRating?: Maybe<ClinicLocationRatingType>;
  documents?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The ID of the object */
  id: Scalars['ID'];
  reasonForNoVisit?: Maybe<ReasonForNoVisit>;
  visitDetails: Scalars['String'];
};

export type IncompletePetDataType = {
  __typename?: 'IncompletePetDataType';
  /** List of pet attributes required to checkout. Omits fields already properly set. */
  missingOrIncompleteFields: Array<ActionRequiredPetFields>;
  pet: PetType;
};

export type InitiateClientUploadInput = {
  byteSize: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  contentType: Scalars['String'];
  filename: Scalars['String'];
  purpose: ClientUploadPurpose;
  referenceKey: Scalars['String'];
};

export type InitiateClientUploadPayload = {
  __typename?: 'InitiateClientUploadPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  requiredHeaders: Array<UploadRequiredHeaderType>;
  upload: ClientUploadNode;
  uploadUrl: Scalars['String'];
};

export type InsertClinicInput = {
  address?: InputMaybe<AddressInput>;
  addressId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type InsertClinicNodeInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  clinic: InsertClinicInput;
};

export type InsertClinicNodePayload = {
  __typename?: 'InsertClinicNodePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  clinic?: Maybe<CoreClinicNode>;
};

/** Deprecated - here for backwards compatibility with product_v2 */
export type InsertClinicNodeV2 = {
  __typename?: 'InsertClinicNodeV2';
  clinic?: Maybe<CoreClinicNode>;
};

export type InsertPrescriptionInput = {
  cartLineId: Scalars['ID'];
  clinicId: Scalars['ID'];
  petId: Scalars['ID'];
};

export type InsertPrescriptionNodeInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  prescription: InsertPrescriptionInput;
};

/** Deprecated - here for backwards compatibility with product_v2 */
export type InsertPrescriptionNodePayload = {
  __typename?: 'InsertPrescriptionNodePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  prescription: CorePrescriptionNode;
};

export type InsightCategoryNode = Node & {
  __typename?: 'InsightCategoryNode';
  backgroundColor: Scalars['String'];
  cardIllustrationCat: Scalars['String'];
  cardIllustrationDog: Scalars['String'];
  createdAt: Scalars['DateTime'];
  icon: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  insights: InsightNodeConnection;
  modalIllustrationCat: Scalars['String'];
  modalIllustrationDog: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type InsightCategoryNodeInsightsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** An enumeration. */
export enum InsightKeyAction {
  BookRxVisit = 'BOOK_RX_VISIT',
  BuyProduct = 'BUY_PRODUCT',
  ExploreFinancialProtection = 'EXPLORE_FINANCIAL_PROTECTION',
  ReadArticle = 'READ_ARTICLE',
  ReviewCareAction = 'REVIEW_CARE_ACTION',
  ReviewProgram = 'REVIEW_PROGRAM',
  StartLiveVisit = 'START_LIVE_VISIT',
  ViewIipQuote = 'VIEW_IIP_QUOTE'
}

export type InsightNode = Node & {
  __typename?: 'InsightNode';
  category: InsightCategoryNode;
  eligibleHolidays: Array<Holiday>;
  eligibleSeasons: Array<Season>;
  expirationDays: Scalars['Int'];
  fallbackKeyAction?: Maybe<InsightKeyAction>;
  fallbackKeyActionParams: Scalars['JSONString'];
  /** The ID of the object */
  id: Scalars['ID'];
  internalTitle: Scalars['String'];
  isActive: Scalars['Boolean'];
  keyAction?: Maybe<InsightKeyAction>;
  keyActionParams: Scalars['JSONString'];
  slug: Scalars['String'];
};

export type InsightNodeConnection = {
  __typename?: 'InsightNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InsightNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `InsightNode` and its cursor. */
export type InsightNodeEdge = {
  __typename?: 'InsightNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<InsightNode>;
};

/** Deprecated type because model is now deprecated */
export type InsurancePolicy = {
  __typename?: 'InsurancePolicy';
  certificateDocument?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  generatedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  insuredId?: Maybe<Scalars['Int']>;
  policyDocument?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type InsurancePolicyDocumentNode = Node & {
  __typename?: 'InsurancePolicyDocumentNode';
  documentType: InsurancePolicyDocumentType;
  file: Scalars['String'];
  generatedAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type InsurancePolicyDocumentNodeConnection = {
  __typename?: 'InsurancePolicyDocumentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InsurancePolicyDocumentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `InsurancePolicyDocumentNode` and its cursor. */
export type InsurancePolicyDocumentNodeEdge = {
  __typename?: 'InsurancePolicyDocumentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<InsurancePolicyDocumentNode>;
};

/** An enumeration. */
export enum InsurancePolicyDocumentType {
  Cancelation = 'CANCELATION',
  ClaimStatement = 'CLAIM_STATEMENT',
  Endorsement = 'ENDORSEMENT',
  IntentToCancel = 'INTENT_TO_CANCEL',
  MedicalReport = 'MEDICAL_REPORT',
  PolicyDocument = 'POLICY_DOCUMENT',
  SignedPolicyDocument = 'SIGNED_POLICY_DOCUMENT',
  VetInvoice = 'VET_INVOICE'
}

export type InsurancePolicyInterface = {
  annualLimit: Scalars['Decimal'];
  annualLimitUsed: Scalars['Decimal'];
  boundDate?: Maybe<Scalars['DateTime']>;
  coinsurancePercentage: Scalars['Int'];
  deductible: Scalars['Decimal'];
  deductibleUsed: Scalars['Decimal'];
  documents?: Maybe<InsurancePolicyDocumentNodeConnection>;
  insuredAddress?: Maybe<AddressType>;
  policyExpirationDate?: Maybe<Scalars['Date']>;
  policyNumber: Scalars['String'];
  policyStartDate: Scalars['Date'];
  provider: InsuranceProvider;
};


export type InsurancePolicyInterfaceDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<InsurancePolicyDocumentType>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type InsurancePolicyNode = EmergencyFundPolicyNode | PetInsurancePolicyNode;

/** An enumeration. */
export enum InsuranceProvider {
  /** ISC */
  Isc = 'ISC',
  Lemonade = 'LEMONADE',
  /** MetLife */
  Metlife = 'METLIFE',
  Odie = 'ODIE',
  OdieEf = 'ODIE_EF',
  Pawp = 'PAWP',
  PetsBest = 'PETS_BEST',
  Sandbox = 'SANDBOX'
}

export type InvoiceNode = Node & {
  __typename?: 'InvoiceNode';
  amountDue: Scalars['Decimal'];
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  invoiceNumber: Scalars['String'];
  pastDue: Scalars['Boolean'];
  processorId: Scalars['String'];
  status: InvoiceStatus;
  subtotal?: Maybe<Scalars['Decimal']>;
  total: Scalars['Decimal'];
  totalDiscount?: Maybe<Scalars['Decimal']>;
};

export type InvoiceNodeConnection = {
  __typename?: 'InvoiceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InvoiceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `InvoiceNode` and its cursor. */
export type InvoiceNodeEdge = {
  __typename?: 'InvoiceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<InvoiceNode>;
};

/** An enumeration. */
export enum InvoiceStatus {
  Draft = 'DRAFT',
  Open = 'OPEN',
  Paid = 'PAID',
  Uncollectible = 'UNCOLLECTIBLE',
  Void = 'VOID'
}

export type IssueIipPolicyInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  offer: Scalars['ID'];
  paymentMethod: Scalars['ID'];
};

export type IssueIipPolicyPayload = {
  __typename?: 'IssueIIPPolicyPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  offer: IipOfferNode;
};

export type JoinBookingWaitlistInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pet: Scalars['ID'];
  serviceType: BookingServiceType;
};

export type JoinBookingWaitlistPayload = {
  __typename?: 'JoinBookingWaitlistPayload';
  bookingWaitlist: BookingWaitlistNode;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type KeyAction = BookRxVisit | BuyProduct | ExploreFinancialProtection | ReadArticle | ReviewCareAction | ReviewProgram | StartLiveVisit | ViewIipQuote;

/**
 * Lets a member create feedback on a conversation
 * the feedback they leave is not visible to the other conversation
 * participants
 */
export type LeaveConversationFeedbackMember = {
  __typename?: 'LeaveConversationFeedbackMember';
  conversationFeedback?: Maybe<ConversationFeedbackType>;
};

/** An enumeration. */
export enum LegalSex {
  F = 'F',
  M = 'M',
  X = 'X'
}

export type LocationInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type Login = {
  __typename?: 'Login';
  login?: Maybe<LoginType>;
};

export type LoginType = {
  __typename?: 'LoginType';
  accessToken: Scalars['String'];
  idToken: Scalars['String'];
  refreshToken?: Maybe<Scalars['String']>;
  role: Roles;
  user: UserType;
};

export type LoginV2Input = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  guestSession?: InputMaybe<GuestSessionInput>;
  password: Scalars['String'];
  role?: InputMaybe<Roles>;
  username: Scalars['String'];
};

export type LoginV2Payload = {
  __typename?: 'LoginV2Payload';
  clientMutationId?: Maybe<Scalars['String']>;
  login: LoginType;
};

export type Logout = {
  __typename?: 'Logout';
  success?: Maybe<Scalars['Boolean']>;
};

export type MarkCarePlanViewedInput = {
  carePlan: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type MarkCarePlanViewedPayload = {
  __typename?: 'MarkCarePlanViewedPayload';
  carePlan?: Maybe<CarePlanNode>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type MarkNotificationStatusInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** @deprecated Notifications not sent to individual devices anymore */
  device?: InputMaybe<Scalars['String']>;
  notification: Scalars['ID'];
  status: NotificationReceiptStatus;
};

export type MarkNotificationStatusPayload = {
  __typename?: 'MarkNotificationStatusPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type MedicalRecordNode = Node & {
  __typename?: 'MedicalRecordNode';
  attachments: Array<Maybe<FileType>>;
  clinic?: Maybe<ClinicLocationType>;
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  submittedBy: UserType;
  submittedByCurrentUser: Scalars['Boolean'];
};

export type MedicalRecordNodeConnection = {
  __typename?: 'MedicalRecordNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MedicalRecordNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `MedicalRecordNode` and its cursor. */
export type MedicalRecordNodeEdge = {
  __typename?: 'MedicalRecordNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<MedicalRecordNode>;
};

/** An enumeration. */
export enum MedicationAdministrationMethods {
  Buccal = 'BUCCAL',
  Collar = 'COLLAR',
  Cutaneous = 'CUTANEOUS',
  Inhalation = 'INHALATION',
  /** Intramuscular Injection */
  InjectionMus = 'INJECTION_MUS',
  /** Intrathecal Injection */
  InjectionSpine = 'INJECTION_SPINE',
  /** Subcutaneous Injection */
  InjectionSub = 'INJECTION_SUB',
  /** Intravenous Injection */
  InjectionVein = 'INJECTION_VEIN',
  Nasal = 'NASAL',
  Nebulization = 'NEBULIZATION',
  /** Eye Drops */
  Ocular = 'OCULAR',
  OralCap = 'ORAL_CAP',
  OralChew = 'ORAL_CHEW',
  OralLiquid = 'ORAL_LIQUID',
  OralTab = 'ORAL_TAB',
  /** Ear Drops */
  Otic = 'OTIC',
  Rectal = 'RECTAL',
  Sublingual = 'SUBLINGUAL',
  Transdermal = 'TRANSDERMAL',
  Vaginal = 'VAGINAL'
}

export type MedicationCategoryNode = Node & {
  __typename?: 'MedicationCategoryNode';
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type MedicationCategoryNodeConnection = {
  __typename?: 'MedicationCategoryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MedicationCategoryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `MedicationCategoryNode` and its cursor. */
export type MedicationCategoryNodeEdge = {
  __typename?: 'MedicationCategoryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<MedicationCategoryNode>;
};

export type MedicationDosageNode = Node & {
  __typename?: 'MedicationDosageNode';
  administrationMethod: MedicationAdministrationMethods;
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  /** <strength> / <liquid_strength_volume> mL; null if medication is not a liquid */
  liquidStrengthVolume?: Maybe<Scalars['Decimal']>;
  petType: PetTypes;
  /** in mg */
  strength: Scalars['Decimal'];
  /** Defaults to parent medication's instructions */
  usageDirections: Scalars['String'];
};

export type MedicationDosageNodeConnection = {
  __typename?: 'MedicationDosageNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MedicationDosageNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `MedicationDosageNode` and its cursor. */
export type MedicationDosageNodeEdge = {
  __typename?: 'MedicationDosageNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<MedicationDosageNode>;
};

export type MedicationNode = Node & {
  __typename?: 'MedicationNode';
  categories: MedicationCategoryNodeConnection;
  /** Brand name(s) or colloquial references (ex: 'Z-pak') */
  commonAliases: Array<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  dosages: MedicationDosageNodeConnection;
  /** The ID of the object */
  id: Scalars['ID'];
  interactions: Array<DrugInteractionNode>;
  isApproved: Scalars['Boolean'];
  isControlled: Scalars['Boolean'];
  isPrescriptionRequired: Scalars['Boolean'];
  /** Actual medication name; not the brand name. */
  name: Scalars['String'];
  usageDirections: Scalars['String'];
};


export type MedicationNodeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MedicationNodeDosagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type MedicationNodeConnection = {
  __typename?: 'MedicationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MedicationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `MedicationNode` and its cursor. */
export type MedicationNodeEdge = {
  __typename?: 'MedicationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<MedicationNode>;
};

export type MemberLocationInput = {
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/**
 * This is a scope limited user type for use with relations where the
 * requesting user should not have complete access to all user fields
 */
export type MemberType = {
  __typename?: 'MemberType';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  lastIosActivityAt?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  location?: Maybe<AddressType>;
};

/**
 * The `Membership` is the telemedicine related set of features; not to be confused
 * with the `UserMembership` which is the collection of features a user can access.
 */
export type Membership = MembershipFeatures & PurchasedTierInterface & SubscribedFeatureInterface & {
  __typename?: 'Membership';
  activatedAt?: Maybe<Scalars['DateTime']>;
  bundle?: Maybe<FeatureBundle>;
  downgradeOptions: Array<SubscribableFeatureInterface>;
  partner?: Maybe<PartnerNode>;
  price?: Maybe<PriceNode>;
  purchaseAmount?: Maybe<Scalars['Decimal']>;
  purchasedAt?: Maybe<Scalars['DateTime']>;
  requiresUserAction: Scalars['Boolean'];
  subscription?: Maybe<SubscriptionNode>;
  subsidized: Scalars['Boolean'];
  terminatedAt?: Maybe<Scalars['DateTime']>;
  textChat: FeatureAvailability;
  /** Feature user currently is subscribed to, or the default freemium config if user has no paid membership. If in the context of a quote this will populate the feature the user will be subscribed to. */
  tier: MembershipTierConfig;
  trialDuration?: Maybe<Scalars['Duration']>;
  trialEndsAt?: Maybe<Scalars['DateTime']>;
  trialing: Scalars['Boolean'];
  upgradeOptions: Array<SubscribableFeatureInterface>;
  videoCalls: FeatureAvailability;
};


/**
 * The `Membership` is the telemedicine related set of features; not to be confused
 * with the `UserMembership` which is the collection of features a user can access.
 */
export type MembershipDowngradeOptionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


/**
 * The `Membership` is the telemedicine related set of features; not to be confused
 * with the `UserMembership` which is the collection of features a user can access.
 */
export type MembershipUpgradeOptionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type MembershipCheckoutType = {
  __typename?: 'MembershipCheckoutType';
  discount: Scalars['Decimal'];
  /** All line items in this checkout (both recurring and one-off). */
  lineItems: Array<CheckoutLineItem>;
  subsidy: Scalars['Decimal'];
  subtotal: Scalars['Decimal'];
  total: Scalars['Decimal'];
};

export type MembershipFeatures = {
  textChat: FeatureAvailability;
  /** Feature user currently is subscribed to, or the default freemium config if user has no paid membership. If in the context of a quote this will populate the feature the user will be subscribed to. */
  tier: MembershipTierConfig;
  videoCalls: FeatureAvailability;
};

export type MembershipQuote = {
  __typename?: 'MembershipQuote';
  checkouts: Array<MembershipCheckoutType>;
  status: MembershipStatus;
};

export type MembershipQuoteLine = MembershipFeatures & QuoteLineInterface & RenewalQuoteLineInterface & SubscribableQuoteLineInterface & {
  __typename?: 'MembershipQuoteLine';
  /** Amount user needs to pay at checkout. */
  amountDue: Scalars['Decimal'];
  /** Current net price the user pays, if any. */
  currentNetPrice?: Maybe<Scalars['Decimal']>;
  /** What the user currently pays for this feature, if any. */
  currentPrice?: Maybe<Scalars['Decimal']>;
  /** Current subsidy amount, if any. */
  currentSubsidy?: Maybe<Scalars['Decimal']>;
  discount: Scalars['Decimal'];
  existingSubscription?: Maybe<SubscriptionNode>;
  feature: MembershipTierConfig;
  missingOrIncompletePetFields: Array<IncompletePetDataType>;
  /** List of pet attributes required to checkout. Omits fields already properly set. */
  missingOrIncompleteUserFields: Array<ActionRequiredUserFields>;
  netPrice: Scalars['Decimal'];
  price: Scalars['Decimal'];
  /** Null if this is fully subsidized. */
  renewalCadence?: Maybe<RenewalCadence>;
  subsidizedBy?: Maybe<PartnerNode>;
  subsidy: Scalars['Decimal'];
  textChat: FeatureAvailability;
  /** Feature user currently is subscribed to, or the default freemium config if user has no paid membership. If in the context of a quote this will populate the feature the user will be subscribed to. */
  tier: MembershipTierConfig;
  videoCalls: FeatureAvailability;
};

/** An enumeration. */
export enum MembershipStatus {
  Free = 'FREE',
  Inactive = 'INACTIVE',
  Paid = 'PAID'
}

export type MembershipTierConfig = Node & SubscribableFeatureInterface & {
  __typename?: 'MembershipTierConfig';
  defaultRenewalCadence: RenewalCadence;
  description: Scalars['String'];
  id: Scalars['ID'];
  /** Null implies unlimited */
  maxTextChatsPerMonth?: Maybe<Scalars['Int']>;
  /** Null implies unlimited */
  maxVideoCallsPerMonth?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  slug: Scalars['Slug'];
};

export type MessageAttachmentPaginatedType = {
  __typename?: 'MessageAttachmentPaginatedType';
  attachments?: Maybe<Array<Maybe<MessageAttachmentType>>>;
  count: Scalars['Int'];
  hasNext: Scalars['Boolean'];
  pages: Scalars['Int'];
};

export type MessageAttachmentType = {
  __typename?: 'MessageAttachmentType';
  attachment?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  medicalRecord?: Maybe<MedicalRecordNode>;
  twilioContentType: Scalars['String'];
  twilioFilename: Scalars['String'];
  twilioSid: Scalars['String'];
};

export type MessagePaginatedType = {
  __typename?: 'MessagePaginatedType';
  hasNext?: Maybe<Scalars['Boolean']>;
  messages?: Maybe<Array<Maybe<MessageType>>>;
  pages?: Maybe<Scalars['Int']>;
};

export type MessageType = {
  __typename?: 'MessageType';
  attachments?: Maybe<Array<MessageAttachmentType>>;
  attributes: Scalars['JSONString'];
  body?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  index: Scalars['Int'];
  senderId: Scalars['String'];
  /** @deprecated Replaced by 'attributes' */
  twilioAttributes: Scalars['JSONString'];
  /** @deprecated Replaced by 'body' */
  twilioBody?: Maybe<Scalars['String']>;
  twilioCreatedAt: Scalars['DateTime'];
  /** @deprecated Replace by 'index' */
  twilioIndex: Scalars['Int'];
  twilioReceiverId?: Maybe<Scalars['String']>;
  /** @deprecated Replaced by 'sender_id' */
  twilioSenderId: Scalars['String'];
};

export type MetadataInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

/** An enumeration. */
export enum MethodTypes {
  Ach = 'ACH',
  Check = 'CHECK'
}

export type MicrochipInput = {
  brand?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type MobileVersionsType = {
  __typename?: 'MobileVersionsType';
  recommendedMinimumVersion?: Maybe<Scalars['String']>;
  requiredMinimumVersion?: Maybe<Scalars['String']>;
};

export type ModelFilters = {
  __typename?: 'ModelFilters';
  facetFilters?: Maybe<Array<Array<Scalars['String']>>>;
};

export type ModelPetDetailNode = Node & PetDetailInterface & {
  __typename?: 'ModelPetDetailNode';
  aggregatedValues?: Maybe<Array<PetDetailNode>>;
  createdAt: Scalars['DateTime'];
  diagnosticQuestion: DiagnosticQuestionNode;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  meetsTarget?: Maybe<Scalars['Boolean']>;
  modelValue?: Maybe<Node>;
  occurredAfter?: Maybe<Scalars['DateTime']>;
  occurredBefore?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  slug: Scalars['String'];
  staleAt?: Maybe<Scalars['DateTime']>;
  triggersInPersonVisit?: Maybe<Scalars['Boolean']>;
  triggersLiveVisit?: Maybe<Scalars['Boolean']>;
};

export type ModifyBundleInput = {
  bundle: Scalars['Slug'];
  renewalCadence?: InputMaybe<ModifyRenewalCadenceOptions>;
  /** Will auto select a subsidizer if user has one. Setting this is only necessary if client wants to force a specific subsidizer. */
  subsidizedBy?: InputMaybe<Scalars['Slug']>;
  trial?: InputMaybe<TrialOptions>;
};

export type ModifyEmergencyProtectionInput = {
  ignoreSubsidizerChecks?: InputMaybe<Scalars['Boolean']>;
  pets?: InputMaybe<Array<Scalars['ID']>>;
  renewalCadence?: InputMaybe<ModifyRenewalCadenceOptions>;
  /** Will auto select a subsidizer if user has one. Setting this is only necessary if client wants to force a specific subsidizer. */
  subsidizedBy?: InputMaybe<Scalars['Slug']>;
  trial?: InputMaybe<TrialOptions>;
};

export type ModifyMembershipInput = {
  ignoreSubsidizerChecks?: InputMaybe<Scalars['Boolean']>;
  renewalCadence?: InputMaybe<ModifyRenewalCadenceOptions>;
  /** Will auto select a subsidizer if user has one. Setting this is only necessary if client wants to force a specific subsidizer. */
  subsidizedBy?: InputMaybe<Scalars['Slug']>;
  /** If null will fall back to user's existing tier. */
  tier?: InputMaybe<Scalars['Slug']>;
  trial?: InputMaybe<TrialOptions>;
};

/** An enumeration. */
export enum ModifyRenewalCadenceOptions {
  /** If user already has a subscription use the billing cadence from that; falls back to DEFAULT */
  Current = 'CURRENT',
  /** Use the feature config's default renewal cadence */
  Default = 'DEFAULT',
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY'
}

export type Mutation = {
  __typename?: 'Mutation';
  acknowledgeRejectedClaimRequest?: Maybe<AcknowledgeRejectedClaimRequestPayload>;
  activateAddOn?: Maybe<ActivateAddOnPayload>;
  /** Specific mutaion to add the different type of clinics (primary, secondary, etc) */
  addClinicPetDetail?: Maybe<AddClinicPetDetailPayload>;
  addExternalPaymentMethod?: Maybe<AddExternalPaymentMethodPayload>;
  /** Specific mutation to add multiple model_value pet details */
  addModelPetDetails?: Maybe<AddModelPetDetailsPayload>;
  addOrUpdateUserState?: Maybe<AddOrUpdateUserState>;
  addPaymentMethod?: Maybe<AddPaymentMethodPayload>;
  addPetDetailEntry?: Maybe<AddPetDetailEntryPayload>;
  addUserActivity?: Maybe<AddUserActivity>;
  authorizationCodeLogin?: Maybe<AuthorizationCodeLoginPayload>;
  bookRxWithPurchaseConsumable?: Maybe<BookRxWithPurchaseConsumablePayload>;
  cancelAutoshipPlan?: Maybe<CancelAutoshipPlanPayload>;
  cancelBooking?: Maybe<CancelBookingPayload>;
  cancelBundle?: Maybe<CancelBundlePayload>;
  cancelClaimRequest?: Maybe<CancelClaimRequestPayload>;
  cancelFeature?: Maybe<CancelFeaturePayload>;
  changeCurrentRole?: Maybe<ChangeCurrentRolePayload>;
  changePassword?: Maybe<ChangePassword>;
  checkInToBooking?: Maybe<CheckInToBookingPayload>;
  checkout?: Maybe<Checkout>;
  completeAction?: Maybe<CompleteActionPayload>;
  completeClientUpload?: Maybe<CompleteClientUploadPayload>;
  configureFeatures?: Maybe<ConfigureFeaturesPayload>;
  configureMembership?: Maybe<ConfigureMembershipPayload>;
  confirmBooking?: Maybe<ConfirmBookingPayload>;
  /**
   * Connects a guest to a partner if it has not been already connected
   * with another partner
   */
  connectUserToPartner?: Maybe<ConnectUserToPartnerPayload>;
  createAssessmentResultFollowUp?: Maybe<CreateAssessmentResultFollowUpPayload>;
  createCheckinResultFollowUp?: Maybe<CreateCheckInResultFollowUpPayload>;
  createClaimRequest?: Maybe<CreateClaimRequestPayload>;
  createClinicLocation?: Maybe<CreateClinicLocationPayload>;
  createConversationFromSymptomCheckerResult?: Maybe<CreateConversationFromSymptomCheckerResult>;
  createConversationV2?: Maybe<CreateConversationV2>;
  createInitialAssessmentFromPet?: Maybe<CreateInitialAssessmentFromPetPayload>;
  createInsightVisitFollowUp?: Maybe<CreateInsightVisitFollowUpPayload>;
  createLoginAuthorizationCode?: Maybe<CreateLoginAuthorizationCodePayload>;
  createPet?: Maybe<CreatePet>;
  createRxBooking?: Maybe<CreateRxBookingPayload>;
  createShippingAddress?: Maybe<CreateShippingAddress>;
  createSymptomCheckerFollowUpFromConversation?: Maybe<CreateSymptomCheckerFollowUpFromConversationPayload>;
  createSymptomCheckerForPet?: Maybe<CreateSymptomCheckerForPetPayload>;
  deletePet?: Maybe<DeletePet>;
  /** Used to soft delete pet details by current user. */
  deletePetDetail?: Maybe<DeletePetDetailPayload>;
  deletePetMedicalRecord?: Maybe<DeletePetMedicalRecordPayload>;
  deleteShippingAddress?: Maybe<DeleteShippingAddress>;
  deleteUser?: Maybe<DeleteUser>;
  doRxBookingIntake?: Maybe<DoRxBookingIntakePayload>;
  endConversationV2?: Maybe<EndConversationV2>;
  endVideoV2?: Maybe<EndVideoV2>;
  escalateTriageConversation?: Maybe<EscalateTriageConversationPayload>;
  forgotPassword?: Maybe<ForgotPassword>;
  /**
   * Generate a purchasable external URL for selected IIPQuote estimate(s).
   * Creates or updates the BindableQuote with the external URL.
   */
  generateExternalQuote?: Maybe<GenerateExternalQuotePayload>;
  generateIipQuotes?: Maybe<GenerateIipQuotesPayload>;
  initiateClientUpload?: Maybe<InitiateClientUploadPayload>;
  insertClinic?: Maybe<InsertClinicNodePayload>;
  /** Deprecated - here for backwards compatibility with product_v2 */
  insertClinicV2?: Maybe<InsertClinicNodeV2>;
  /** Deprecated - here for backwards compatibility with product_v2 */
  insertPrescription?: Maybe<InsertPrescriptionNodePayload>;
  issueIipPolicy?: Maybe<IssueIipPolicyPayload>;
  joinBookingWaitlist?: Maybe<JoinBookingWaitlistPayload>;
  /**
   * Lets a member create feedback on a conversation
   * the feedback they leave is not visible to the other conversation
   * participants
   */
  leaveConversationFeedbackMember?: Maybe<LeaveConversationFeedbackMember>;
  /** @deprecated Replaced by LoginV2 */
  login?: Maybe<Login>;
  loginV2: LoginV2Payload;
  logout?: Maybe<Logout>;
  markCarePlanViewed?: Maybe<MarkCarePlanViewedPayload>;
  markNotificationStatus?: Maybe<MarkNotificationStatusPayload>;
  nextQuestionGroup?: Maybe<NextPayload>;
  preCheckout?: Maybe<PreCheckout>;
  previousQuestionGroup?: Maybe<PreviousPayload>;
  quoteFeatures?: Maybe<QuoteFeaturesPayload>;
  recordUserConsent?: Maybe<RecordUserConsentPayload>;
  refreshTokens?: Maybe<RefreshTokens>;
  /** Register a user device - used for sending push notifications. */
  registerDevice?: Maybe<RegisterDevicePayload>;
  releasePhoneNumber?: Maybe<ReleasePhoneNumberPayload>;
  removeAddOn?: Maybe<RemoveAddOnPayload>;
  removeClaimRequestAttachments?: Maybe<RemoveClaimRequestAttachmentsPayload>;
  requestGuestSession?: Maybe<RequestGuestSession>;
  requestTwilioAccessToken?: Maybe<RequestTwilioAccessToken>;
  requestVideoV2?: Maybe<RequestVideoV2>;
  rescheduleBooking?: Maybe<RescheduleBookingPayload>;
  resetPassword?: Maybe<ResetPassword>;
  /** Used to resolve a pet detail */
  resolvePetDetail?: Maybe<ResolvePetDetailPayload>;
  reviveAddOn?: Maybe<CoreReviveAddOnPayload>;
  reviveUserPlan?: Maybe<CoreReviveUserPlanPayload>;
  saveCarePlanActionFeedback?: Maybe<SaveCarePlanActionFeedbackPayload>;
  saveInPersonVisitResult?: Maybe<SaveInPersonVisitResultPayload>;
  savePetDetail?: Maybe<SavePetDetailPayload>;
  saveUserSatisfactionSurvey?: Maybe<SaveUserSatisfactionSurveyPayload>;
  /** @deprecated Replaced by sendOtp */
  sendEmailVerificationCode?: Maybe<SendEmailVerificationCode>;
  sendOtp: SendOtpPayload;
  setUserPlan?: Maybe<SetUserPlanPayload>;
  signupV2: SignupV2Payload;
  startPeriodicCheckin?: Maybe<StartPeriodicCheckinPayload>;
  submitClaimRequest?: Maybe<SubmitClaimRequestPayload>;
  submitClaimRequestPaymentMethod?: Maybe<SubmitClaimRequestPaymentMethodPayload>;
  submitClinicLocationRating?: Maybe<SubmitRating>;
  suggestProductFamily?: Maybe<SuggestProductFamilyPayload>;
  /** Track lifecycle events for pet insights. */
  trackPetInsightEvents?: Maybe<TrackPetInsightEventsPayload>;
  unsubscribeFromMarketingEmails?: Maybe<UnsubscribeFromMarketingEmails>;
  updateAutoshipPlan?: Maybe<UpdateAutoshipPlanPayload>;
  updateCart?: Maybe<UpdateCart>;
  updateClaimRequest?: Maybe<UpdateClaimRequestPayload>;
  updateClinic?: Maybe<UpdateClinicNodePayload>;
  updateConversation?: Maybe<UpdateConversation>;
  /** @deprecated Replaced by sendOtp */
  updateEmail: UpdateEmailPayload;
  updateEmergencyFundPolicyPets?: Maybe<UpdateEmergencyFundPolicyPetsPayload>;
  updatePeriodicCheckIn?: Maybe<UpdatePeriodicCheckInPayload>;
  updatePet?: Maybe<UpdatePet>;
  updatePetMedicalRecord?: Maybe<UpdatePetMedicalRecordPayload>;
  updateShippingAddress?: Maybe<UpdateShippingAddress>;
  updateUser?: Maybe<UpdateUser>;
  uploadClaimRequestAttachment?: Maybe<UploadClaimRequestAttachmentPayload>;
  uploadPetMedicalRecord?: Maybe<UploadPetMedicalRecordPayload>;
  /** @deprecated Replaced by verifyOtp */
  verifyEmail?: Maybe<VerifyEmail>;
  verifyIdentifiedGuest?: Maybe<VerifyIdentifiedGuest>;
  /**
   * We can use this for verifying any non-login/signup code. It could be useful
   * for anything that requires extra verification. Currently only supports changing emails and
   * verifying emails but in the future could be extended to other tasks like deleting an account.
   */
  verifyOtp: VerifyOtpPayload;
};


export type MutationAcknowledgeRejectedClaimRequestArgs = {
  input: AcknowledgeRejectedClaimRequestInput;
};


export type MutationActivateAddOnArgs = {
  input: ActivateAddOnInput;
};


export type MutationAddClinicPetDetailArgs = {
  input: AddClinicPetDetailInput;
};


export type MutationAddExternalPaymentMethodArgs = {
  input: AddExternalPaymentMethodInput;
};


export type MutationAddModelPetDetailsArgs = {
  input: AddModelPetDetailsInput;
};


export type MutationAddOrUpdateUserStateArgs = {
  key: Scalars['String'];
  value: Scalars['String'];
};


export type MutationAddPaymentMethodArgs = {
  input: AddPaymentMethodInput;
};


export type MutationAddPetDetailEntryArgs = {
  input: AddPetDetailEntryInput;
};


export type MutationAddUserActivityArgs = {
  activityType: Scalars['String'];
  metadata?: InputMaybe<Array<InputMaybe<MetadataInput>>>;
  target?: InputMaybe<GenericInstanceInput>;
};


export type MutationAuthorizationCodeLoginArgs = {
  input: AuthorizationCodeLoginInput;
};


export type MutationBookRxWithPurchaseConsumableArgs = {
  input: BookRxWithPurchaseConsumableInput;
};


export type MutationCancelAutoshipPlanArgs = {
  input: CancelAutoshipPlanInput;
};


export type MutationCancelBookingArgs = {
  input: CancelBookingInput;
};


export type MutationCancelBundleArgs = {
  input: CancelBundleInput;
};


export type MutationCancelClaimRequestArgs = {
  input: CancelClaimRequestInput;
};


export type MutationCancelFeatureArgs = {
  input: CancelFeatureInput;
};


export type MutationChangeCurrentRoleArgs = {
  input: ChangeCurrentRoleInput;
};


export type MutationChangePasswordArgs = {
  accessToken?: InputMaybe<Scalars['String']>;
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};


export type MutationCheckInToBookingArgs = {
  input: CheckInToBookingInput;
};


export type MutationCheckoutArgs = {
  input?: InputMaybe<CheckoutInput>;
  paymentMethodId?: InputMaybe<Scalars['ID']>;
};


export type MutationCompleteActionArgs = {
  input: CompleteActionInput;
};


export type MutationCompleteClientUploadArgs = {
  input: CompleteClientUploadInput;
};


export type MutationConfigureFeaturesArgs = {
  input: ConfigureFeaturesInput;
};


export type MutationConfigureMembershipArgs = {
  input: ConfigureMembershipInput;
};


export type MutationConfirmBookingArgs = {
  input: ConfirmBookingInput;
};


export type MutationConnectUserToPartnerArgs = {
  input: ConnectUserToPartnerInput;
};


export type MutationCreateAssessmentResultFollowUpArgs = {
  input: CreateAssessmentResultFollowUpInput;
};


export type MutationCreateCheckinResultFollowUpArgs = {
  input: CreateCheckInResultFollowUpInput;
};


export type MutationCreateClaimRequestArgs = {
  input: CreateClaimRequestInput;
};


export type MutationCreateClinicLocationArgs = {
  input: CreateClinicLocationInput;
};


export type MutationCreateConversationFromSymptomCheckerResultArgs = {
  petSymptomCheckerResultId: Scalars['ID'];
  requesterVideoAspectRatio?: InputMaybe<Scalars['String']>;
};


export type MutationCreateConversationV2Args = {
  emergencyRequestQuestionnaire?: InputMaybe<EmergencyRequestQuestionnaireInput>;
  pets: Array<Scalars['ID']>;
  requestLevel: ConversationRequestLevel;
  requesterVideoAspectRatio?: InputMaybe<Scalars['String']>;
  topicId?: InputMaybe<Scalars['ID']>;
  topicIdentifier?: InputMaybe<Scalars['String']>;
};


export type MutationCreateInitialAssessmentFromPetArgs = {
  input: CreateInitialAssessmentFromPetInput;
};


export type MutationCreateInsightVisitFollowUpArgs = {
  input: CreateInsightVisitFollowUpInput;
};


export type MutationCreateLoginAuthorizationCodeArgs = {
  input: CreateLoginAuthorizationCodeInput;
};


export type MutationCreatePetArgs = {
  activityLevel?: InputMaybe<Scalars['Int']>;
  adoptionMethod?: InputMaybe<Scalars['String']>;
  allergies?: InputMaybe<Array<Scalars['ID']>>;
  birthday?: InputMaybe<BirthdayInput>;
  bodyType?: InputMaybe<Scalars['Int']>;
  breed?: InputMaybe<Scalars['ID']>;
  coatColor?: InputMaybe<Array<PetCoatColor>>;
  conditions?: InputMaybe<Array<Scalars['ID']>>;
  eyeColor?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  healthGoals?: InputMaybe<Array<Scalars['ID']>>;
  hometown?: InputMaybe<LocationInput>;
  isSpayedOrNeutered?: InputMaybe<Scalars['Boolean']>;
  microchip?: InputMaybe<MicrochipInput>;
  name: Scalars['String'];
  nickname?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<Scalars['ImageUpload']>;
  rabies?: InputMaybe<RabiesInput>;
  scents?: InputMaybe<Array<Scalars['ID']>>;
  type?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
};


export type MutationCreateRxBookingArgs = {
  input: CreateRxBookingInput;
};


export type MutationCreateShippingAddressArgs = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  firstName: Scalars['String'];
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};


export type MutationCreateSymptomCheckerFollowUpFromConversationArgs = {
  input: CreateSymptomCheckerFollowUpFromConversationInput;
};


export type MutationCreateSymptomCheckerForPetArgs = {
  input: CreateSymptomCheckerForPetInput;
};


export type MutationDeletePetArgs = {
  pk: Scalars['ID'];
};


export type MutationDeletePetDetailArgs = {
  input: DeletePetDetailInput;
};


export type MutationDeletePetMedicalRecordArgs = {
  input: DeletePetMedicalRecordInput;
};


export type MutationDeleteShippingAddressArgs = {
  pk: Scalars['ID'];
};


export type MutationDeleteUserArgs = {
  accessToken: Scalars['String'];
};


export type MutationDoRxBookingIntakeArgs = {
  input: DoRxBookingIntakeInput;
};


export type MutationEndConversationV2Args = {
  conversationId: Scalars['ID'];
};


export type MutationEndVideoV2Args = {
  conversationId: Scalars['ID'];
};


export type MutationEscalateTriageConversationArgs = {
  input: EscalateTriageConversationInput;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationGenerateExternalQuoteArgs = {
  input: GenerateExternalQuoteInput;
};


export type MutationGenerateIipQuotesArgs = {
  input: GenerateIipQuotesInput;
};


export type MutationInitiateClientUploadArgs = {
  input: InitiateClientUploadInput;
};


export type MutationInsertClinicArgs = {
  input: InsertClinicNodeInput;
};


export type MutationInsertClinicV2Args = {
  forceSync?: InputMaybe<Scalars['Boolean']>;
  googlePlaceId: Scalars['String'];
};


export type MutationInsertPrescriptionArgs = {
  input: InsertPrescriptionNodeInput;
};


export type MutationIssueIipPolicyArgs = {
  input: IssueIipPolicyInput;
};


export type MutationJoinBookingWaitlistArgs = {
  input: JoinBookingWaitlistInput;
};


export type MutationLeaveConversationFeedbackMemberArgs = {
  conversationId: Scalars['ID'];
  feedbackComments?: InputMaybe<Scalars['String']>;
  otherParticipantRating?: InputMaybe<Scalars['Int']>;
};


export type MutationLoginArgs = {
  email: Scalars['String'];
  guestSession?: InputMaybe<GuestSessionInput>;
  password: Scalars['String'];
  role?: InputMaybe<Roles>;
};


export type MutationLoginV2Args = {
  input: LoginV2Input;
};


export type MutationLogoutArgs = {
  refreshToken?: InputMaybe<Scalars['String']>;
};


export type MutationMarkCarePlanViewedArgs = {
  input: MarkCarePlanViewedInput;
};


export type MutationMarkNotificationStatusArgs = {
  input: MarkNotificationStatusInput;
};


export type MutationNextQuestionGroupArgs = {
  input: NextInput;
};


export type MutationPreCheckoutArgs = {
  input?: InputMaybe<PreCheckoutInput>;
  shippingAddressId?: InputMaybe<Scalars['ID']>;
};


export type MutationPreviousQuestionGroupArgs = {
  input: PreviousInput;
};


export type MutationQuoteFeaturesArgs = {
  input: QuoteFeaturesInput;
};


export type MutationRecordUserConsentArgs = {
  input: RecordUserConsentInput;
};


export type MutationRefreshTokensArgs = {
  refreshToken: Scalars['String'];
};


export type MutationRegisterDeviceArgs = {
  input: RegisterDeviceInput;
};


export type MutationReleasePhoneNumberArgs = {
  input: ReleasePhoneNumberInput;
};


export type MutationRemoveAddOnArgs = {
  input: RemoveAddOnInput;
};


export type MutationRemoveClaimRequestAttachmentsArgs = {
  input: RemoveClaimRequestAttachmentsInput;
};


export type MutationRequestGuestSessionArgs = {
  interaction?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};


export type MutationRequestTwilioAccessTokenArgs = {
  conversationId?: InputMaybe<Scalars['ID']>;
};


export type MutationRequestVideoV2Args = {
  conversationId: Scalars['ID'];
};


export type MutationRescheduleBookingArgs = {
  input: RescheduleBookingInput;
};


export type MutationResetPasswordArgs = {
  confirmationCode: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationResolvePetDetailArgs = {
  input: ResolvePetDetailInput;
};


export type MutationReviveAddOnArgs = {
  input: CoreReviveAddOnInput;
};


export type MutationReviveUserPlanArgs = {
  input: CoreReviveUserPlanInput;
};


export type MutationSaveCarePlanActionFeedbackArgs = {
  input: SaveCarePlanActionFeedbackInput;
};


export type MutationSaveInPersonVisitResultArgs = {
  input: SaveInPersonVisitResultInput;
};


export type MutationSavePetDetailArgs = {
  input: SavePetDetailInput;
};


export type MutationSaveUserSatisfactionSurveyArgs = {
  input: SaveUserSatisfactionSurveyInput;
};


export type MutationSendOtpArgs = {
  input: SendOtpInput;
};


export type MutationSetUserPlanArgs = {
  input: SetUserPlanInput;
};


export type MutationSignupV2Args = {
  input: SignupV2Input;
};


export type MutationStartPeriodicCheckinArgs = {
  input: StartPeriodicCheckinInput;
};


export type MutationSubmitClaimRequestArgs = {
  input: SubmitClaimRequestInput;
};


export type MutationSubmitClaimRequestPaymentMethodArgs = {
  input: SubmitClaimRequestPaymentMethodInput;
};


export type MutationSubmitClinicLocationRatingArgs = {
  clinicLocationId?: InputMaybe<Scalars['ID']>;
  clinicLocationObjectid?: InputMaybe<Scalars['ID']>;
  rating: Scalars['Int'];
  review?: InputMaybe<Scalars['String']>;
};


export type MutationSuggestProductFamilyArgs = {
  input: SuggestProductFamilyInput;
};


export type MutationTrackPetInsightEventsArgs = {
  input: TrackPetInsightEventsInput;
};


export type MutationUnsubscribeFromMarketingEmailsArgs = {
  email: Scalars['String'];
};


export type MutationUpdateAutoshipPlanArgs = {
  input: UpdateAutoshipPlanInput;
};


export type MutationUpdateCartArgs = {
  lineItems: Array<InputMaybe<UpdateCartLineItemInput>>;
};


export type MutationUpdateClaimRequestArgs = {
  input: UpdateClaimRequestInput;
};


export type MutationUpdateClinicArgs = {
  input: UpdateClinicNodeInput;
};


export type MutationUpdateConversationArgs = {
  memberLocation?: InputMaybe<MemberLocationInput>;
  pets?: InputMaybe<Array<Scalars['ID']>>;
  pk: Scalars['ID'];
  requesterVideoAspectRatio?: InputMaybe<Scalars['String']>;
  topic?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateEmailArgs = {
  input: UpdateEmailInput;
};


export type MutationUpdateEmergencyFundPolicyPetsArgs = {
  input: UpdateEmergencyFundPolicyPetsInput;
};


export type MutationUpdatePeriodicCheckInArgs = {
  input: UpdatePeriodicCheckInInput;
};


export type MutationUpdatePetArgs = {
  activityLevel?: InputMaybe<Scalars['Int']>;
  adoptionMethod?: InputMaybe<Scalars['String']>;
  adverseReactionsToMedicines?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  allHouseholdPetsTreatedForFleas?: InputMaybe<Scalars['Boolean']>;
  allergies?: InputMaybe<Array<Scalars['ID']>>;
  appetite?: InputMaybe<PetAppetite>;
  behavior?: InputMaybe<PetBehavior>;
  birthday?: InputMaybe<BirthdayInput>;
  bodyType?: InputMaybe<Scalars['Int']>;
  breed?: InputMaybe<Scalars['ID']>;
  breedingPregnantLactating?: InputMaybe<Scalars['Boolean']>;
  coatColor?: InputMaybe<Array<PetCoatColor>>;
  conditions?: InputMaybe<Array<Scalars['ID']>>;
  dateOfDeath?: InputMaybe<Scalars['Date']>;
  deletedFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eyeColor?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  habitat?: InputMaybe<PetHabitat>;
  hairLossLevel?: InputMaybe<Scalars['Int']>;
  healthAssessmentCadence?: InputMaybe<PetHealthAssessmentCadence>;
  healthGoals?: InputMaybe<Array<Scalars['ID']>>;
  hometown?: InputMaybe<LocationInput>;
  inContactWithNonHouseholdPetsOrYard?: InputMaybe<Scalars['Boolean']>;
  initialRoutinePromptViewed?: InputMaybe<Scalars['Boolean']>;
  isSpayedOrNeutered?: InputMaybe<Scalars['Boolean']>;
  itchLevel?: InputMaybe<Scalars['Int']>;
  lastFleaTickMedication?: InputMaybe<Scalars['DateTime']>;
  microchip?: InputMaybe<MicrochipInput>;
  name?: InputMaybe<Scalars['String']>;
  nameLastFleaTickMedication?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<Scalars['ImageUpload']>;
  pk: Scalars['ID'];
  preExistingEpilepsyConditions?: InputMaybe<Scalars['Boolean']>;
  profileCompletedAt?: InputMaybe<Scalars['DateTime']>;
  rabies?: InputMaybe<RabiesInput>;
  reasonForChangingFleaTickMedication?: InputMaybe<Scalars['String']>;
  routineResultsViewed?: InputMaybe<Scalars['Boolean']>;
  scents?: InputMaybe<Array<Scalars['ID']>>;
  takenFleaTickMedication?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  waterConsumption?: InputMaybe<PetWaterConsumption>;
  weight?: InputMaybe<Scalars['Float']>;
};


export type MutationUpdatePetMedicalRecordArgs = {
  input: UpdatePetMedicalRecordInput;
};


export type MutationUpdateShippingAddressArgs = {
  address2?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  pk: Scalars['ID'];
};


export type MutationUpdateUserArgs = {
  avatar?: InputMaybe<Scalars['ImageUpload']>;
  dob?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  intentForRx?: InputMaybe<Scalars['Boolean']>;
  interaction?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  legalSex?: InputMaybe<LegalSex>;
  location?: InputMaybe<LocationInput>;
  partner?: InputMaybe<Scalars['String']>;
  partnerCode?: InputMaybe<Scalars['String']>;
  partnerOauthCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  shouldReceiveMarketingSms?: InputMaybe<Scalars['Boolean']>;
  shouldReceiveTransactionalSms?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<Scalars['String']>;
};


export type MutationUploadClaimRequestAttachmentArgs = {
  input: UploadClaimRequestAttachmentInput;
};


export type MutationUploadPetMedicalRecordArgs = {
  input: UploadPetMedicalRecordInput;
};


export type MutationVerifyEmailArgs = {
  code: Scalars['String'];
};


export type MutationVerifyIdentifiedGuestArgs = {
  attemptSessionRetrieval?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  uri?: InputMaybe<Scalars['String']>;
};


export type MutationVerifyOtpArgs = {
  input: VerifyOtpInput;
};

export type NextInput = {
  answers?: InputMaybe<Array<InputMaybe<AnswerInput>>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  formResponse?: InputMaybe<Scalars['ID']>;
  formSlug: Scalars['String'];
  questionGroupSlug?: InputMaybe<Scalars['String']>;
};

export type NextPayload = {
  __typename?: 'NextPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  response: NextResponse;
};

export type NextResponse = QuestionGroupResponse | RedirectResponse;

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID'];
};

/** An enumeration. */
export enum NotificationReceiptStatus {
  Delivered = 'DELIVERED',
  Opened = 'OPENED'
}

/** An enumeration. */
export enum OrderCancelReason {
  /** Cancelled from parent cancellation */
  CascadeCancelled = 'CASCADE_CANCELLED',
  Customer = 'CUSTOMER',
  Declined = 'DECLINED',
  Fraud = 'FRAUD',
  Other = 'OTHER',
  PrescriptionRejected = 'PRESCRIPTION_REJECTED'
}

/** Deprecated - here for backwards compatibility with product_v2 */
export type OrderInvoiceNode = Node & {
  __typename?: 'OrderInvoiceNode';
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  invoice: InvoiceNode;
  updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum OrderLineCancelReason {
  Customer = 'CUSTOMER',
  Fraud = 'FRAUD',
  Inventory = 'INVENTORY',
  /** Order was cancelled or voided */
  OrderTerminated = 'ORDER_TERMINATED',
  Other = 'OTHER',
  PrescriptionRejected = 'PRESCRIPTION_REJECTED'
}

/** Deprecated - kept for backwards compatibility */
export type OrderLineItem = {
  __typename?: 'OrderLineItem';
  discount: Scalars['Decimal'];
  fulfillmentLineItems?: Maybe<Array<FulfillmentNode>>;
  id: Scalars['ID'];
  prescription?: Maybe<CorePrescriptionNode>;
  productVariant: ProductVariantNode;
  quantity: Scalars['Int'];
  subtotal: Scalars['Decimal'];
  tax: Scalars['Decimal'];
  total: Scalars['Decimal'];
};

export type OrderLineNode = Node & {
  __typename?: 'OrderLineNode';
  cancelReason?: Maybe<OrderLineCancelReason>;
  context: Scalars['JSONString'];
  discount: Scalars['Decimal'];
  fulfillments: FulfillmentNodeConnection;
  /** The ID of the object */
  id: Scalars['ID'];
  order?: Maybe<OrderV2Node>;
  prescription?: Maybe<CorePrescriptionNode>;
  price: PriceNode;
  product: ProductNode;
  quantity: Scalars['Int'];
  shipping: Scalars['Decimal'];
  status: OrderLineStatus;
  subtotal: Scalars['Decimal'];
  /** Null if tax has not been calculated yet */
  tax?: Maybe<Scalars['Decimal']>;
  total: Scalars['Decimal'];
};


export type OrderLineNodeFulfillmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  shipmentStatus?: InputMaybe<FulfillmentShipmentStatus>;
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export type OrderLineNodeConnection = {
  __typename?: 'OrderLineNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrderLineNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `OrderLineNode` and its cursor. */
export type OrderLineNodeEdge = {
  __typename?: 'OrderLineNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<OrderLineNode>;
};

/**
 * DRAFT: The line item is still editable (Order has not been placed yet)
 * UNPAID: The cart has been created but payment has not been collected for the order yet
 * INTERNAL_RX_VERIFICATION: the user wants to use a `prescription.Prescription` that
 *     is still pending approval / rejection from an internal vet yet
 * RX_VERIFICATION: the order contains line item(s) that required prescriptions
 *     that need to be validated and approved by a third party before the order can
 *     be fulfilled
 * PENDING_FULFILLMENT: all RXes (if any) have been approved and we are waiting for the
 *     supplier to process and ship the order
 * PARTIALLY_FULFILLED: some quantity of the total quantity have been shipped
 * FULFILLED: the full line item has been shipped to the user
 * CANCELLED: user cancelled the line item (can only cancel an order BEFORE it gets to the
 *     FULFILLED status)
 * VOIDED: the line item was cancelled for some reason by Pawp (RX rejected or no
 *     inventory) and a refund was issued.
 */
export enum OrderLineStatus {
  /** Cancelled by the user */
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Fulfilled = 'FULFILLED',
  InternalRxVerification = 'INTERNAL_RX_VERIFICATION',
  PartiallyFulfilled = 'PARTIALLY_FULFILLED',
  PendingFulfillment = 'PENDING_FULFILLMENT',
  RxVerification = 'RX_VERIFICATION',
  Unpaid = 'UNPAID',
  /** Cancelled by Pawp */
  Voided = 'VOIDED'
}

/** Deprecated - here for backwards compatibility with product_v2 */
export type OrderNode = Node & {
  __typename?: 'OrderNode';
  autoshipPlan?: Maybe<AutoshipPlanNode>;
  cancelReason?: Maybe<OrderCancelReason>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  customerEmail: Scalars['String'];
  customerPhoneNumber?: Maybe<Scalars['String']>;
  fulfillments?: Maybe<Array<FulfillmentNode>>;
  /** The ID of the object */
  id: Scalars['ID'];
  invoices?: Maybe<Array<Maybe<OrderInvoiceNode>>>;
  lineItems?: Maybe<Array<OrderLineItem>>;
  meta?: Maybe<OrderNodeMeta>;
  orderNumber?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<PaymentMethodNode>;
  purchaser: UserType;
  shippingAddress: ShippingAddressType;
  status: OrderStatus;
  /** Total for line items before discounts or tax */
  subtotal: Scalars['Decimal'];
  totalDiscount: Scalars['Decimal'];
  totalPrice: Scalars['Decimal'];
  totalShipping: Scalars['Decimal'];
  totalTax: Scalars['Decimal'];
  updatedAt: Scalars['DateTime'];
};

export type OrderNodeConnection = {
  __typename?: 'OrderNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrderNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `OrderNode` and its cursor. */
export type OrderNodeEdge = {
  __typename?: 'OrderNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<OrderNode>;
};

export type OrderNodeMeta = {
  __typename?: 'OrderNodeMeta';
  stripeId?: Maybe<Scalars['String']>;
};

/**
 * PAYMENT_FAILED: the user's payment failed. The user can only update the payment
 *     method or billing information at this point.
 * PAID: the order has been successfully paid for and is going to be handed off for
 *     fulfillment
 * FULFILLED: all line items expected to fulfill have been fulfilled
 * CANCELLED: user cancelled the order (can only cancel an order BEFORE it gets to the
 *     FULFILLED status)
 * VOIDED: the order was cancelled for some reason by Pawp (RX rejected or no
 *     inventory) and a refund was issued.
 */
export enum OrderStatus {
  /** Cancelled by the user */
  Cancelled = 'CANCELLED',
  Checkout = 'CHECKOUT',
  /** All line items fulfilled */
  Fulfilled = 'FULFILLED',
  Paid = 'PAID',
  PaymentFailed = 'PAYMENT_FAILED',
  /** Cancelled by Pawp */
  Voided = 'VOIDED'
}

export type OrderV2Node = Node & {
  __typename?: 'OrderV2Node';
  autoship?: Maybe<AutoshipPlanNode>;
  cancelReason?: Maybe<OrderCancelReason>;
  createdAt: Scalars['DateTime'];
  discount: Scalars['Decimal'];
  /** The ID of the object */
  id: Scalars['ID'];
  invoice: InvoiceNode;
  lineItems: OrderLineNodeConnection;
  orderNumber?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<PaymentMethodNode>;
  shipping?: Maybe<Scalars['Decimal']>;
  status: OrderStatus;
  /** Total for line items before discounts or tax */
  subtotal: Scalars['Decimal'];
  /** Null if tax has not been calculated yet */
  tax?: Maybe<Scalars['Decimal']>;
  /** Final total after accounting for discounts, tax and shipping */
  total: Scalars['Decimal'];
  user: UserType;
};


export type OrderV2NodeLineItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type OwnerPaymentMethodConnection = {
  __typename?: 'OwnerPaymentMethodConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OwnerPaymentMethodEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OwnerPaymentMethod` and its cursor. */
export type OwnerPaymentMethodEdge = {
  __typename?: 'OwnerPaymentMethodEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  isDefault?: Maybe<Scalars['Boolean']>;
  /** The item at the end of the edge */
  node?: Maybe<PaymentMethodNode>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum PartnerClaimMethod {
  Admin = 'ADMIN',
  Code = 'CODE',
  EmailVerification = 'EMAIL_VERIFICATION',
  MemberList = 'MEMBER_LIST',
  OauthCode = 'OAUTH_CODE',
  User = 'USER',
  Webhook = 'WEBHOOK'
}

export type PartnerNode = Node & {
  __typename?: 'PartnerNode';
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type PartnerPlan = {
  __typename?: 'PartnerPlan';
  customTrialDuration?: Maybe<Scalars['Duration']>;
  isFullySubsidized: Scalars['Boolean'];
  plan: BillingPlanNode;
};

export type PartnerReferralOfferNode = Node & {
  __typename?: 'PartnerReferralOfferNode';
  backgroundColor: Scalars['String'];
  ctaBackgroundColor: Scalars['String'];
  /** @deprecated Use in PartnerReferralOfferProductNode instead */
  ctaText: Scalars['String'];
  ctaTextColor: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  /** @deprecated Use in PartnerReferralOfferProductNode instead */
  manufacturerLogoUrl: Scalars['String'];
  /** @deprecated Use in PartnerReferralOfferProductNode instead */
  offerIconUrl: Scalars['String'];
  /** @deprecated Use in PartnerReferralOfferProductNode instead */
  offerImageUrl: Scalars['String'];
  /** @deprecated Use in PartnerReferralOfferProductNode instead */
  offerLabel: Scalars['String'];
  offerProducts: PartnerReferralOfferProductNodeConnection;
  /** @deprecated Use in PartnerReferralOfferProductNode instead */
  offerTitle: Scalars['String'];
  partner: PartnerNode;
  /** Hex color code (e.g., #FF0000) */
  primaryColor: Scalars['String'];
  /** Hex color code (e.g., #FF0000) */
  primaryContrastColor: Scalars['String'];
  /** Hex color code (e.g., #FF0000) */
  secondaryColor: Scalars['String'];
  /** Hex color code (e.g., #FF0000) */
  secondaryContrastColor: Scalars['String'];
  textColor: Scalars['String'];
  /** @deprecated Use in PartnerReferralOfferProductNode instead */
  userSpecificOfferUrl: Scalars['String'];
};


export type PartnerReferralOfferNodeOfferProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/**
 * Product-specific presentation details for partner referral offers.
 * This is the new, correct way to access offer presentation data.
 */
export type PartnerReferralOfferProductNode = Node & {
  __typename?: 'PartnerReferralOfferProductNode';
  ctaText: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  manufacturerLogo?: Maybe<Scalars['String']>;
  manufacturerLogoUrl: Scalars['String'];
  offer: PartnerReferralOfferNode;
  offerIcon?: Maybe<Scalars['String']>;
  offerIconUrl: Scalars['String'];
  offerImage?: Maybe<Scalars['String']>;
  offerImageUrl: Scalars['String'];
  offerLabel: Scalars['String'];
  offerTitle: Scalars['String'];
  product: ProductNode;
  userSpecificOfferUrl: Scalars['String'];
};

export type PartnerReferralOfferProductNodeConnection = {
  __typename?: 'PartnerReferralOfferProductNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PartnerReferralOfferProductNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `PartnerReferralOfferProductNode` and its cursor. */
export type PartnerReferralOfferProductNodeEdge = {
  __typename?: 'PartnerReferralOfferProductNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PartnerReferralOfferProductNode>;
};

export type PayPalPaymentMethod = Node & PaymentMethodInterface & {
  __typename?: 'PayPalPaymentMethod';
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  nickname?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user: UserType;
};

export type PaymentMethodInterface = {
  createdAt: Scalars['DateTime'];
  isActive: Scalars['Boolean'];
  nickname?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user: UserType;
};

export type PaymentMethodNode = CardPaymentMethod | PayPalPaymentMethod;

export type PaymentNode = Node & {
  __typename?: 'PaymentNode';
  amount: Scalars['Decimal'];
  amountRefunded: Scalars['Decimal'];
  failed: Scalars['Boolean'];
  failureDetails: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  invoice?: Maybe<InvoiceNode>;
  paymentDate: Scalars['DateTime'];
  processorApi: PaymentProcessor;
  processorId: Scalars['String'];
  status: PaymentStatus;
};

export type PaymentNodeConnection = {
  __typename?: 'PaymentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PaymentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `PaymentNode` and its cursor. */
export type PaymentNodeEdge = {
  __typename?: 'PaymentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PaymentNode>;
};

/** An enumeration. */
export enum PaymentProcessor {
  Paypal = 'PAYPAL',
  Recurly = 'RECURLY',
  Stripe = 'STRIPE'
}

/** An enumeration. */
export enum PaymentSource {
  Card = 'CARD',
  Paypal = 'PAYPAL'
}

/** An enumeration. */
export enum PaymentStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED'
}

/** An enumeration. */
export enum Period {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type PeriodicCheckInNode = Node & VisitInterface & {
  __typename?: 'PeriodicCheckInNode';
  aggregateCompliancePercentage?: Maybe<Scalars['Int']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  conversation?: Maybe<ConversationType>;
  createdAt: Scalars['DateTime'];
  date: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  pet: PetType;
  resultsViewed: Scalars['Boolean'];
  status: PeriodicCheckInStatus;
  targetDate: Scalars['Date'];
  title: Scalars['String'];
  topicName: Scalars['String'];
};

/** An enumeration. */
export enum PeriodicCheckInStatus {
  Completed = 'COMPLETED',
  Due = 'DUE',
  Missed = 'MISSED',
  Skipped = 'SKIPPED',
  Upcoming = 'UPCOMING'
}

export type PetActionNode = ActionInterface & Node & PetTodoInterface & {
  __typename?: 'PetActionNode';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<ProfessionalNode>;
  ctaAction?: Maybe<TodoClientAction>;
  ctaText?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  extendedSubtitle?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  important: Scalars['Boolean'];
  label: Scalars['String'];
  lastEditedBy?: Maybe<ProfessionalNode>;
  pet: PetType;
  slug: Scalars['String'];
  status: ActionStatus;
  subtitle: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  viewingDraft: Scalars['Boolean'];
};

export type PetAgeObjectType = {
  __typename?: 'PetAgeObjectType';
  day?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum PetAppetite {
  LessThanNormal = 'LESS_THAN_NORMAL',
  MoreThanNormal = 'MORE_THAN_NORMAL',
  NoneMoreThan_24Hours = 'NONE_MORE_THAN_24_HOURS',
  Normal = 'NORMAL'
}

/** An enumeration. */
export enum PetBehavior {
  Anxious = 'ANXIOUS',
  Lethargic = 'LETHARGIC',
  Normal = 'NORMAL'
}

export type PetBirthdayType = {
  __typename?: 'PetBirthdayType';
  accuracyLevel?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum PetCatCoatColor {
  Black = 'BLACK',
  Blue = 'BLUE',
  Brindle = 'BRINDLE',
  Calico = 'CALICO',
  Chocolate = 'CHOCOLATE',
  Cinnamon = 'CINNAMON',
  Cream = 'CREAM',
  Fawn = 'FAWN',
  Gray = 'GRAY',
  Harlequin = 'HARLEQUIN',
  Lilac = 'LILAC',
  NoCoat = 'NO_COAT',
  Orange = 'ORANGE',
  SealPoint = 'SEAL_POINT',
  Tabby = 'TABBY',
  Torbie = 'TORBIE',
  Tortoiseshell = 'TORTOISESHELL',
  Tuxedo = 'TUXEDO',
  White = 'WHITE'
}

/** An enumeration. */
export enum PetCoatColor {
  Black = 'BLACK',
  Blue = 'BLUE',
  Brindle = 'BRINDLE',
  Brown = 'BROWN',
  Calico = 'CALICO',
  Chocolate = 'CHOCOLATE',
  Cinnamon = 'CINNAMON',
  Cream = 'CREAM',
  Fawn = 'FAWN',
  Gold = 'GOLD',
  Gray = 'GRAY',
  Harlequin = 'HARLEQUIN',
  Lilac = 'LILAC',
  NoCoat = 'NO_COAT',
  Orange = 'ORANGE',
  Red = 'RED',
  SealPoint = 'SEAL_POINT',
  Striped = 'STRIPED',
  Tabby = 'TABBY',
  Torbie = 'TORBIE',
  Tortoiseshell = 'TORTOISESHELL',
  Tuxedo = 'TUXEDO',
  White = 'WHITE',
  Yellow = 'YELLOW'
}

export type PetDetailConnection = {
  __typename?: 'PetDetailConnection';
  count: Scalars['Int'];
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PetDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};


export type PetDetailConnectionCountArgs = {
  meetsTarget?: InputMaybe<Scalars['Boolean']>;
};

/** A Relay edge containing a `PetDetail` and its cursor. */
export type PetDetailEdge = {
  __typename?: 'PetDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PetDetailNodeV2>;
};

export type PetDetailInput = {
  booleanValue?: InputMaybe<Scalars['Boolean']>;
  choiceValue?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  conversation?: InputMaybe<Scalars['ID']>;
  diagnosticQuestion: Scalars['ID'];
  exactDate?: InputMaybe<Scalars['DateTime']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  flatValue?: InputMaybe<Scalars['Decimal']>;
  imageValue?: InputMaybe<Scalars['ImageUpload']>;
  modelValue?: InputMaybe<Scalars['ID']>;
  occurredAfter?: InputMaybe<Scalars['DateTime']>;
  occurredBefore?: InputMaybe<Scalars['DateTime']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']>;
  responseLocation?: InputMaybe<PetDetailResponseLocation>;
  staleAt?: InputMaybe<Scalars['DateTime']>;
  textValue?: InputMaybe<Scalars['String']>;
};

export type PetDetailInterface = {
  createdAt: Scalars['DateTime'];
  diagnosticQuestion: DiagnosticQuestionNode;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  meetsTarget?: Maybe<Scalars['Boolean']>;
  occurredAfter?: Maybe<Scalars['DateTime']>;
  occurredBefore?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  slug: Scalars['String'];
  staleAt?: Maybe<Scalars['DateTime']>;
  triggersInPersonVisit?: Maybe<Scalars['Boolean']>;
  triggersLiveVisit?: Maybe<Scalars['Boolean']>;
};

export type PetDetailNode = Node & {
  __typename?: 'PetDetailNode';
  aggregatedValues?: Maybe<Array<PetDetailNode>>;
  booleanValue?: Maybe<Scalars['Boolean']>;
  choiceValue?: Maybe<Array<Maybe<Scalars['String']>>>;
  comments?: Maybe<Scalars['String']>;
  complianceStatus?: Maybe<ComplianceLevel>;
  conversation?: Maybe<ConversationType>;
  createdAt: Scalars['DateTime'];
  diagnosticQuestion: DiagnosticQuestionNode;
  expectedTargetValue?: Maybe<DiagnosticQuestionTargetValuesNode>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  flatValue?: Maybe<Scalars['Decimal']>;
  /** The ID of the object */
  id: Scalars['ID'];
  imageValue?: Maybe<Scalars['String']>;
  medicationDosage?: Maybe<MedicationDosageNode>;
  meetsTarget?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Scalars['JSONString']>;
  modelValue?: Maybe<Node>;
  occurredAfter?: Maybe<Scalars['DateTime']>;
  occurredBefore?: Maybe<Scalars['DateTime']>;
  pet: PetType;
  previousValues?: Maybe<Array<PetDetailNode>>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  slug: Scalars['String'];
  staleAt?: Maybe<Scalars['DateTime']>;
  submittedByCurrentUser: Scalars['Boolean'];
  submittedByPro: Scalars['Boolean'];
  textValue?: Maybe<Scalars['String']>;
  triggersInPersonVisit?: Maybe<Scalars['Boolean']>;
  triggersLiveVisit?: Maybe<Scalars['Boolean']>;
  uploadedFiles?: Maybe<Array<FileNode>>;
};

export type PetDetailNodeConnection = {
  __typename?: 'PetDetailNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PetDetailNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `PetDetailNode` and its cursor. */
export type PetDetailNodeEdge = {
  __typename?: 'PetDetailNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PetDetailNode>;
};

export type PetDetailNodeV2 = BooleanPetDetailNode | ChoicePetDetailNode | DatePetDetailNode | FlatPetDetailNode | ImagePetDetailNode | ModelPetDetailNode | TextPetDetailNode;

/** An enumeration. */
export enum PetDetailResponseLocation {
  BookingForm = 'BOOKING_FORM',
  HealthDetails = 'HEALTH_DETAILS',
  PetProfile = 'PET_PROFILE',
  SoapReport = 'SOAP_REPORT',
  VisitDetails = 'VISIT_DETAILS',
  WellnessAssessment = 'WELLNESS_ASSESSMENT'
}

/** An enumeration. */
export enum PetDogCoatColor {
  Black = 'BLACK',
  Blue = 'BLUE',
  Brindle = 'BRINDLE',
  Brown = 'BROWN',
  Cream = 'CREAM',
  Fawn = 'FAWN',
  Gold = 'GOLD',
  Gray = 'GRAY',
  NoCoat = 'NO_COAT',
  Red = 'RED',
  Striped = 'STRIPED',
  White = 'WHITE',
  Yellow = 'YELLOW'
}

/** An enumeration. */
export enum PetHabitat {
  Indoor = 'INDOOR',
  IndoorOutdoor = 'INDOOR_OUTDOOR',
  Outdoor = 'OUTDOOR'
}

/** How often a pet should be assessed */
export enum PetHealthAssessmentCadence {
  BiWeekly = 'BI_WEEKLY',
  EverySixMonths = 'EVERY_SIX_MONTHS',
  EveryThreeMonths = 'EVERY_THREE_MONTHS',
  EveryTwoMonths = 'EVERY_TWO_MONTHS',
  EveryYear = 'EVERY_YEAR',
  Monthly = 'MONTHLY'
}

export type PetHoroscopeType = {
  __typename?: 'PetHoroscopeType';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  endDay: Scalars['Int'];
  endMonth: Scalars['Int'];
  id: Scalars['ID'];
  link?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pets: Array<PetType>;
  shortDescription?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  startDay: Scalars['Int'];
  startMonth: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

/** Pet Insight lifecycle events - used for both tracking and client reporting */
export enum PetInsightEvent {
  CampaignTriggered = 'CAMPAIGN_TRIGGERED',
  Consumed = 'CONSUMED',
  Dismissed = 'DISMISSED',
  Expired = 'EXPIRED',
  Generated = 'GENERATED',
  InsightGenerationFailed = 'INSIGHT_GENERATION_FAILED',
  Opened = 'OPENED',
  Viewed = 'VIEWED'
}

/** Input for tracking a single pet insight event */
export type PetInsightEventInput = {
  /** The event type to track */
  event: PetInsightEvent;
  /** The pet insight to track an event for */
  insight: Scalars['ID'];
};

export type PetInsightNode = Node & {
  __typename?: 'PetInsightNode';
  body: Scalars['String'];
  cardIllustration: Scalars['String'];
  consumedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  ctaText: Scalars['String'];
  dismissedAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  generatedAt: Scalars['DateTime'];
  headline: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  insight: InsightNode;
  isActive: Scalars['Boolean'];
  /** @deprecated Use keyActionV2 instead. Will be removed after May 2026. */
  keyAction: KeyAction;
  keyActionV2?: Maybe<KeyAction>;
  modalIllustration: Scalars['String'];
  navigationParams: Scalars['JSONString'];
  openedAt?: Maybe<Scalars['DateTime']>;
  pet: PetType;
  relevanceScore: Scalars['Float'];
  scoringContext: Scalars['JSONString'];
  teaser: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: UserType;
  viewedAt?: Maybe<Scalars['DateTime']>;
};

export type PetInsightNodeConnection = {
  __typename?: 'PetInsightNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PetInsightNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `PetInsightNode` and its cursor. */
export type PetInsightNodeEdge = {
  __typename?: 'PetInsightNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PetInsightNode>;
};

export type PetInsurancePolicyNode = InsurancePolicyInterface & Node & {
  __typename?: 'PetInsurancePolicyNode';
  accidentEffectiveDate?: Maybe<Scalars['Date']>;
  annualLimit: Scalars['Decimal'];
  annualLimitUsed: Scalars['Decimal'];
  boundDate?: Maybe<Scalars['DateTime']>;
  coinsurancePercentage: Scalars['Int'];
  cruciateEffectiveDate?: Maybe<Scalars['Date']>;
  deductible: Scalars['Decimal'];
  deductibleUsed: Scalars['Decimal'];
  documents?: Maybe<InsurancePolicyDocumentNodeConnection>;
  /** The ID of the object */
  id: Scalars['ID'];
  illnessEffectiveDate?: Maybe<Scalars['Date']>;
  insuredAddress?: Maybe<AddressType>;
  pet: PetType;
  policyExpirationDate?: Maybe<Scalars['Date']>;
  policyNumber: Scalars['String'];
  policyStartDate: Scalars['Date'];
  provider: InsuranceProvider;
};


export type PetInsurancePolicyNodeDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<InsurancePolicyDocumentType>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type PetMicrochipType = {
  __typename?: 'PetMicrochipType';
  brand?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type PetRabiesType = {
  __typename?: 'PetRabiesType';
  brand?: Maybe<Scalars['String']>;
  tagNumber?: Maybe<Scalars['String']>;
};

export type PetRoutineActionCategory = {
  __typename?: 'PetRoutineActionCategory';
  actionType: CarePlanActionCategoryType;
  actions: Array<GenericCarePlanActionNode>;
};


export type PetRoutineActionCategoryActionsArgs = {
  recommendationTypes?: InputMaybe<Array<InputMaybe<RecommendationType>>>;
  statuses?: InputMaybe<Array<InputMaybe<ActionStatus>>>;
};

export type PetRoutineType = {
  __typename?: 'PetRoutineType';
  actions: Array<GenericCarePlanActionNode>;
  actionsByType: Array<PetRoutineActionCategory>;
  createdAt: Scalars['DateTime'];
  dailyActions: Array<GenericCarePlanActionNode>;
  monthlyActions: Array<GenericCarePlanActionNode>;
  nonRecurringActions: Array<GenericCarePlanActionNode>;
  offTrackActions: Array<GenericCarePlanActionNode>;
  offTrackActionsCount: Scalars['Int'];
  totalActionsCount: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  updatedFrom: ConversationType;
  weeklyActions: Array<GenericCarePlanActionNode>;
  writtenBy: ProfessionalNode;
};


export type PetRoutineTypeActionsByTypeArgs = {
  categories?: InputMaybe<Array<Scalars['String']>>;
};

export type PetSymptomCheckerResultType = Node & {
  __typename?: 'PetSymptomCheckerResultType';
  formResponse: FormResponseType;
  /** The ID of the object */
  id: Scalars['ID'];
  pet: PetType;
  symptomCheckerResponse: SymptomCheckerResponseType;
};

export type PetSymptomCheckerResultTypeConnection = {
  __typename?: 'PetSymptomCheckerResultTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PetSymptomCheckerResultTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `PetSymptomCheckerResultType` and its cursor. */
export type PetSymptomCheckerResultTypeEdge = {
  __typename?: 'PetSymptomCheckerResultTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PetSymptomCheckerResultType>;
};

/** An enumeration. */
export enum PetTileColor {
  Blue = 'BLUE',
  Breeze = 'BREEZE',
  Grapefruit = 'GRAPEFRUIT',
  Grey = 'GREY',
  Passion = 'PASSION',
  Pink = 'PINK',
  Purple = 'PURPLE'
}

export type PetTodoInterface = {
  ctaAction?: Maybe<TodoClientAction>;
  ctaText?: Maybe<Scalars['String']>;
  extendedSubtitle?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  pet: PetType;
  slug: Scalars['String'];
  subtitle: Scalars['String'];
};

export type PetType = {
  __typename?: 'PetType';
  activityLevel?: Maybe<Scalars['Int']>;
  adoptionMethod?: Maybe<Scalars['String']>;
  adverseReactionsToMedicines: Array<Scalars['String']>;
  age?: Maybe<PetAgeObjectType>;
  allDetails?: Maybe<PetDetailNodeConnection>;
  allDetailsV2?: Maybe<PetDetailConnection>;
  allHouseholdPetsTreatedForFleas?: Maybe<Scalars['Boolean']>;
  appetite: Scalars['String'];
  behavior: Scalars['String'];
  birthday?: Maybe<PetBirthdayType>;
  bodyType?: Maybe<Scalars['Int']>;
  breed?: Maybe<BreedType>;
  breedingPregnantLactating?: Maybe<Scalars['Boolean']>;
  carePlans?: Maybe<Array<Maybe<CarePlanNode>>>;
  coatColor?: Maybe<Array<PetCoatColor>>;
  coveredByEmergencyFund: Scalars['Boolean'];
  currentDetails?: Maybe<PetDetailNodeConnection>;
  currentDetailsV2?: Maybe<PetDetailConnection>;
  dateOfDeath?: Maybe<Scalars['Date']>;
  eyeColor?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  habitat?: Maybe<PetHabitat>;
  /** @deprecated Replaced by coatColor */
  hairColor?: Maybe<Scalars['String']>;
  hairLossLevel?: Maybe<Scalars['Int']>;
  hasRoutine: Scalars['Boolean'];
  healthAssessmentCadence?: Maybe<PetHealthAssessmentCadence>;
  healthGoals?: Maybe<Array<Maybe<HealthGoalType>>>;
  hometown?: Maybe<AddressType>;
  horoscope?: Maybe<PetHoroscopeType>;
  id: Scalars['ID'];
  inContactWithNonHouseholdPetsOrYard?: Maybe<Scalars['Boolean']>;
  initialAssessment?: Maybe<PeriodicCheckInNode>;
  initialAssessmentComplete: Scalars['Boolean'];
  initialAssessmentCompleteV2: Scalars['Boolean'];
  initialRoutinePromptViewed: Scalars['Boolean'];
  isOwner?: Maybe<Scalars['Boolean']>;
  isSpayedOrNeutered?: Maybe<Scalars['Boolean']>;
  itchLevel?: Maybe<Scalars['Int']>;
  lastFleaTickMedication?: Maybe<Scalars['DateTime']>;
  lastVisitAt?: Maybe<Scalars['DateTime']>;
  living?: Maybe<Scalars['Boolean']>;
  medicalRecords: MedicalRecordNodeConnection;
  microchip?: Maybe<PetMicrochipType>;
  mostRecentSoapReport?: Maybe<PetDetailNodeConnection>;
  name: Scalars['String'];
  nameLastFleaTickMedication: Scalars['String'];
  nextAssessmentDueAt: Scalars['DateTime'];
  nickname?: Maybe<Scalars['String']>;
  owner: MemberType;
  /** All conversations (async or live) that took place as well as any 'in-person' (where the pet was taken to an actual clinic) actions. These are sorted with the most recent visits at the top. */
  pastVisits: Array<VisitInterface>;
  periodicCheckIns: Array<Maybe<PeriodicCheckInNode>>;
  picture?: Maybe<Scalars['String']>;
  preExistingEpilepsyConditions?: Maybe<Scalars['Boolean']>;
  profileCompletedAt?: Maybe<Scalars['DateTime']>;
  profileCompletionPercentage?: Maybe<Scalars['Int']>;
  rabies?: Maybe<PetRabiesType>;
  reasonForChangingFleaTickMedication: Scalars['String'];
  routine?: Maybe<PetRoutineType>;
  routineResultsViewed: Scalars['Boolean'];
  scents?: Maybe<Array<ScentType>>;
  score?: Maybe<Scalars['Int']>;
  symptomCheckerResults?: Maybe<PetSymptomCheckerResultTypeConnection>;
  takenFleaTickMedication?: Maybe<Scalars['Boolean']>;
  tileColor?: Maybe<PetTileColor>;
  todos: Array<PetTodoInterface>;
  type?: Maybe<Scalars['String']>;
  /** Not all items in this list are guaranteed to become 'pastVisits.' Only check ins that yield async conversations or actions that yielded in-person visits will re-appear in 'pastVisits' upon completion. These are sorted  with the earliest items first. */
  upcomingVisits: Array<VisitInterface>;
  vaccinations?: Maybe<Array<Maybe<PetVaccinationType>>>;
  waterConsumption: Scalars['String'];
  weight?: Maybe<Scalars['Float']>;
};


export type PetTypeAllDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  fromTs?: InputMaybe<Scalars['DateTime']>;
  last?: InputMaybe<Scalars['Int']>;
  modelValueId?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  responseLocation?: InputMaybe<PetDetailResponseLocation>;
  slug?: InputMaybe<Scalars['String']>;
};


export type PetTypeAllDetailsV2Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type PetTypeCurrentDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PetTypeCurrentDetailsV2Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type PetTypeHealthGoalsArgs = {
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type PetTypeMedicalRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PetTypeMostRecentSoapReportArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PetTypePastVisitsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  maxVisitDate?: InputMaybe<Scalars['DateTime']>;
  minVisitDate?: InputMaybe<Scalars['DateTime']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PetTypePeriodicCheckInsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<InputMaybe<PeriodicCheckInStatus>>>;
  windowOfFour?: InputMaybe<Scalars['Boolean']>;
  withAggregateComplianceValue?: InputMaybe<Scalars['Boolean']>;
};


export type PetTypeSymptomCheckerResultsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
};


export type PetTypeUpcomingVisitsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  maxVisitDate?: InputMaybe<Scalars['DateTime']>;
  minVisitDate?: InputMaybe<Scalars['DateTime']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** An enumeration. */
export enum PetTypes {
  Cat = 'CAT',
  Dog = 'DOG'
}

export type PetVaccinationType = {
  __typename?: 'PetVaccinationType';
  administeredAt: Scalars['Date'];
  id: Scalars['ID'];
  pet: PetType;
  vaccination: VaccinationType;
};

/** An enumeration. */
export enum PetWaterConsumption {
  LessThanNormal = 'LESS_THAN_NORMAL',
  MoreThanNormal = 'MORE_THAN_NORMAL',
  NoneMoreThan_24Hours = 'NONE_MORE_THAN_24_HOURS',
  Normal = 'NORMAL'
}

export type PlanAddOnInput = {
  emergencyFundPets?: InputMaybe<Array<Scalars['Int']>>;
  interval?: InputMaybe<Scalars['Int']>;
  period?: InputMaybe<Period>;
  petId?: InputMaybe<Scalars['Int']>;
  promoCode?: InputMaybe<Scalars['String']>;
  /** AddOn slug */
  slug: Scalars['Slug'];
};

export type PlanQuoteConfiguration = {
  __typename?: 'PlanQuoteConfiguration';
  isEligibleForTrial: Scalars['Boolean'];
  partner?: Maybe<PartnerNode>;
  plan: BillingPlanNode;
  subsidizedBy?: Maybe<PartnerNode>;
  trialLength?: Maybe<Scalars['Duration']>;
};

export type PlanQuoteInput = {
  configuration?: InputMaybe<Scalars['String']>;
  interval?: InputMaybe<Scalars['Int']>;
  noSubsidy?: InputMaybe<Scalars['Boolean']>;
  period?: InputMaybe<Period>;
  plan?: InputMaybe<Scalars['String']>;
  startInTrial?: InputMaybe<Scalars['Boolean']>;
  subsidizedBy?: InputMaybe<Scalars['Slug']>;
};

/** An enumeration. */
export enum PlanStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Dunning = 'DUNNING',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Replaced = 'REPLACED',
  Trial = 'TRIAL',
  Voided = 'VOIDED'
}

export type PlanSubscriptionPrice = Node & {
  __typename?: 'PlanSubscriptionPrice';
  /** The ID of the object */
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  price: PriceNode;
  requiresActiveAddOns: Array<AddOnNode>;
};

export type PlanSubscriptionPriceConnection = {
  __typename?: 'PlanSubscriptionPriceConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PlanSubscriptionPriceEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `PlanSubscriptionPrice` and its cursor. */
export type PlanSubscriptionPriceEdge = {
  __typename?: 'PlanSubscriptionPriceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PlanSubscriptionPrice>;
};

export type PreCheckout = {
  __typename?: 'PreCheckout';
  /** @deprecated Replaced by 'cartV2' */
  cart: CartNode;
  cartV2: CartNodeV2;
};

export type PreCheckoutInput = {
  cart: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  shippingAddressId?: InputMaybe<Scalars['ID']>;
};

export type PreferredSupplierDetails = {
  __typename?: 'PreferredSupplierDetails';
  supplier: SupplierNode;
  url?: Maybe<Scalars['String']>;
};

export type PrescriptionConsumable = Node & PurchasedConsumableInterface & PurchasedTierInterface & {
  __typename?: 'PrescriptionConsumable';
  activatedAt?: Maybe<Scalars['DateTime']>;
  booking?: Maybe<RxBookingNode>;
  bundle?: Maybe<FeatureBundle>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  consumedAt?: Maybe<Scalars['DateTime']>;
  /** The ID of the object */
  id: Scalars['ID'];
  invoice?: Maybe<InvoiceNode>;
  partner?: Maybe<PartnerNode>;
  price?: Maybe<PriceNode>;
  purchaseAmount?: Maybe<Scalars['Decimal']>;
  purchasedAt: Scalars['DateTime'];
  refund?: Maybe<Refund>;
  reissueReason?: Maybe<ReissueReason>;
  reissueReasonNote?: Maybe<Scalars['String']>;
  reissuedBy?: Maybe<UserType>;
  requiresUserAction: Scalars['Boolean'];
  status: PurchasedConsumableStatus;
  subscribable?: Maybe<SubscribableConsumable>;
  subsidized: Scalars['Boolean'];
  tier: ConsumableFeatureTier;
  useBy?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionConsumableConnection = {
  __typename?: 'PrescriptionConsumableConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PrescriptionConsumableEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `PrescriptionConsumable` and its cursor. */
export type PrescriptionConsumableEdge = {
  __typename?: 'PrescriptionConsumableEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PrescriptionConsumable>;
};

export type PrescriptionFeature = ConsumableFeatureInterface & PrescriptionFeatures & PurchasedTierInterface & SubscribedFeatureInterface & {
  __typename?: 'PrescriptionFeature';
  activatedAt?: Maybe<Scalars['DateTime']>;
  bundle?: Maybe<FeatureBundle>;
  downgradeOptions: Array<SubscribableFeatureInterface>;
  isAvailable: Scalars['Boolean'];
  partner?: Maybe<PartnerNode>;
  price?: Maybe<PriceNode>;
  purchaseAmount?: Maybe<Scalars['Decimal']>;
  purchaseOptions: Array<ConsumableFeatureTier>;
  purchasedAt?: Maybe<Scalars['DateTime']>;
  purchasedRxes?: Maybe<PrescriptionConsumableConnection>;
  requiresUserAction: Scalars['Boolean'];
  subscription?: Maybe<SubscriptionNode>;
  subscriptionTier?: Maybe<SubscribableConsumable>;
  subsidized: Scalars['Boolean'];
  terminatedAt?: Maybe<Scalars['DateTime']>;
  trialDuration?: Maybe<Scalars['Duration']>;
  trialEndsAt?: Maybe<Scalars['DateTime']>;
  trialing: Scalars['Boolean'];
  upgradeOptions: Array<SubscribableFeatureInterface>;
};


export type PrescriptionFeatureDowngradeOptionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type PrescriptionFeaturePurchaseOptionsArgs = {
  maxQuantity?: InputMaybe<Scalars['Int']>;
  minQuantity?: InputMaybe<Scalars['Int']>;
};


export type PrescriptionFeaturePurchasedRxesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  consumable?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
};


export type PrescriptionFeatureUpgradeOptionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type PrescriptionFeatures = {
  isAvailable: Scalars['Boolean'];
  purchasedRxes?: Maybe<PrescriptionConsumableConnection>;
  subscriptionTier?: Maybe<SubscribableConsumable>;
};


export type PrescriptionFeaturesPurchasedRxesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  consumable?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
};

export type PrescriptionNode = Node & {
  __typename?: 'PrescriptionNode';
  /** @deprecated Replaced by 'status' */
  approvalStatus: PrescriptionStatus;
  approvedRefills: Scalars['Int'];
  carePlanActions: GenericCarePlanActionNodeConnection;
  clinic: CoreClinicNode;
  createdAt: Scalars['DateTime'];
  expiresAt: Scalars['Date'];
  /** The ID of the object */
  id: Scalars['ID'];
  interval?: Maybe<Scalars['Int']>;
  /** Immutable details about the pet. This is a JSON field that stores things like the pet name, pet parent address etc.   */
  otherDetails: Scalars['JSONString'];
  period?: Maybe<CarePlanActionPeriod>;
  pet: PetType;
  prescriberLicenseId: Scalars['String'];
  prescriberName: Scalars['String'];
  processedAt?: Maybe<Scalars['DateTime']>;
  processedBy?: Maybe<ProfessionalNode>;
  /** @deprecated Use quantityDecimal */
  quantity?: Maybe<Scalars['Int']>;
  quantityDecimal?: Maybe<Scalars['Decimal']>;
  quantityDispensed?: Maybe<Scalars['Decimal']>;
  quantityUnit?: Maybe<CarePlanActionQuantityUnit>;
  selectedProduct: ProductNode;
  selectedProductTitle: Scalars['String'];
  /** Directions for use */
  sig: Scalars['String'];
  status: PrescriptionStatus;
  treatmentEnd?: Maybe<Scalars['DateTime']>;
};


export type PrescriptionNodeCarePlanActionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PrescriptionNodeConnection = {
  __typename?: 'PrescriptionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PrescriptionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `PrescriptionNode` and its cursor. */
export type PrescriptionNodeEdge = {
  __typename?: 'PrescriptionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PrescriptionNode>;
};

export type PrescriptionPetActionNode = ActionInterface & Node & PetTodoInterface & {
  __typename?: 'PrescriptionPetActionNode';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<ProfessionalNode>;
  ctaAction?: Maybe<TodoClientAction>;
  ctaText?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  extendedSubtitle?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  important: Scalars['Boolean'];
  label: Scalars['String'];
  lastEditedBy?: Maybe<ProfessionalNode>;
  pet: PetType;
  prescription: PrescriptionNode;
  slug: Scalars['String'];
  status: ActionStatus;
  subtitle: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  viewingDraft: Scalars['Boolean'];
};

export type PrescriptionQuoteLine = ConsumableQuoteLineInterface & PrescriptionFeatures & QuoteLineInterface & RenewalQuoteLineInterface & {
  __typename?: 'PrescriptionQuoteLine';
  /** Amount user needs to pay at checkout. */
  amountDue: Scalars['Decimal'];
  /** Current net price the user pays, if any. */
  currentNetPrice?: Maybe<Scalars['Decimal']>;
  /** What the user currently pays for this feature, if any. */
  currentPrice?: Maybe<Scalars['Decimal']>;
  currentQuantity: Scalars['Int'];
  /** Current subsidy amount, if any. */
  currentSubsidy?: Maybe<Scalars['Decimal']>;
  discount: Scalars['Decimal'];
  existingSubscription?: Maybe<SubscriptionNode>;
  feature: ConsumableFeatureTier;
  isAvailable: Scalars['Boolean'];
  missingOrIncompletePetFields: Array<IncompletePetDataType>;
  /** List of pet attributes required to checkout. Omits fields already properly set. */
  missingOrIncompleteUserFields: Array<ActionRequiredUserFields>;
  netPrice: Scalars['Decimal'];
  newQuantity: Scalars['Int'];
  price: Scalars['Decimal'];
  purchasedRxes?: Maybe<PrescriptionConsumableConnection>;
  /** Null if this is fully subsidized. */
  renewalCadence?: Maybe<RenewalCadence>;
  subscriptionTier?: Maybe<SubscribableConsumable>;
  subsidizedBy?: Maybe<PartnerNode>;
  subsidy: Scalars['Decimal'];
  useNewItemsBy?: Maybe<Scalars['Date']>;
};


export type PrescriptionQuoteLinePurchasedRxesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  consumable?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
};

export type PrescriptionRequestNode = Node & {
  __typename?: 'PrescriptionRequestNode';
  clinic: CoreClinicNode;
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  lineItems?: Maybe<OrderLineNodeConnection>;
  pet: PetType;
  product: ProductNode;
  result?: Maybe<PrescriptionRequestResult>;
  results: Array<PrescriptionRequestResult>;
};


export type PrescriptionRequestNodeLineItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PrescriptionRequestResult = {
  prescriptionRequest: CorePrescriptionNode;
};

/** An enumeration. */
export enum PrescriptionStatus {
  /** Prescription has been created and is ready to be sent to a pharmacy. */
  Approved = 'APPROVED',
  /** Deprecated status - used in VCPR flows */
  AsyncReview = 'ASYNC_REVIEW',
  /** Deprecated status - used in VCPR flows */
  Cancelled = 'CANCELLED',
  /** Deprecated status - used in VCPR flows */
  Rejected = 'REJECTED',
  /** Prescription has been sent to a pharmacy (either verbally, by fax, or online web portal) */
  Transmitted = 'TRANSMITTED',
  /** Prescription can no longer be used. */
  Voided = 'VOIDED'
}

export type PrescriptionsPetActionNode = ActionInterface & ConversationActionInterface & Node & PetTodoInterface & {
  __typename?: 'PrescriptionsPetActionNode';
  conversation: ConversationType;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<ProfessionalNode>;
  ctaAction?: Maybe<TodoClientAction>;
  ctaText?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  extendedSubtitle?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  important: Scalars['Boolean'];
  label: Scalars['String'];
  lastEditedBy?: Maybe<ProfessionalNode>;
  pet: PetType;
  slug: Scalars['String'];
  status: ActionStatus;
  subtitle: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  viewingDraft: Scalars['Boolean'];
};

export type PreviousInput = {
  answers?: InputMaybe<Array<InputMaybe<AnswerInput>>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  formResponse?: InputMaybe<Scalars['ID']>;
  formSlug: Scalars['String'];
  questionGroupSlug: Scalars['String'];
};

export type PreviousPayload = {
  __typename?: 'PreviousPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  response: NextResponse;
};

export type PriceNode = Node & {
  __typename?: 'PriceNode';
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  interval?: Maybe<Scalars['Int']>;
  period?: Maybe<Period>;
  price: Scalars['Decimal'];
  priceType: PriceTypeEnum;
  tiers?: Maybe<Array<Maybe<PriceTierType>>>;
};

export type PriceTierType = {
  __typename?: 'PriceTierType';
  limit?: Maybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  scheme: TierPricingType;
};

/** An enumeration. */
export enum PriceTypeEnum {
  OneTime = 'ONE_TIME',
  Recurring = 'RECURRING'
}

export type ProductCategoryNode = Node & {
  __typename?: 'ProductCategoryNode';
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
  parentCategory?: Maybe<ProductCategoryNode>;
  products: Array<ProductNode>;
  slug: Scalars['String'];
};

export type ProductCategoryNodeConnection = {
  __typename?: 'ProductCategoryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductCategoryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `ProductCategoryNode` and its cursor. */
export type ProductCategoryNodeEdge = {
  __typename?: 'ProductCategoryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProductCategoryNode>;
};

export type ProductComponentCategoryNode = Node & {
  __typename?: 'ProductComponentCategoryNode';
  categoryType: ProductComponentCategoryType;
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

/** An enumeration. */
export enum ProductComponentCategoryType {
  Ingredient = 'INGREDIENT',
  Other = 'OTHER'
}

export type ProductComponentNode = Node & {
  __typename?: 'ProductComponentNode';
  /** Allergies associated with this ingredient component */
  allergies: AllergyNodeConnection;
  category: ProductComponentCategoryNode;
  /** Only for ingredients. Describes the functional reason the ingredient is added to the formula, only used if it does not serve a core nutritional role. */
  functionalRole?: Maybe<ProductFunctionalRole>;
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Only for ingredients. Identifies whether the ingredient provides essential nutrients required by the pet */
  nutrientType?: Maybe<ProductNutrientType>;
  products: Array<ProductNode>;
  slug: Scalars['String'];
};


export type ProductComponentNodeAllergiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ProductComponentNodeConnection = {
  __typename?: 'ProductComponentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductComponentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `ProductComponentNode` and its cursor. */
export type ProductComponentNodeEdge = {
  __typename?: 'ProductComponentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProductComponentNode>;
};

export type ProductFamilyNode = Node & {
  __typename?: 'ProductFamilyNode';
  /** ('Any product categories linked to the family are also considered categories of the child products',) */
  categories: ProductCategoryNodeConnection;
  description: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  image: Scalars['String'];
  isPopular: Scalars['Boolean'];
  pawpRxEligible: Scalars['Boolean'];
  rxBookingAcknowledgment?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};


export type ProductFamilyNodeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ProductFamilySuggestionNode = Node & {
  __typename?: 'ProductFamilySuggestionNode';
  /** The ID of the object */
  id: Scalars['ID'];
  title: Scalars['String'];
};

/** An enumeration. */
export enum ProductFormFactor {
  Barf = 'BARF',
  Canned = 'CANNED',
  Capsule = 'CAPSULE',
  Chewable = 'CHEWABLE',
  Collar = 'COLLAR',
  Drop = 'DROP',
  Fresh = 'FRESH',
  Kibble = 'KIBBLE',
  Tablet = 'TABLET'
}

/** An enumeration. */
export enum ProductFunctionalRole {
  Additive = 'ADDITIVE',
  Filler = 'FILLER',
  Flavoring = 'FLAVORING',
  Nutritional = 'NUTRITIONAL',
  Palatant = 'PALATANT',
  Probiotic = 'PROBIOTIC',
  Supplement = 'SUPPLEMENT'
}

export type ProductManufacturerNode = Node & {
  __typename?: 'ProductManufacturerNode';
  /** The ID of the object */
  id: Scalars['ID'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type ProductNode = Node & {
  __typename?: 'ProductNode';
  abridgedTitle: Scalars['String'];
  amount?: Maybe<Scalars['Decimal']>;
  caloricContent?: Maybe<Scalars['Decimal']>;
  caloricUnitDisplay?: Maybe<Scalars['String']>;
  categories: ProductCategoryNodeConnection;
  compareAt?: Maybe<Scalars['Decimal']>;
  /** Ingredients or components that make up this product */
  components: ProductComponentNodeConnection;
  description: Scalars['String'];
  /** Human readable flavor names (converted from slugs) */
  flavors: Array<Maybe<Scalars['String']>>;
  formFactor?: Maybe<ProductFormFactor>;
  fullImages?: Maybe<Array<Maybe<ImageType>>>;
  /** The ID of the object */
  id: Scalars['ID'];
  images?: Maybe<Array<Maybe<ImageType>>>;
  isRx: Scalars['Boolean'];
  /** Number of items in package (ex: number of pills; always 1 for liquids) */
  items?: Maybe<Scalars['Decimal']>;
  manufacturer?: Maybe<ProductManufacturerNode>;
  meta?: Maybe<CoreProductMeta>;
  /** Weight (solids) or volume (liquids) of package. */
  metricAmount?: Maybe<Scalars['Decimal']>;
  metricUnit?: Maybe<ProductWeightUnit>;
  /** @deprecated No longer implemented */
  minPrice?: Maybe<Scalars['Decimal']>;
  /** @deprecated Use partner_referral_offer_v2 instead for product-specific details */
  partnerReferralOffer?: Maybe<PartnerReferralOfferNode>;
  /** Product-specific partner referral offer with improved structure */
  partnerReferralOfferV2?: Maybe<PartnerReferralOfferProductNode>;
  petTypes?: Maybe<Array<PetTypes>>;
  preferredSupplier?: Maybe<PreferredSupplierDetails>;
  pricePerUnit?: Maybe<Scalars['Decimal']>;
  /** The rough price range of a product in comparison with other products in the same category. Not automatically calculated. */
  priceRange?: Maybe<ProductPriceRange>;
  /** @deprecated Use 'categories' */
  productCategoryDescriptor: Scalars['String'];
  productDetails?: Maybe<CoreProductDetailsNode>;
  productFamily?: Maybe<ProductFamilyNode>;
  productGuidance: Scalars['String'];
  /** @deprecated Use 'preferredSupplier' */
  purchaseDetails?: Maybe<PurchaseDetails>;
  shortDescription: Scalars['String'];
  slug: Scalars['String'];
  subscriptionOptions: ProductVariantSubscriptionPriceNodeConnection;
  targetConditions: ConditionNodeConnection;
  /** @deprecated Use 'petTypes' */
  targetPetTypes?: Maybe<Array<PetTypes>>;
  targetWeightRange?: Maybe<ProductVariantWeightRange>;
  title: Scalars['String'];
  upc: Scalars['String'];
  variants: ProductVariantNodeConnection;
  vcprAddons: Array<VcprAddOnNode>;
  /** @deprecated No longer implemented */
  vendor?: Maybe<Scalars['String']>;
  /** @deprecated No longer implemented - do not trust this value */
  vendorType: ProductVendorType;
  weightRange?: Maybe<WeightRange>;
};


export type ProductNodeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProductNodeComponentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProductNodeSubscriptionOptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProductNodeTargetConditionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProductNodeVariantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Decimal']>;
  quantityType?: InputMaybe<QuantityType>;
  quantityValue?: InputMaybe<Scalars['Decimal']>;
};

export type ProductNodeConnection = {
  __typename?: 'ProductNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `ProductNode` and its cursor. */
export type ProductNodeEdge = {
  __typename?: 'ProductNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProductNode>;
};

/** An enumeration. */
export enum ProductNutrientType {
  Macronutrient = 'MACRONUTRIENT',
  Micronutrient = 'MICRONUTRIENT'
}

/** An enumeration. */
export enum ProductPriceRange {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type ProductRecommendationNodeV2 = Node & {
  __typename?: 'ProductRecommendationNodeV2';
  determiningPetDetails: PetDetailNodeConnection;
  generatedByAgent: Scalars['Boolean'];
  /** The ID of the object */
  id: Scalars['ID'];
  pet?: Maybe<PetType>;
  prescription?: Maybe<PrescriptionNode>;
  product: ProductNode;
  reasons: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
};


export type ProductRecommendationNodeV2DeterminingPetDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Deprecated - this is a carry over from product_v2 */
export type ProductVariantNode = Node & {
  __typename?: 'ProductVariantNode';
  compareAtPrice?: Maybe<Scalars['Decimal']>;
  discountPrice?: Maybe<Scalars['Decimal']>;
  fullImages?: Maybe<Array<Maybe<ImageType>>>;
  /** The ID of the object */
  id: Scalars['ID'];
  images?: Maybe<Array<Maybe<ImageType>>>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['Decimal']>;
  product: ProductNode;
  quantityType?: Maybe<QuantityType>;
  quantityValue?: Maybe<Scalars['Decimal']>;
  slug: Scalars['String'];
  subscriptionPrices?: Maybe<Array<Maybe<ProductVariantSubscriptionPriceNode>>>;
  targetWeightRange?: Maybe<ProductVariantWeightRange>;
  vcprAddons?: Maybe<Array<Maybe<VcprAddOnNode>>>;
};

export type ProductVariantNodeConnection = {
  __typename?: 'ProductVariantNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductVariantNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `ProductVariantNode` and its cursor. */
export type ProductVariantNodeEdge = {
  __typename?: 'ProductVariantNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProductVariantNode>;
};

export type ProductVariantSubscriptionPriceNode = Node & {
  __typename?: 'ProductVariantSubscriptionPriceNode';
  discountPercent: Scalars['Int'];
  /** The ID of the object */
  id: Scalars['ID'];
  interval: Scalars['Int'];
  period: Period;
  price?: Maybe<PriceNode>;
};

export type ProductVariantSubscriptionPriceNodeConnection = {
  __typename?: 'ProductVariantSubscriptionPriceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductVariantSubscriptionPriceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `ProductVariantSubscriptionPriceNode` and its cursor. */
export type ProductVariantSubscriptionPriceNodeEdge = {
  __typename?: 'ProductVariantSubscriptionPriceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProductVariantSubscriptionPriceNode>;
};

export type ProductVariantWeightRange = {
  __typename?: 'ProductVariantWeightRange';
  lower?: Maybe<Scalars['Decimal']>;
  upper?: Maybe<Scalars['Decimal']>;
};

/** An enumeration. */
export enum ProductVendorType {
  FirstParty = 'FIRST_PARTY',
  ThirdParty = 'THIRD_PARTY'
}

/** An enumeration. */
export enum ProductWeightUnit {
  /** fluid ounces */
  FlOz = 'FL_OZ',
  /** grams */
  Grams = 'GRAMS',
  /** milliliters */
  Ml = 'ML',
  /** ounces */
  Oz = 'OZ'
}

/** All fields on this node are visible by all authenticated users. */
export type ProfessionalNode = Node & {
  __typename?: 'ProfessionalNode';
  firstName?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  isSystem: Scalars['Boolean'];
  isVideoChatAvailable: Scalars['Boolean'];
  jobTitle: Scalars['String'];
  picture?: Maybe<Scalars['String']>;
  professionalName?: Maybe<Scalars['String']>;
};

export type ProgressContextType = {
  __typename?: 'ProgressContextType';
  completedCategoriesCount: Scalars['Int'];
  currentCategory: CategoryType;
  remainingCategories?: Maybe<Array<Maybe<CategoryType>>>;
};

export type ProgressType = {
  __typename?: 'ProgressType';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
};

export type PromoCodeNode = Node & {
  __typename?: 'PromoCodeNode';
  code: Scalars['String'];
  coupon: CouponNode;
  createdAt: Scalars['DateTime'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  /** The ID of the object */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  maxRedemptions?: Maybe<Scalars['Int']>;
  newCustomersOnly: Scalars['Boolean'];
  processorId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PromoCodeNodeConnection = {
  __typename?: 'PromoCodeNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PromoCodeNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `PromoCodeNode` and its cursor. */
export type PromoCodeNodeEdge = {
  __typename?: 'PromoCodeNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PromoCodeNode>;
};

/**
 * Deprecated - here as a stub so iOS doesn't break. Nothing ever actually asks for
 * this in the iOS codebase but there is a fragment defined for it so we need to
 * stub the type otherwise graphql validation will fail
 */
export type PromotionNode = {
  __typename?: 'PromotionNode';
  cmsId: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type PromotionalClaimNode = {
  __typename?: 'PromotionalClaimNode';
  adjustedAmount: Scalars['Decimal'];
  petName: Scalars['String'];
  state: Scalars['String'];
};

export type PurchaseConsumableInput = {
  ignoreSubsidizerChecks?: InputMaybe<Scalars['Boolean']>;
  quantity?: InputMaybe<Scalars['Int']>;
  /** Will auto select a subsidizer if user has one. Setting this is only necessary if client wants to force a specific subsidizer. */
  subsidizedBy?: InputMaybe<Scalars['Slug']>;
  tier: Scalars['Slug'];
};

export type PurchaseDetails = {
  __typename?: 'PurchaseDetails';
  supplier: SupplierNode;
  url: Scalars['String'];
};

/** CORE interface — extends base with billing fields (invoice, refund). */
export type PurchasedConsumableInterface = {
  activatedAt?: Maybe<Scalars['DateTime']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  consumedAt?: Maybe<Scalars['DateTime']>;
  invoice?: Maybe<InvoiceNode>;
  purchasedAt: Scalars['DateTime'];
  refund?: Maybe<Refund>;
  reissueReason?: Maybe<ReissueReason>;
  reissueReasonNote?: Maybe<Scalars['String']>;
  reissuedBy?: Maybe<UserType>;
  status: PurchasedConsumableStatus;
  subscribable?: Maybe<SubscribableConsumable>;
  tier: ConsumableFeatureTier;
  useBy?: Maybe<Scalars['DateTime']>;
};

/** An enumeration. */
export enum PurchasedConsumableStatus {
  Activated = 'ACTIVATED',
  Cancelled = 'CANCELLED',
  Consumed = 'CONSUMED',
  Refunded = 'REFUNDED',
  Unused = 'UNUSED'
}

/** CORE interface — extends base with billing fields (bundle, price). */
export type PurchasedTierInterface = {
  bundle?: Maybe<FeatureBundle>;
  partner?: Maybe<PartnerNode>;
  price?: Maybe<PriceNode>;
  purchaseAmount?: Maybe<Scalars['Decimal']>;
  purchasedAt?: Maybe<Scalars['DateTime']>;
  requiresUserAction: Scalars['Boolean'];
  subsidized: Scalars['Boolean'];
};

/** An enumeration. */
export enum QuantityType {
  Chew = 'CHEW',
  Grams = 'GRAMS',
  Item = 'ITEM',
  Milligrams = 'MILLIGRAMS',
  Pill = 'PILL',
  Tablet = 'TABLET'
}

export type Query = {
  __typename?: 'Query';
  actionsForPet: Array<Maybe<GenericCarePlanActionNode>>;
  addOns?: Maybe<AddOnConnection>;
  allConversationFeedback?: Maybe<Array<Maybe<ConversationFeedbackType>>>;
  allergies?: Maybe<Array<Maybe<AllergyType>>>;
  allergiesV2?: Maybe<AllergyNodeConnection>;
  allergy?: Maybe<AllergyType>;
  allergyV2?: Maybe<AllergyNode>;
  autoshipPlan?: Maybe<AutoshipPlanNode>;
  autoshipPlans?: Maybe<AutoshipPlanNodeConnection>;
  canCheckInToBooking: Scalars['Boolean'];
  carePlan?: Maybe<CarePlanNode>;
  carePlanAction?: Maybe<CarePlanActionNode>;
  cartV2: CartNodeV2;
  checkConsentGranted: Scalars['Boolean'];
  claimAttachment?: Maybe<ClaimAttachmentNodeConnection>;
  claimRequest?: Maybe<ClaimRequestNodeConnection>;
  clinic?: Maybe<CoreClinicNode>;
  clinicLocations?: Maybe<ClinicLocationNodeConnection>;
  clinics?: Maybe<CoreClinicNodeConnection>;
  collection?: Maybe<CollectionNode>;
  collections?: Maybe<CollectionNodeConnection>;
  condition?: Maybe<ConditionType>;
  conditionGroup?: Maybe<ConditionGroupNode>;
  conditionV2?: Maybe<ConditionNode>;
  conditions?: Maybe<Array<Maybe<ConditionType>>>;
  conditionsV2?: Maybe<ConditionNodeConnection>;
  consentTypes?: Maybe<ConsentTypeNodeConnection>;
  contextualAddOns: Array<ContextualAddOn>;
  conversation?: Maybe<ConversationType>;
  conversationFeedback?: Maybe<ConversationFeedbackType>;
  conversations: ConversationPaginatedType;
  coupon?: Maybe<CouponNode>;
  coupons?: Maybe<CouponNodeConnection>;
  /** @deprecated Replaced by 'cartV2' */
  currentCart?: Maybe<CartNode>;
  /** @deprecated Use Membership.emergencyProtection field */
  currentEmergencyFund?: Maybe<EmergencyFundStatusNode>;
  currentPlan?: Maybe<UserPlanNode>;
  currentRole: Roles;
  dispatchStatsMember?: Maybe<DispatchStatsMemberType>;
  featureAccess: FeatureAccess;
  formResponse?: Maybe<FormResponseNode>;
  fulfillment?: Maybe<FulfillmentNode>;
  fulfillments?: Maybe<FulfillmentNodeConnection>;
  getAuthInstructions: AuthInstructions;
  getBooking: BookingInterface;
  getBookingAvailability?: Maybe<BookingAvailability>;
  getBookings?: Maybe<Array<BookingInterface>>;
  iipOffers?: Maybe<Array<IipOfferNode>>;
  listRoles: Array<SchemaRole>;
  medication?: Maybe<CoreMedicationNode>;
  medications?: Maybe<CoreMedicationNodeConnection>;
  minimumAndroidAppVersions?: Maybe<MobileVersionsType>;
  minimumIosAppVersions?: Maybe<MobileVersionsType>;
  /** @deprecated Use the dedicated productRecommendation query instead */
  node?: Maybe<Node>;
  orderV2?: Maybe<OrderNode>;
  ordersV2?: Maybe<OrderNodeConnection>;
  pet: PetType;
  petHistoricalInsights?: Maybe<PetInsightNodeConnection>;
  petSymptomCheckerResult?: Maybe<PetSymptomCheckerResultType>;
  pets: Array<Maybe<PetType>>;
  prescription: PrescriptionNode;
  prescriptions?: Maybe<PrescriptionNodeConnection>;
  previewBundleCancellation?: Maybe<BundleCancellationPreview>;
  previewCancellation?: Maybe<CancellationPreview>;
  productRecommendation?: Maybe<ProductRecommendationNodeV2>;
  productV2?: Maybe<ProductNode>;
  productsV2?: Maybe<ProductNodeConnection>;
  promoCode?: Maybe<PromoCodeNode>;
  promoCodes?: Maybe<PromoCodeNodeConnection>;
  promotionalClaims: Array<PromotionalClaimNode>;
  quoteSignup?: Maybe<QuoteResponse>;
  recommendedProducts?: Maybe<Array<ProductRecommendationNodeV2>>;
  shippingAddress?: Maybe<ShippingAddressType>;
  shippingAddresses?: Maybe<Array<Maybe<ShippingAddressType>>>;
  symptomCheckerResponse?: Maybe<SymptomCheckerResponseType>;
  user?: Maybe<UserType>;
  userAlgoliaKey?: Maybe<UserAlgoliaKeyType>;
  userConsents?: Maybe<UserConsentNodeConnection>;
  userPetInsight?: Maybe<PetInsightNode>;
  userPetInsights?: Maybe<PetInsightNodeConnection>;
  userV2: UserType;
  v2Plan?: Maybe<BillingPlanNode>;
  v2Plans?: Maybe<BillingPlanNodeConnection>;
  variantV2?: Maybe<ProductVariantNode>;
  variantsV2?: Maybe<ProductVariantNodeConnection>;
  /** @deprecated Use upcomingVisits and pastVisits on pet instead */
  visitsForPet?: Maybe<VisitsForPet>;
};


export type QueryActionsForPetArgs = {
  category?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['ID']>;
  excludedCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludedSubcategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  petId: Scalars['ID'];
  subCategory?: InputMaybe<Scalars['String']>;
};


export type QueryAddOnsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAllergiesArgs = {
  isApproved?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAllergiesV2Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryAllergyArgs = {
  pk?: InputMaybe<Scalars['ID']>;
};


export type QueryAllergyV2Args = {
  id: Scalars['ID'];
};


export type QueryAutoshipPlanArgs = {
  id: Scalars['ID'];
};


export type QueryAutoshipPlansArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
  subscription_Status?: InputMaybe<SubscriptionStatus>;
};


export type QueryCanCheckInToBookingArgs = {
  pet: Scalars['ID'];
  serviceType: BookingServiceType;
};


export type QueryCarePlanArgs = {
  id: Scalars['ID'];
};


export type QueryCarePlanActionArgs = {
  id: Scalars['ID'];
};


export type QueryCheckConsentGrantedArgs = {
  consentCategory: ConsentCategory;
};


export type QueryClaimAttachmentArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryClaimRequestArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  insurancePolicy?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
  status_In?: InputMaybe<Array<InputMaybe<ClaimRequestStatus>>>;
};


export type QueryClinicArgs = {
  id: Scalars['ID'];
};


export type QueryClinicLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryClinicsArgs = {
  address?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};


export type QueryCollectionArgs = {
  id: Scalars['ID'];
};


export type QueryCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryConditionArgs = {
  pk?: InputMaybe<Scalars['ID']>;
};


export type QueryConditionGroupArgs = {
  id: Scalars['ID'];
};


export type QueryConditionV2Args = {
  id: Scalars['ID'];
};


export type QueryConditionsArgs = {
  isApproved?: InputMaybe<Scalars['Boolean']>;
};


export type QueryConditionsV2Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryConsentTypesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryContextualAddOnsArgs = {
  pets?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryConversationArgs = {
  pk?: InputMaybe<Scalars['ID']>;
};


export type QueryConversationFeedbackArgs = {
  conversationId?: InputMaybe<Scalars['ID']>;
};


export type QueryConversationsArgs = {
  eligibleForClaim?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  petId?: InputMaybe<Scalars['ID']>;
  requestLevels?: InputMaybe<Array<InputMaybe<ConversationRequestLevel>>>;
  size?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCouponArgs = {
  id: Scalars['ID'];
};


export type QueryCouponsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFormResponseArgs = {
  id: Scalars['ID'];
};


export type QueryFulfillmentArgs = {
  id: Scalars['ID'];
};


export type QueryFulfillmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  shipmentStatus?: InputMaybe<FulfillmentShipmentStatus>;
  trackingNumber?: InputMaybe<Scalars['String']>;
};


export type QueryGetAuthInstructionsArgs = {
  username: Scalars['String'];
};


export type QueryGetBookingArgs = {
  id: Scalars['ID'];
};


export type QueryGetBookingAvailabilityArgs = {
  days?: InputMaybe<Scalars['Int']>;
  forRescheduleOf?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  pet?: InputMaybe<Scalars['ID']>;
  serviceType: BookingServiceType;
};


export type QueryGetBookingsArgs = {
  includeCancelled?: InputMaybe<Scalars['Boolean']>;
  includeHold?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  pets?: InputMaybe<Array<Scalars['ID']>>;
  services?: InputMaybe<Array<BookingServiceType>>;
  startsAfter?: InputMaybe<Scalars['DateTime']>;
  startsBefore?: InputMaybe<Scalars['DateTime']>;
};


export type QueryIipOffersArgs = {
  isGroupPolicy?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  limitPerOffer?: InputMaybe<Scalars['Int']>;
  offer?: InputMaybe<Scalars['ID']>;
  pets?: InputMaybe<Array<Scalars['ID']>>;
  skipConsentCheck?: InputMaybe<Scalars['Boolean']>;
  surface?: InputMaybe<IipSurface>;
  targetAnnualLimit?: InputMaybe<Scalars['Int']>;
  targetDeductible?: InputMaybe<Scalars['Int']>;
  targetReimbursementPercentage?: InputMaybe<Scalars['Int']>;
};


export type QueryMedicationArgs = {
  id: Scalars['ID'];
};


export type QueryMedicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  approvedOnly?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryNodeArgs = {
  id: Scalars['ID'];
};


export type QueryOrderV2Args = {
  id: Scalars['ID'];
};


export type QueryOrdersV2Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryPetArgs = {
  pk?: InputMaybe<Scalars['ID']>;
};


export type QueryPetHistoricalInsightsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  petId: Scalars['ID'];
};


export type QueryPetSymptomCheckerResultArgs = {
  id: Scalars['ID'];
};


export type QueryPrescriptionArgs = {
  id: Scalars['ID'];
};


export type QueryPrescriptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clinic?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  pet?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<PrescriptionStatus>;
};


export type QueryPreviewBundleCancellationArgs = {
  bundle: Scalars['String'];
};


export type QueryPreviewCancellationArgs = {
  feature: Scalars['String'];
};


export type QueryProductRecommendationArgs = {
  id: Scalars['ID'];
};


export type QueryProductV2Args = {
  id: Scalars['ID'];
};


export type QueryProductsV2Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryPromoCodeArgs = {
  id: Scalars['ID'];
};


export type QueryPromoCodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryPromotionalClaimsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryQuoteSignupArgs = {
  params: QuoteInput;
};


export type QueryRecommendedProductsArgs = {
  conversationId?: InputMaybe<Scalars['ID']>;
  generatedByAgent?: InputMaybe<Scalars['Boolean']>;
  hasOffer?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  petId?: InputMaybe<Scalars['ID']>;
  productCategorySlugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryShippingAddressArgs = {
  pk?: InputMaybe<Scalars['ID']>;
};


export type QuerySymptomCheckerResponseArgs = {
  id: Scalars['ID'];
};


export type QueryUserConsentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryUserPetInsightArgs = {
  petInsightId: Scalars['ID'];
};


export type QueryUserPetInsightsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  petId?: InputMaybe<Scalars['ID']>;
};


export type QueryUserV2Args = {
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryV2PlanArgs = {
  id: Scalars['ID'];
};


export type QueryV2PlansArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryVariantV2Args = {
  id: Scalars['ID'];
};


export type QueryVariantsV2Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type QuestionGroupNode = {
  __typename?: 'QuestionGroupNode';
  bottomSheet?: Maybe<BottomSheetNode>;
  category?: Maybe<Scalars['String']>;
  categoryBackgroundColor?: Maybe<Scalars['String']>;
  categoryColor?: Maybe<Scalars['String']>;
  categoryIconUrl?: Maybe<Scalars['String']>;
  /** Optional subtitle for a question group, maps to H2 */
  context?: Maybe<Scalars['String']>;
  expandLimit?: Maybe<Scalars['Int']>;
  questions: Array<Maybe<QuestionNode>>;
  /** Text to display for the Skip button. Inherits from question */
  skipText?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  subcategory?: Maybe<Scalars['String']>;
  /** Label for the submit button */
  submitLabel?: Maybe<Scalars['String']>;
  /** Optional title for a question group, maps to H1 */
  title?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
};

export type QuestionGroupResponse = {
  __typename?: 'QuestionGroupResponse';
  formResponse: Scalars['ID'];
  formSlug: Scalars['String'];
  progress: ProgressType;
  progressContext?: Maybe<ProgressContextType>;
  questionGroup: QuestionGroupNode;
};

export type QuestionNode = {
  __typename?: 'QuestionNode';
  canBeEmpty?: Maybe<Scalars['Boolean']>;
  /** True if the question can be skipped */
  canSkip: Scalars['Boolean'];
  choices?: Maybe<ChoiceUnion>;
  emptyValue?: Maybe<Scalars['String']>;
  /** Tooltip to provide more context to a question */
  helperText?: Maybe<Scalars['String']>;
  /** Display an icon somewhere in the question */
  iconUrl?: Maybe<Scalars['String']>;
  /** Display an info icon in the question and info when clicked */
  infoIconText?: Maybe<Scalars['String']>;
  /** Slotted for deprecation - Only used for algolia types, see ChoiceAlgoliaNode */
  modelFilters?: Maybe<ModelFilters>;
  prefilledAnswer?: Maybe<AnswerNode>;
  /** Section header for the question, maps to H3 */
  prompt: Scalars['String'];
  slug: Scalars['String'];
  submitEmptyText?: Maybe<Scalars['String']>;
  type: QuestionType;
  /** Validators to apply to the answer to this question */
  validators: Array<Maybe<ValidatorNode>>;
};

/** Types of questions we might incorporate into a Form's QuestionGroup. */
export enum QuestionType {
  Account = 'ACCOUNT',
  Address = 'ADDRESS',
  AlgoliaChoice = 'ALGOLIA_CHOICE',
  Allergy = 'ALLERGY',
  Checkbox = 'CHECKBOX',
  Choice = 'CHOICE',
  Clinic = 'CLINIC',
  Condition = 'CONDITION',
  Date = 'DATE',
  Datetime = 'DATETIME',
  DatetimeRange = 'DATETIME_RANGE',
  DateRange = 'DATE_RANGE',
  Decimal = 'DECIMAL',
  DecimalRange = 'DECIMAL_RANGE',
  Image = 'IMAGE',
  Integer = 'INTEGER',
  IntegerRange = 'INTEGER_RANGE',
  Medication = 'MEDICATION',
  PaymentMethod = 'PAYMENT_METHOD',
  Pet = 'PET',
  Text = 'TEXT'
}

export type QuoteFeaturesInput = {
  bundles?: InputMaybe<Array<ModifyBundleInput>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  modifyEmergencyProtection?: InputMaybe<ModifyEmergencyProtectionInput>;
  modifyMembership?: InputMaybe<ModifyMembershipInput>;
  purchaseConsumables?: InputMaybe<Array<PurchaseConsumableInput>>;
};

export type QuoteFeaturesPayload = {
  __typename?: 'QuoteFeaturesPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  quote: MembershipQuote;
};

export type QuoteInput = {
  addOns?: InputMaybe<Array<InputMaybe<PlanAddOnInput>>>;
  membership?: InputMaybe<PlanQuoteInput>;
  /** @deprecated Replaced by 'membership' */
  plan?: InputMaybe<Scalars['String']>;
  promoCode?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<Scalars['ID']>;
};

export type QuoteLineInterface = {
  discount: Scalars['Decimal'];
  missingOrIncompletePetFields: Array<IncompletePetDataType>;
  /** List of pet attributes required to checkout. Omits fields already properly set. */
  missingOrIncompleteUserFields: Array<ActionRequiredUserFields>;
  netPrice: Scalars['Decimal'];
  price: Scalars['Decimal'];
  subsidizedBy?: Maybe<PartnerNode>;
  subsidy: Scalars['Decimal'];
};

export type QuoteLineItem = {
  __typename?: 'QuoteLineItem';
  discount: Scalars['Decimal'];
  label: Scalars['String'];
  plan?: Maybe<PlanQuoteConfiguration>;
  price: PriceNode;
  product?: Maybe<ProductNode>;
  /** @deprecated Use 'product' field. */
  productVariant?: Maybe<ProductVariantNode>;
  subtotal: Scalars['Decimal'];
  tax: Scalars['Decimal'];
  total: Scalars['Decimal'];
};

export type QuotePrice = {
  __typename?: 'QuotePrice';
  discount: Scalars['Decimal'];
  lineItems: Array<Maybe<QuoteLineItem>>;
  subtotal: Scalars['Decimal'];
  tax: Scalars['Decimal'];
  total: Scalars['Decimal'];
};

/** An enumeration. */
export enum QuoteRequirement {
  DateOfBirth = 'DATE_OF_BIRTH',
  FullAddress = 'FULL_ADDRESS'
}

export type QuoteResponse = {
  __typename?: 'QuoteResponse';
  checkoutPrice: QuotePrice;
  /** Deprecated, use 'recurring_price' */
  monthlyPrice?: Maybe<QuotePrice>;
  recurringPrice?: Maybe<QuotePrice>;
};

/** RX Booking node for RX bookings. */
export type RxBookingNode = BookingInterface & Node & VisitInterface & {
  __typename?: 'RXBookingNode';
  canCancelWithoutPenalty: Scalars['Boolean'];
  canCheckInAfter?: Maybe<Scalars['DateTime']>;
  canReschedule: Scalars['Boolean'];
  cancelledAt?: Maybe<Scalars['DateTime']>;
  conditionGroup?: Maybe<ConditionGroupNode>;
  confirmedAt?: Maybe<Scalars['DateTime']>;
  conversation?: Maybe<ConversationType>;
  date: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  inQueuePosition?: Maybe<Scalars['Int']>;
  inQueueWaitTime?: Maybe<Scalars['Duration']>;
  intakeStatus: BookingIntakeStatus;
  medications: MedicationNodeConnection;
  pet: PetType;
  placedAt?: Maybe<Scalars['DateTime']>;
  productFamily?: Maybe<ProductFamilyNode>;
  /** RX status of the booking */
  rxStatus: BookingRxStatus;
  startsAt: Scalars['DateTime'];
  status: BookingStatus;
  title: Scalars['String'];
  topicName: Scalars['String'];
};


/** RX Booking node for RX bookings. */
export type RxBookingNodeMedicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type RxVirtualVisitActionNode = ActionInterface & CarePlanActionInterface & ConversationActionInterface & Node & PetTodoInterface & VisitInterface & {
  __typename?: 'RXVirtualVisitActionNode';
  actionType: CarePlanActionType;
  carePlan: CarePlanNode;
  complianceStatus?: Maybe<ComplianceLevel>;
  complianceStatusRecords?: Maybe<CarePlanActionComplianceStatusRecordNodeConnection>;
  conditionGroup?: Maybe<ConditionGroupNode>;
  conversation: ConversationType;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<ProfessionalNode>;
  ctaAction?: Maybe<TodoClientAction>;
  ctaText?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  deadline?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  extendedSubtitle?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  important: Scalars['Boolean'];
  label: Scalars['String'];
  lastEditedBy?: Maybe<ProfessionalNode>;
  notes: Scalars['String'];
  pet: PetType;
  reasoningContent: Scalars['String'];
  reasoningTitle: Scalars['String'];
  slug: Scalars['String'];
  sortingWeight: Scalars['Int'];
  status: ActionStatus;
  subtitle: Scalars['String'];
  title: Scalars['String'];
  topicName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  viewingDraft: Scalars['Boolean'];
};


export type RxVirtualVisitActionNodeComplianceStatusRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type RabiesInput = {
  brand?: InputMaybe<Scalars['String']>;
  tagNumber: Scalars['String'];
};

export type RangeCountValidatorNode = RangeValidatorNode & {
  __typename?: 'RangeCountValidatorNode';
  lower?: Maybe<Scalars['Int']>;
  lowerInclusive: Scalars['Boolean'];
  upper?: Maybe<Scalars['Int']>;
  upperInclusive: Scalars['Boolean'];
};

export type RangeDateValidatorNode = RangeValidatorNode & {
  __typename?: 'RangeDateValidatorNode';
  lower?: Maybe<Scalars['Date']>;
  lowerInclusive: Scalars['Boolean'];
  upper?: Maybe<Scalars['Date']>;
  upperInclusive: Scalars['Boolean'];
};

export type RangeDatetimeValidatorNode = RangeValidatorNode & {
  __typename?: 'RangeDatetimeValidatorNode';
  lower?: Maybe<Scalars['DateTime']>;
  lowerInclusive: Scalars['Boolean'];
  upper?: Maybe<Scalars['DateTime']>;
  upperInclusive: Scalars['Boolean'];
};

export type RangeDecimalValidatorNode = RangeValidatorNode & {
  __typename?: 'RangeDecimalValidatorNode';
  lower?: Maybe<Scalars['Decimal']>;
  lowerInclusive: Scalars['Boolean'];
  upper?: Maybe<Scalars['Decimal']>;
  upperInclusive: Scalars['Boolean'];
};

export type RangeIntegerValidatorNode = RangeValidatorNode & {
  __typename?: 'RangeIntegerValidatorNode';
  lower?: Maybe<Scalars['Int']>;
  lowerInclusive: Scalars['Boolean'];
  upper?: Maybe<Scalars['Int']>;
  upperInclusive: Scalars['Boolean'];
};

export type RangeValidatorNode = {
  lowerInclusive: Scalars['Boolean'];
  upperInclusive: Scalars['Boolean'];
};

export type ReadArticle = {
  __typename?: 'ReadArticle';
  slug: Scalars['String'];
};

/** An enumeration. */
export enum ReasonForNoVisit {
  ICantAffordIt = 'I_CANT_AFFORD_IT',
  ICantFindAnAppointment = 'I_CANT_FIND_AN_APPOINTMENT',
  IHaventHadTime = 'I_HAVENT_HAD_TIME',
  MyPetIsFeelingBetter = 'MY_PET_IS_FEELING_BETTER',
  Other = 'OTHER'
}

/** An enumeration. */
export enum ReasonsForNoConversation {
  ConditionWorsened = 'CONDITION_WORSENED',
  MemberNotPresent = 'MEMBER_NOT_PRESENT',
  Other = 'OTHER',
  SevereAccident = 'SEVERE_ACCIDENT',
  Unaware = 'UNAWARE'
}

/** Deprecated type - kept around for old clients. Please use RecommendationNode instead. */
export type RecommendationCarePlanActionNode = ActionInterface & CarePlanActionInterface & Node & {
  __typename?: 'RecommendationCarePlanActionNode';
  actionType: CarePlanActionType;
  carePlan: CarePlanNode;
  complianceStatus?: Maybe<ComplianceLevel>;
  complianceStatusRecords?: Maybe<CarePlanActionComplianceStatusRecordNodeConnection>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<ProfessionalNode>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  externalProductTitle: Scalars['String'];
  externalUrls: Array<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  important: Scalars['Boolean'];
  label: Scalars['String'];
  lastEditedBy?: Maybe<ProfessionalNode>;
  notes: Scalars['String'];
  order?: Maybe<OrderV2Node>;
  product?: Maybe<ProductNode>;
  productGuidance: Scalars['String'];
  purchasedExternally?: Maybe<Scalars['Boolean']>;
  reasoningContent: Scalars['String'];
  reasoningTitle: Scalars['String'];
  slug: Scalars['String'];
  sortingWeight: Scalars['Int'];
  status: ActionStatus;
  subtitle?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  viewingDraft: Scalars['Boolean'];
};


/** Deprecated type - kept around for old clients. Please use RecommendationNode instead. */
export type RecommendationCarePlanActionNodeComplianceStatusRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** An enumeration. */
export enum RecommendationExternalService {
  Contentful = 'CONTENTFUL'
}

export type RecommendationNode = ArticleRecommendationNode | ExternalLinkRecommendationNode | ProductRecommendationNodeV2;

/** An enumeration. */
export enum RecommendationType {
  Article = 'ARTICLE',
  ExternalLink = 'EXTERNAL_LINK',
  Product = 'PRODUCT'
}

export type RecordUserConsentInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  consentCategory?: InputMaybe<ConsentCategory>;
  consentType?: InputMaybe<Scalars['ID']>;
  status: UserConsentStatus;
};

export type RecordUserConsentPayload = {
  __typename?: 'RecordUserConsentPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  userConsent: UserConsentNode;
};

export type RedirectResponse = {
  __typename?: 'RedirectResponse';
  /** JSON blob to be parsed by the outbound page. */
  redirectContext: Scalars['String'];
  /** Determines the page a user should be directed to on submission. */
  redirectSlug: Scalars['String'];
};

export type ReferralDataType = {
  __typename?: 'ReferralDataType';
  link: Scalars['String'];
  message: Scalars['String'];
};

export type RefreshTokens = {
  __typename?: 'RefreshTokens';
  accessToken: Scalars['String'];
  idToken: Scalars['String'];
  refreshToken: Scalars['String'];
};

export type Refund = Node & {
  __typename?: 'Refund';
  amount: Scalars['Decimal'];
  comments: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  processorId: Scalars['String'];
  reason: RefundReason;
  status: RefundStatus;
};

export type RefundConnection = {
  __typename?: 'RefundConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RefundEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `Refund` and its cursor. */
export type RefundEdge = {
  __typename?: 'RefundEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Refund>;
};

/** An enumeration. */
export enum RefundReason {
  BannedUser = 'BANNED_USER',
  DidNotPurchase = 'DID_NOT_PURCHASE',
  Duplicate = 'DUPLICATE',
  Fraudulent = 'FRAUDULENT',
  MissingItem = 'MISSING_ITEM',
  Other = 'OTHER',
  RequestedByUser = 'REQUESTED_BY_USER',
  UnusedSubscriptionTime = 'UNUSED_SUBSCRIPTION_TIME'
}

/** An enumeration. */
export enum RefundStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED'
}

export type RegisterDeviceInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  device: DeviceInput;
};

/** Register a user device - used for sending push notifications. */
export type RegisterDevicePayload = {
  __typename?: 'RegisterDevicePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  device: DeviceNode;
};

/** An enumeration. */
export enum ReissueReason {
  Admin = 'ADMIN',
  Grace = 'GRACE',
  InternalError = 'INTERNAL_ERROR',
  ServiceFailure = 'SERVICE_FAILURE',
  Unsatisfied = 'UNSATISFIED',
  ValidChange = 'VALID_CHANGE'
}

/** Deprecated type - kept around for old clients. Please use RecommendationNode instead. */
export type RelatedResourceCarePlanActionNode = ActionInterface & CarePlanActionInterface & Node & {
  __typename?: 'RelatedResourceCarePlanActionNode';
  actionType: CarePlanActionType;
  carePlan: CarePlanNode;
  complianceStatus?: Maybe<ComplianceLevel>;
  complianceStatusRecords?: Maybe<CarePlanActionComplianceStatusRecordNodeConnection>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<ProfessionalNode>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  externalService: SharedArticleExternalServices;
  icon?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  important: Scalars['Boolean'];
  label: Scalars['String'];
  lastEditedBy?: Maybe<ProfessionalNode>;
  name: Scalars['String'];
  notes: Scalars['String'];
  reasoningContent: Scalars['String'];
  reasoningTitle: Scalars['String'];
  slug: Scalars['String'];
  sortingWeight: Scalars['Int'];
  status: ActionStatus;
  subtitle?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  viewingDraft: Scalars['Boolean'];
};


/** Deprecated type - kept around for old clients. Please use RecommendationNode instead. */
export type RelatedResourceCarePlanActionNodeComplianceStatusRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ReleasePhoneNumberInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type ReleasePhoneNumberPayload = {
  __typename?: 'ReleasePhoneNumberPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type RemainingUses = {
  __typename?: 'RemainingUses';
  /** Null means unlimited */
  month?: Maybe<Scalars['Int']>;
  /** Null means unlimited */
  today?: Maybe<Scalars['Int']>;
  /** Null means unlimited */
  week?: Maybe<Scalars['Int']>;
  /** Null means unlimited */
  year?: Maybe<Scalars['Int']>;
};

export type RemoveAddOnInput = {
  addOnStatus: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type RemoveAddOnPayload = {
  __typename?: 'RemoveAddOnPayload';
  addOn: AddOnStatusNode;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type RemoveClaimRequestAttachmentsInput = {
  claimRequest: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  removeAttachments: Array<Scalars['ID']>;
};

export type RemoveClaimRequestAttachmentsPayload = {
  __typename?: 'RemoveClaimRequestAttachmentsPayload';
  claimRequest?: Maybe<ClaimRequestNode>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum RenewalCadence {
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY'
}

export type RenewalQuoteLineInterface = {
  /** Amount user needs to pay at checkout. */
  amountDue: Scalars['Decimal'];
  /** Current net price the user pays, if any. */
  currentNetPrice?: Maybe<Scalars['Decimal']>;
  /** What the user currently pays for this feature, if any. */
  currentPrice?: Maybe<Scalars['Decimal']>;
  /** Current subsidy amount, if any. */
  currentSubsidy?: Maybe<Scalars['Decimal']>;
  existingSubscription?: Maybe<SubscriptionNode>;
  /** Null if this is fully subsidized. */
  renewalCadence?: Maybe<RenewalCadence>;
};

export type RequestGuestSession = {
  __typename?: 'RequestGuestSession';
  identifier?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type RequestTwilioAccessToken = {
  __typename?: 'RequestTwilioAccessToken';
  twilioAccessToken?: Maybe<Scalars['String']>;
};

export type RequestVideoV2 = {
  __typename?: 'RequestVideoV2';
  twilioAccessToken?: Maybe<Scalars['String']>;
  videoRoom?: Maybe<VideoRoomType>;
};

export type RescheduleBookingInput = {
  booking: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
};

export type RescheduleBookingPayload = {
  __typename?: 'RescheduleBookingPayload';
  booking: BookingInterface;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ResetPassword = {
  __typename?: 'ResetPassword';
  success?: Maybe<Scalars['Boolean']>;
};

export type ResolvePetDetailInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  petDetail: Scalars['ID'];
  resolvedAt?: InputMaybe<Scalars['DateTime']>;
};

/** Used to resolve a pet detail */
export type ResolvePetDetailPayload = {
  __typename?: 'ResolvePetDetailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  petDetail: PetDetailNode;
};

export type ReviewCareAction = {
  __typename?: 'ReviewCareAction';
  careActionId: Scalars['ID'];
  conversationId: Scalars['ID'];
  petId: Scalars['ID'];
};

export type ReviewProgram = {
  __typename?: 'ReviewProgram';
  petId: Scalars['ID'];
};

/** An enumeration. */
export enum Roles {
  Admin = 'ADMIN',
  /** This role has permission to edit and republish all care plans */
  CarePlanAdmin = 'CARE_PLAN_ADMIN',
  ClaimProcessor = 'CLAIM_PROCESSOR',
  /** Consumer */
  Core = 'CORE',
  /** Django admin: full access */
  DjangoAdminAll = 'DJANGO_ADMIN_ALL',
  /** Django admin: view only */
  DjangoAdminReadOnly = 'DJANGO_ADMIN_READ_ONLY',
  MedicalQa = 'MEDICAL_QA',
  MedOps = 'MED_OPS',
  Owner = 'OWNER',
  Pro = 'PRO',
  RxPro = 'RX_PRO',
  ShiftLead = 'SHIFT_LEAD',
  Supplier = 'SUPPLIER',
  Training = 'TRAINING',
  TriageQa = 'TRIAGE_QA'
}

export type SaveCarePlanActionFeedbackInput = {
  action: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  feedbackType: CarePlanActionFeedbackType;
  notes?: InputMaybe<Scalars['String']>;
};

export type SaveCarePlanActionFeedbackPayload = {
  __typename?: 'SaveCarePlanActionFeedbackPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  feedback: CarePlanActionFeedbackNode;
};

export type SaveInPersonVisitResultInput = {
  action: Scalars['ID'];
  actualVisitDate?: InputMaybe<Scalars['DateTime']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  clinicLocation?: InputMaybe<Scalars['ID']>;
  clinicLocationRating?: InputMaybe<Scalars['Int']>;
  clinicLocationReview?: InputMaybe<Scalars['String']>;
  documents?: InputMaybe<Array<InputMaybe<Scalars['DocumentFileUpload']>>>;
  reasonForNoVisit?: InputMaybe<ReasonForNoVisit>;
  visitDetails?: InputMaybe<Scalars['String']>;
};

export type SaveInPersonVisitResultPayload = {
  __typename?: 'SaveInPersonVisitResultPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  inPersonVisitResult: InPersonVisitResultNode;
};

export type SavePetDetailInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  detail: PetDetailInput;
  pet: Scalars['ID'];
};

export type SavePetDetailPayload = {
  __typename?: 'SavePetDetailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  petDetail: PetDetailNode;
};

export type SaveUserSatisfactionSurveyInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['Int']>;
  surveyTrigger: Scalars['String'];
};

export type SaveUserSatisfactionSurveyPayload = {
  __typename?: 'SaveUserSatisfactionSurveyPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  userSatisfactionSurvey: UserSatisfactionSurveyNode;
};

export type ScentType = {
  __typename?: 'ScentType';
  activeIcon?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identifier?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

/** Deprecated type - kept around for old clients. Please use `InPersonVisitActionNode` instead */
export type ScheduleAppointmentCarePlanActionNode = ActionInterface & CarePlanActionInterface & Node & {
  __typename?: 'ScheduleAppointmentCarePlanActionNode';
  actionType: CarePlanActionType;
  bookedWithExternalService?: Maybe<Scalars['Boolean']>;
  carePlan: CarePlanNode;
  complianceStatus?: Maybe<ComplianceLevel>;
  complianceStatusRecords?: Maybe<CarePlanActionComplianceStatusRecordNodeConnection>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<ProfessionalNode>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  icon?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  important: Scalars['Boolean'];
  label: Scalars['String'];
  lastEditedBy?: Maybe<ProfessionalNode>;
  notes: Scalars['String'];
  pausedUntil?: Maybe<Scalars['DateTime']>;
  providerType: Scalars['String'];
  reasoningContent: Scalars['String'];
  reasoningTitle: Scalars['String'];
  scheduleByDeadline?: Maybe<Scalars['DateTime']>;
  scheduledBooking?: Maybe<Scalars['DateTime']>;
  slug: Scalars['String'];
  sortingWeight: Scalars['Int'];
  status: ActionStatus;
  subtitle?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  viewingDraft: Scalars['Boolean'];
};


/** Deprecated type - kept around for old clients. Please use `InPersonVisitActionNode` instead */
export type ScheduleAppointmentCarePlanActionNodeComplianceStatusRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type SchemaRole = {
  __typename?: 'SchemaRole';
  role: Roles;
  schemas: Array<SchemaTypes>;
};

/** An enumeration. */
export enum SchemaTypes {
  Admin = 'ADMIN',
  Core = 'CORE',
  Pro = 'PRO'
}

/** An enumeration. */
export enum Season {
  Fall = 'FALL',
  Spring = 'SPRING',
  Summer = 'SUMMER',
  Winter = 'WINTER'
}

export type SelectPlanInput = {
  addOns?: InputMaybe<Array<InputMaybe<PlanAddOnInput>>>;
  configuration?: InputMaybe<Scalars['String']>;
  interval?: InputMaybe<Scalars['Int']>;
  /** This is deprecated; use the same argument directly on the mutation */
  newPaymentMethod?: InputMaybe<CreateUserPaymentMethodInput>;
  period?: InputMaybe<Period>;
  /** Plan slug */
  plan: Scalars['Slug'];
  promoCode?: InputMaybe<Scalars['String']>;
  startInTrial?: InputMaybe<Scalars['Boolean']>;
};

export type SendEmailVerificationCode = {
  __typename?: 'SendEmailVerificationCode';
  success?: Maybe<Scalars['Boolean']>;
};

export type SendOtpInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
};

export type SendOtpPayload = {
  __typename?: 'SendOTPPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SetUserPlanInput = {
  attribution?: InputMaybe<AttributionInput>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  newPaymentMethod?: InputMaybe<CreateUserPaymentMethodInput>;
  plan?: InputMaybe<SelectPlanInput>;
  updateUser?: InputMaybe<UpdateUserInput>;
};

export type SetUserPlanPayload = {
  __typename?: 'SetUserPlanPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  login?: Maybe<LoginType>;
  userPlan: UserPlanNode;
};

/** An enumeration. */
export enum SharedArticleExternalServices {
  Contentful = 'CONTENTFUL'
}

/** An enumeration. */
export enum ShippingAddressState {
  /** Alaska */
  Ak = 'AK',
  /** Alabama */
  Al = 'AL',
  /** Arkansas */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Arizona */
  Az = 'AZ',
  /** California */
  Ca = 'CA',
  /** Colorado */
  Co = 'CO',
  /** Connecticut */
  Ct = 'CT',
  /** District Of Columbia */
  Dc = 'DC',
  /** Delaware */
  De = 'DE',
  /** Florida */
  Fl = 'FL',
  /** Federated States Of Micronesia */
  Fm = 'FM',
  /** Georgia */
  Ga = 'GA',
  /** Guam */
  Gu = 'GU',
  /** Hawaii */
  Hi = 'HI',
  /** Iowa */
  Ia = 'IA',
  /** Idaho */
  Id = 'ID',
  /** Illinois */
  Il = 'IL',
  /** Indiana */
  In = 'IN',
  /** Kansas */
  Ks = 'KS',
  /** Kentucky */
  Ky = 'KY',
  /** Louisiana */
  La = 'LA',
  /** Massachusetts */
  Ma = 'MA',
  /** Maryland */
  Md = 'MD',
  /** Maine */
  Me = 'ME',
  /** Marshall Islands */
  Mh = 'MH',
  /** Michigan */
  Mi = 'MI',
  /** Minnesota */
  Mn = 'MN',
  /** Missouri */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Mississippi */
  Ms = 'MS',
  /** Montana */
  Mt = 'MT',
  /** North Carolina */
  Nc = 'NC',
  /** North Dakota */
  Nd = 'ND',
  /** Nebraska */
  Ne = 'NE',
  /** New Hampshire */
  Nh = 'NH',
  /** New Jersey */
  Nj = 'NJ',
  /** New Mexico */
  Nm = 'NM',
  /** Nevada */
  Nv = 'NV',
  /** New York */
  Ny = 'NY',
  /** Ohio */
  Oh = 'OH',
  /** Oklahoma */
  Ok = 'OK',
  /** Oregon */
  Or = 'OR',
  /** Pennsylvania */
  Pa = 'PA',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palau */
  Pw = 'PW',
  /** Rhode Island */
  Ri = 'RI',
  /** South Carolina */
  Sc = 'SC',
  /** South Dakota */
  Sd = 'SD',
  /** Tennessee */
  Tn = 'TN',
  /** Texas */
  Tx = 'TX',
  /** Utah */
  Ut = 'UT',
  /** Virginia */
  Va = 'VA',
  /** Virgin Islands */
  Vi = 'VI',
  /** Vermont */
  Vt = 'VT',
  /** Washington */
  Wa = 'WA',
  /** Wisconsin */
  Wi = 'WI',
  /** West Virginia */
  Wv = 'WV',
  /** Wyoming */
  Wy = 'WY'
}

export type ShippingAddressType = {
  __typename?: 'ShippingAddressType';
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  firstName: Scalars['String'];
  formattedAddress?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isPrimary: Scalars['Boolean'];
  lastName: Scalars['String'];
  latitude?: Maybe<Scalars['Decimal']>;
  longitude?: Maybe<Scalars['Decimal']>;
  neighborhood?: Maybe<Array<Scalars['String']>>;
  poBox?: Maybe<Scalars['String']>;
  state: ShippingAddressState;
  user: MemberType;
  zip: Scalars['String'];
};

export type SignupV2Input = {
  attribution?: InputMaybe<AttributionInput>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  partner?: InputMaybe<Scalars['String']>;
  partnerCode?: InputMaybe<Scalars['String']>;
  partnerOauthCode?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  username: Scalars['String'];
};

export type SignupV2Payload = {
  __typename?: 'SignupV2Payload';
  clientMutationId?: Maybe<Scalars['String']>;
  login?: Maybe<LoginType>;
};

export type StartLiveVisit = {
  __typename?: 'StartLiveVisit';
  petId: Scalars['ID'];
};

export type StartPeriodicCheckinInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pet: Scalars['ID'];
};

export type StartPeriodicCheckinPayload = {
  __typename?: 'StartPeriodicCheckinPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  response: NextResponse;
};

export type SubmitClaimRequestInput = {
  claimRequest: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type SubmitClaimRequestPayload = {
  __typename?: 'SubmitClaimRequestPayload';
  claimRequest?: Maybe<ClaimRequestNode>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type SubmitClaimRequestPaymentMethodInput = {
  accountNumber?: InputMaybe<Scalars['String']>;
  accountType?: InputMaybe<AccountTypes>;
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  claimRequest: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  methodType: MethodTypes;
  routingNumber?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type SubmitClaimRequestPaymentMethodPayload = {
  __typename?: 'SubmitClaimRequestPaymentMethodPayload';
  claimRequest?: Maybe<ClaimRequestNode>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type SubmitRating = {
  __typename?: 'SubmitRating';
  rating?: Maybe<ClinicLocationRatingType>;
};

export type SubscribableConsumable = Node & SubscribableFeatureInterface & {
  __typename?: 'SubscribableConsumable';
  consumableFeature: ConsumableFeatureTier;
  defaultRenewalCadence: RenewalCadence;
  description: Scalars['String'];
  id: Scalars['ID'];
  monthlyPrice?: Maybe<Scalars['Decimal']>;
  name: Scalars['String'];
  quantityPerRenewal: Scalars['Int'];
  rolloverUnusedOnRenewal: Scalars['Boolean'];
  slug: Scalars['Slug'];
  subscriptionOptions: Array<SubscribablePriceOption>;
  yearlyPrice?: Maybe<Scalars['Decimal']>;
};

export type SubscribableFeatureInterface = {
  defaultRenewalCadence: RenewalCadence;
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['Slug'];
};

export type SubscribablePriceOption = {
  __typename?: 'SubscribablePriceOption';
  price: Scalars['Decimal'];
  renewalCadence: RenewalCadence;
  /** Trial duration is contextual and will apply logic based on potential LTO offers, whether the feature would be subsidized, whether this offers trials at all, etc. If null the user cannot add this feature as a trial. */
  trialDuration?: Maybe<Scalars['Duration']>;
};

export type SubscribableQuoteLineInterface = {
  feature: SubscribableFeatureInterface;
};

/** CORE interface — extends base with subscription billing field. */
export type SubscribedFeatureInterface = {
  activatedAt?: Maybe<Scalars['DateTime']>;
  downgradeOptions: Array<SubscribableFeatureInterface>;
  subscription?: Maybe<SubscriptionNode>;
  terminatedAt?: Maybe<Scalars['DateTime']>;
  trialDuration?: Maybe<Scalars['Duration']>;
  trialEndsAt?: Maybe<Scalars['DateTime']>;
  trialing: Scalars['Boolean'];
  upgradeOptions: Array<SubscribableFeatureInterface>;
};


/** CORE interface — extends base with subscription billing field. */
export type SubscribedFeatureInterfaceDowngradeOptionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


/** CORE interface — extends base with subscription billing field. */
export type SubscribedFeatureInterfaceUpgradeOptionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type SubscriptionLineNode = Node & {
  __typename?: 'SubscriptionLineNode';
  /** The ID of the object */
  id: Scalars['ID'];
  price: PriceNode;
  quantity: Scalars['Int'];
  remoteId: Scalars['String'];
  subscription: SubscriptionNode;
};

export type SubscriptionLineNodeConnection = {
  __typename?: 'SubscriptionLineNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SubscriptionLineNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `SubscriptionLineNode` and its cursor. */
export type SubscriptionLineNodeEdge = {
  __typename?: 'SubscriptionLineNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SubscriptionLineNode>;
};

export type SubscriptionNode = Node & {
  __typename?: 'SubscriptionNode';
  createdAt: Scalars['DateTime'];
  currentPeriodEndsAt?: Maybe<Scalars['DateTime']>;
  endedAt?: Maybe<Scalars['DateTime']>;
  /** The ID of the object */
  id: Scalars['ID'];
  interval: Scalars['Int'];
  lineItems?: Maybe<SubscriptionLineNodeConnection>;
  nextInvoiceDate?: Maybe<Scalars['DateTime']>;
  paymentMethod?: Maybe<PaymentMethodNode>;
  period: Period;
  processorApi: PaymentProcessor;
  processorId: Scalars['String'];
  status: SubscriptionStatus;
  updatedAt: Scalars['DateTime'];
};


export type SubscriptionNodeLineItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['ID']>;
};

/** An enumeration. */
export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Incomplete = 'INCOMPLETE',
  PastDue = 'PAST_DUE',
  Trial = 'TRIAL',
  Unpaid = 'UNPAID'
}

export type SuggestProductFamilyInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type SuggestProductFamilyPayload = {
  __typename?: 'SuggestProductFamilyPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  productFamilySuggestion?: Maybe<ProductFamilySuggestionNode>;
};

export type SupplierNode = Node & {
  __typename?: 'SupplierNode';
  faxNumber?: Maybe<Scalars['String']>;
  groupId: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
  rxEmail: Scalars['String'];
};

export type SymptomCheckerResponseType = Node & {
  __typename?: 'SymptomCheckerResponseType';
  content: Scalars['JSONString'];
  conversationTopic?: Maybe<ConversationTopicType>;
  /** The ID of the object */
  id: Scalars['ID'];
  severity?: Maybe<ConversationSeverityLevel>;
  severityLevel: SymptomSeverityLevel;
};

export type SymptomDetail = {
  __typename?: 'SymptomDetail';
  choices?: Maybe<Array<Scalars['String']>>;
  isBoolean: Scalars['Boolean'];
  isMultiselect: Scalars['Boolean'];
  label: Scalars['String'];
  /** Key used to record answer in the answer's meta field. Only needs to be unique in the context of a single Symptom */
  slug: Scalars['String'];
};

export type SymptomNode = Node & {
  __typename?: 'SymptomNode';
  details: Array<Maybe<SymptomDetail>>;
  /** The ID of the object */
  id: Scalars['ID'];
  label: Scalars['String'];
  possibleLocations: Array<SymptomDetail>;
  slug: Scalars['String'];
  usesDuration: Scalars['Boolean'];
  usesOnset: Scalars['Boolean'];
};

export type SymptomNodeConnection = {
  __typename?: 'SymptomNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SymptomNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `SymptomNode` and its cursor. */
export type SymptomNodeEdge = {
  __typename?: 'SymptomNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SymptomNode>;
};

/** An enumeration. */
export enum SymptomSeverityLevel {
  High = 'HIGH',
  Immediate = 'IMMEDIATE',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Monitor = 'MONITOR',
  None = 'NONE'
}

export type TextPetDetailNode = Node & PetDetailInterface & {
  __typename?: 'TextPetDetailNode';
  createdAt: Scalars['DateTime'];
  diagnosticQuestion: DiagnosticQuestionNode;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  meetsTarget?: Maybe<Scalars['Boolean']>;
  occurredAfter?: Maybe<Scalars['DateTime']>;
  occurredBefore?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  slug: Scalars['String'];
  staleAt?: Maybe<Scalars['DateTime']>;
  textValue?: Maybe<Scalars['String']>;
  triggersInPersonVisit?: Maybe<Scalars['Boolean']>;
  triggersLiveVisit?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum TierPricingType {
  Flat = 'FLAT',
  PerUnit = 'PER_UNIT'
}

/** An enumeration. */
export enum TodoClientAction {
  BookRxVisit = 'BOOK_RX_VISIT',
  CareActionDetail = 'CARE_ACTION_DETAIL',
  ExploreFinancialProtection = 'EXPLORE_FINANCIAL_PROTECTION',
  OpenMaps = 'OPEN_MAPS',
  StartLiveVisit = 'START_LIVE_VISIT',
  ViewIipQuote = 'VIEW_IIP_QUOTE',
  ViewPrescription = 'VIEW_PRESCRIPTION',
  ViewPrescriptions = 'VIEW_PRESCRIPTIONS'
}

export type TrackPetInsightEventsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** List of insight events to track */
  events: Array<PetInsightEventInput>;
};

/** Track lifecycle events for pet insights. */
export type TrackPetInsightEventsPayload = {
  __typename?: 'TrackPetInsightEventsPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  processedCount?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum TrialOptions {
  NoTrial = 'NO_TRIAL',
  StartInTrial = 'START_IN_TRIAL',
  TrialIfAvailable = 'TRIAL_IF_AVAILABLE'
}

/** States in the United States */
export enum UsStates {
  /** Alaska */
  Ak = 'AK',
  /** Alabama */
  Al = 'AL',
  /** Arkansas */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Arizona */
  Az = 'AZ',
  /** California */
  Ca = 'CA',
  /** Colorado */
  Co = 'CO',
  /** Connecticut */
  Ct = 'CT',
  /** District Of Columbia */
  Dc = 'DC',
  /** Delaware */
  De = 'DE',
  /** Florida */
  Fl = 'FL',
  /** Federated States Of Micronesia */
  Fm = 'FM',
  /** Georgia */
  Ga = 'GA',
  /** Guam */
  Gu = 'GU',
  /** Hawaii */
  Hi = 'HI',
  /** Iowa */
  Ia = 'IA',
  /** Idaho */
  Id = 'ID',
  /** Illinois */
  Il = 'IL',
  /** Indiana */
  In = 'IN',
  /** Kansas */
  Ks = 'KS',
  /** Kentucky */
  Ky = 'KY',
  /** Louisiana */
  La = 'LA',
  /** Massachusetts */
  Ma = 'MA',
  /** Maryland */
  Md = 'MD',
  /** Maine */
  Me = 'ME',
  /** Marshall Islands */
  Mh = 'MH',
  /** Michigan */
  Mi = 'MI',
  /** Minnesota */
  Mn = 'MN',
  /** Missouri */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Mississippi */
  Ms = 'MS',
  /** Montana */
  Mt = 'MT',
  /** North Carolina */
  Nc = 'NC',
  /** North Dakota */
  Nd = 'ND',
  /** Nebraska */
  Ne = 'NE',
  /** New Hampshire */
  Nh = 'NH',
  /** New Jersey */
  Nj = 'NJ',
  /** New Mexico */
  Nm = 'NM',
  /** Nevada */
  Nv = 'NV',
  /** New York */
  Ny = 'NY',
  /** Ohio */
  Oh = 'OH',
  /** Oklahoma */
  Ok = 'OK',
  /** Oregon */
  Or = 'OR',
  /** Pennsylvania */
  Pa = 'PA',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palau */
  Pw = 'PW',
  /** Rhode Island */
  Ri = 'RI',
  /** South Carolina */
  Sc = 'SC',
  /** South Dakota */
  Sd = 'SD',
  /** Tennessee */
  Tn = 'TN',
  /** Texas */
  Tx = 'TX',
  /** Utah */
  Ut = 'UT',
  /** Virginia */
  Va = 'VA',
  /** Virgin Islands */
  Vi = 'VI',
  /** Vermont */
  Vt = 'VT',
  /** Washington */
  Wa = 'WA',
  /** Wisconsin */
  Wi = 'WI',
  /** West Virginia */
  Wv = 'WV',
  /** Wyoming */
  Wy = 'WY'
}

export type UnsubscribeFromMarketingEmails = {
  __typename?: 'UnsubscribeFromMarketingEmails';
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateAutoshipPlanInput = {
  autoshipPlanId: Scalars['ID'];
  billingCycle?: InputMaybe<BillingCycleInput>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['ID']>;
};

export type UpdateAutoshipPlanPayload = {
  __typename?: 'UpdateAutoshipPlanPayload';
  autoshipPlan?: Maybe<AutoshipPlanNode>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateCart = {
  __typename?: 'UpdateCart';
  /** @deprecated Replaced by 'cartV2' */
  cart: CartNode;
  cartV2: CartNodeV2;
};

export type UpdateCartLineItemInput = {
  interval?: InputMaybe<Scalars['Int']>;
  period?: InputMaybe<Period>;
  productVariantId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type UpdateClaimRequestInput = {
  category?: InputMaybe<ClaimCategories>;
  claimRequest: Scalars['ID'];
  claimedAmount?: InputMaybe<Scalars['Decimal']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  clinicLocations?: InputMaybe<Array<Scalars['ID']>>;
  conversation?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  pet?: InputMaybe<Scalars['ID']>;
  reasonForNoConversation?: InputMaybe<ReasonsForNoConversation>;
};

export type UpdateClaimRequestPayload = {
  __typename?: 'UpdateClaimRequestPayload';
  claimRequest?: Maybe<ClaimRequestNode>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateClinicInput = {
  address?: InputMaybe<AddressInput>;
  addressId?: InputMaybe<Scalars['ID']>;
  clinicId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateClinicNodeInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  clinic: UpdateClinicInput;
};

export type UpdateClinicNodePayload = {
  __typename?: 'UpdateClinicNodePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  clinic?: Maybe<CoreClinicNode>;
};

export type UpdateConversation = {
  __typename?: 'UpdateConversation';
  conversation?: Maybe<ConversationType>;
};

export type UpdateEmailInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  newEmail: Scalars['String'];
};

export type UpdateEmailPayload = {
  __typename?: 'UpdateEmailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateEmergencyFundPolicyPetsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  petsToAdd?: InputMaybe<Array<Scalars['ID']>>;
  petsToRemove?: InputMaybe<Array<Scalars['ID']>>;
  policy: Scalars['ID'];
};

export type UpdateEmergencyFundPolicyPetsPayload = {
  __typename?: 'UpdateEmergencyFundPolicyPetsPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  policy: EmergencyFundPolicyNode;
};

export type UpdatePeriodicCheckInInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  periodicCheckIn: Scalars['ID'];
  resultsViewed?: InputMaybe<Scalars['Boolean']>;
};

export type UpdatePeriodicCheckInPayload = {
  __typename?: 'UpdatePeriodicCheckInPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  periodicCheckIn: PeriodicCheckInNode;
};

export type UpdatePet = {
  __typename?: 'UpdatePet';
  pet?: Maybe<PetType>;
};

export type UpdatePetMedicalRecordInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  clinic?: InputMaybe<Scalars['ID']>;
  medicalRecord: Scalars['ID'];
};

export type UpdatePetMedicalRecordPayload = {
  __typename?: 'UpdatePetMedicalRecordPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  medicalRecord: MedicalRecordNode;
};

export type UpdateShippingAddress = {
  __typename?: 'UpdateShippingAddress';
  shippingAddress?: Maybe<ShippingAddressType>;
};

export type UpdateUser = {
  __typename?: 'UpdateUser';
  alert?: Maybe<Scalars['String']>;
  user?: Maybe<UserType>;
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

export type UploadClaimRequestAttachmentInput = {
  attachmentType: ClaimAttachmentAttachmentType;
  claimRequest: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  clinicLocation?: InputMaybe<Scalars['ID']>;
  file: Scalars['ClaimAttachmentUpload'];
  notes?: InputMaybe<Scalars['String']>;
};

export type UploadClaimRequestAttachmentPayload = {
  __typename?: 'UploadClaimRequestAttachmentPayload';
  claimRequest?: Maybe<ClaimRequestNode>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UploadPetMedicalRecordInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  clinic?: InputMaybe<Scalars['ID']>;
  pet: Scalars['ID'];
  records: Array<InputMaybe<Scalars['DocumentFileUpload']>>;
};

export type UploadPetMedicalRecordPayload = {
  __typename?: 'UploadPetMedicalRecordPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  medicalRecord: MedicalRecordNode;
};

export type UploadRequiredHeaderType = {
  __typename?: 'UploadRequiredHeaderType';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type UserAlgoliaKeyType = {
  __typename?: 'UserAlgoliaKeyType';
  algoliaKey?: Maybe<Scalars['String']>;
};

export type UserConsentNode = Node & {
  __typename?: 'UserConsentNode';
  /** When the user actually performed this consent action (grant/revoke) */
  actionTakenAt: Scalars['DateTime'];
  consentType: ConsentTypeNode;
  /** The ID of the object */
  id: Scalars['ID'];
  status: UserConsentStatus;
  user: UserType;
};

export type UserConsentNodeConnection = {
  __typename?: 'UserConsentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserConsentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `UserConsentNode` and its cursor. */
export type UserConsentNodeEdge = {
  __typename?: 'UserConsentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<UserConsentNode>;
};

/** An enumeration. */
export enum UserConsentStatus {
  Granted = 'GRANTED',
  Revoked = 'REVOKED'
}

export type UserExperimentType = {
  __typename?: 'UserExperimentType';
  experiment?: Maybe<Scalars['String']>;
  variantName?: Maybe<Scalars['String']>;
  variantValue?: Maybe<Scalars['String']>;
};

export type UserPartnerNode = Node & {
  __typename?: 'UserPartnerNode';
  claimMethod: PartnerClaimMethod;
  code?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  linkError?: Maybe<Scalars['String']>;
  /** The email the user needs to have verified for the partner link to be satisfied. Only the 'linkedEmail' or 'linkedPhoneNumber' need to be verified if both are set. */
  linkedEmail?: Maybe<Scalars['String']>;
  /** The phone number the user needs to have verified for the partner link to be satisfied. Only the 'linkedEmail' or 'linkedPhoneNumber' need to be verified if both are set. */
  linkedPhoneNumber?: Maybe<Scalars['String']>;
  partner: PartnerNode;
  planBenefits: Array<PartnerPlan>;
  user: UserType;
};


export type UserPartnerNodePlanBenefitsArgs = {
  planSlugs?: InputMaybe<Array<Scalars['Slug']>>;
};

export type UserPlanFundingSourceNode = Node & {
  __typename?: 'UserPlanFundingSourceNode';
  createdAt: Scalars['DateTime'];
  discounts: Array<DiscountNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  source: FundingSource;
  userPlan: UserPlanNode;
  validUntil?: Maybe<Scalars['DateTime']>;
};

export type UserPlanNode = Node & {
  __typename?: 'UserPlanNode';
  addOns?: Maybe<AddOnStatusConnection>;
  approvedClaimsThisCycle: Scalars['Int'];
  availableAddOns?: Maybe<Array<AddOnNode>>;
  /** @deprecated No longer supporting emergencies */
  canClaimEmergency: Scalars['Boolean'];
  canClaimEmergencyAfter?: Maybe<Scalars['DateTime']>;
  canStartConversation: Scalars['Boolean'];
  canStartConversationAfter?: Maybe<Scalars['DateTime']>;
  conversationsStartedThisCycle: Scalars['Int'];
  effectiveAt: Scalars['DateTime'];
  /** @deprecated Please use `approvedClaimsThisCycle` instead */
  emergenciesClaimedThisCycle: Scalars['Int'];
  emergencyFund?: Maybe<EmergencyFundStatusNode>;
  /** @deprecated Please use `subscription` instead */
  fundingSource?: Maybe<UserPlanFundingSourceNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  /** @deprecated V2 policies require pet context for next claim info */
  nextEmergencyActivationDate?: Maybe<Scalars['DateTime']>;
  plan: BillingPlanNode;
  price?: Maybe<PriceNode>;
  sourcePartner?: Maybe<PartnerNode>;
  status: PlanStatus;
  statusHistory: UserPlanStatusRecordNodeConnection;
  subscription?: Maybe<SubscriptionNode>;
  subsidizedBy?: Maybe<PartnerNode>;
  user: UserType;
  validUntil?: Maybe<Scalars['DateTime']>;
};


export type UserPlanNodeAddOnsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserPlanNodeStatusHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status_In?: InputMaybe<Array<InputMaybe<PlanStatus>>>;
};

export type UserPlanNodeConnection = {
  __typename?: 'UserPlanNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserPlanNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `UserPlanNode` and its cursor. */
export type UserPlanNodeEdge = {
  __typename?: 'UserPlanNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<UserPlanNode>;
};

export type UserPlanStatusRecordNode = Node & {
  __typename?: 'UserPlanStatusRecordNode';
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  status: PlanStatus;
};

export type UserPlanStatusRecordNodeConnection = {
  __typename?: 'UserPlanStatusRecordNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserPlanStatusRecordNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `UserPlanStatusRecordNode` and its cursor. */
export type UserPlanStatusRecordNodeEdge = {
  __typename?: 'UserPlanStatusRecordNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<UserPlanStatusRecordNode>;
};

export type UserSatisfactionSurveyNode = Node & {
  __typename?: 'UserSatisfactionSurveyNode';
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  rating?: Maybe<Scalars['Int']>;
  surveyTrigger: Scalars['String'];
  user: UserType;
};

export type UserSatisfactionSurveyNodeConnection = {
  __typename?: 'UserSatisfactionSurveyNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserSatisfactionSurveyNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `UserSatisfactionSurveyNode` and its cursor. */
export type UserSatisfactionSurveyNodeEdge = {
  __typename?: 'UserSatisfactionSurveyNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<UserSatisfactionSurveyNode>;
};

export type UserType = {
  __typename?: 'UserType';
  activeClaimRequest?: Maybe<ClaimRequestNode>;
  avatar?: Maybe<Scalars['String']>;
  careActions?: Maybe<Array<Maybe<CarePlanActionNode>>>;
  carePlans?: Maybe<CarePlanNodeConnection>;
  clinics?: Maybe<Array<Maybe<CoreClinicNode>>>;
  conversationCount?: Maybe<Scalars['Int']>;
  defaultPaymentMethod?: Maybe<PaymentMethodNode>;
  devices?: Maybe<DeviceNodeConnection>;
  dob?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  emergencyState?: Maybe<EmergencyStateType>;
  experiments?: Maybe<Array<Maybe<UserExperimentType>>>;
  externalAccessTokens?: Maybe<ExternalAccesTokensType>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identifiedAt?: Maybe<Scalars['DateTime']>;
  identifier?: Maybe<Scalars['String']>;
  insuranceEligibility?: Maybe<Scalars['Boolean']>;
  insurancePolicy?: Maybe<InsurancePolicy>;
  intentForRx?: Maybe<Scalars['Boolean']>;
  invoices?: Maybe<InvoiceNodeConnection>;
  isAda: Scalars['Boolean'];
  isBanned: Scalars['Boolean'];
  isEmailVerified?: Maybe<Scalars['Boolean']>;
  isFraud: Scalars['Boolean'];
  isGuest?: Maybe<Scalars['Boolean']>;
  isPayingCustomer?: Maybe<Scalars['Boolean']>;
  isVcprAddOnSupported?: Maybe<Scalars['Boolean']>;
  isVip: Scalars['Boolean'];
  lastAndroidActivityAt?: Maybe<Scalars['DateTime']>;
  lastIosActivityAt?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  lastPasswordSetAt?: Maybe<Scalars['DateTime']>;
  legalSex?: Maybe<LegalSex>;
  location?: Maybe<AddressType>;
  membershipHistory?: Maybe<UserPlanNodeConnection>;
  partner?: Maybe<PartnerNode>;
  partners: Array<UserPartnerNode>;
  paymentMethods?: Maybe<OwnerPaymentMethodConnection>;
  payments?: Maybe<PaymentNodeConnection>;
  pendingNewEmail?: Maybe<Scalars['String']>;
  petCount?: Maybe<Scalars['Int']>;
  pets: Array<PetType>;
  phoneNumber?: Maybe<Scalars['String']>;
  primaryClinic?: Maybe<ClinicLocationType>;
  pushNotificationsEnabled: Scalars['Boolean'];
  quote?: Maybe<QuoteResponse>;
  referralData: ReferralDataType;
  refunds?: Maybe<RefundConnection>;
  requiresEmailVerification?: Maybe<Scalars['Boolean']>;
  requiresFullAddress?: Maybe<Scalars['Boolean']>;
  roles: Array<SchemaRole>;
  satisfactionSurveys?: Maybe<UserSatisfactionSurveyNodeConnection>;
  shouldReceiveMarketingEmails: Scalars['Boolean'];
  shouldReceiveMarketingSms: Scalars['Boolean'];
  shouldReceiveTransactionalSms: Scalars['Boolean'];
  state?: Maybe<Scalars['GenericScalar']>;
  todos: Array<PetTodoInterface>;
  trustpilotUrl?: Maybe<Scalars['String']>;
  userPlan?: Maybe<UserPlanNode>;
  verifiedEmailAt?: Maybe<Scalars['DateTime']>;
};


export type UserTypeCarePlansArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  conversation?: InputMaybe<Scalars['ID']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
  pet?: InputMaybe<Scalars['ID']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  writtenBy?: InputMaybe<Scalars['ID']>;
};


export type UserTypeDevicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  first?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
};


export type UserTypeInvoicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  pastDue?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<InvoiceStatus>;
};


export type UserTypeMembershipHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  onlyActivatedPlans?: InputMaybe<Scalars['Boolean']>;
  onlyPaidPlans?: InputMaybe<Scalars['Boolean']>;
};


export type UserTypePartnersArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  partnerSlugs?: InputMaybe<Array<Scalars['Slug']>>;
};


export type UserTypePaymentMethodsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserTypePaymentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  failed?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  processorId?: InputMaybe<Scalars['String']>;
};


export type UserTypeQuoteArgs = {
  params?: InputMaybe<QuoteInput>;
};


export type UserTypeRefundsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type UserTypeSatisfactionSurveysArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  surveyTrigger?: InputMaybe<Scalars['String']>;
};


export type UserTypeTodosArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type VcprAddOnNode = AddOnInterface & Node & {
  __typename?: 'VCPRAddOnNode';
  activationFee?: Maybe<Scalars['Decimal']>;
  clinic?: Maybe<CoreClinicNode>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  /** @deprecated Replaced by 'productCategory' */
  includedProducts: ProductVariantNodeConnection;
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  pricing?: Maybe<Array<AddOnPriceNode>>;
  productCategory?: Maybe<ProductCategoryNode>;
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type VcprAddOnNodeIncludedProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type VcprStatusNode = AddOnStatusInterface & Node & {
  __typename?: 'VCPRStatusNode';
  addOn: VcprAddOnNode;
  autoshipPlan: AutoshipPlanNode;
  /** The ID of the object */
  id: Scalars['ID'];
  isBundled: Scalars['Boolean'];
  isRx: Scalars['Boolean'];
  pet: PetType;
  prescriptions: PrescriptionNodeConnection;
  price?: Maybe<PriceNode>;
  product?: Maybe<ProductNode>;
  /** @deprecated Replaced by 'product' */
  productVariant?: Maybe<ProductVariantNode>;
  status: PlanStatus;
  validUntil?: Maybe<Scalars['DateTime']>;
};


export type VcprStatusNodePrescriptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clinic?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  pet?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<PrescriptionStatus>;
};

export type VaccinationType = {
  __typename?: 'VaccinationType';
  abbreviation?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ValidatorNode = RangeCountValidatorNode | RangeDateValidatorNode | RangeDatetimeValidatorNode | RangeDecimalValidatorNode | RangeIntegerValidatorNode;

export type VerifyEmail = {
  __typename?: 'VerifyEmail';
  success?: Maybe<Scalars['Boolean']>;
};

export type VerifyIdentifiedGuest = {
  __typename?: 'VerifyIdentifiedGuest';
  identifier?: Maybe<Scalars['String']>;
  queued?: Maybe<Scalars['Boolean']>;
  token?: Maybe<Scalars['String']>;
};

export type VerifyOtpInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  identifier: Scalars['ID'];
};

/**
 * We can use this for verifying any non-login/signup code. It could be useful
 * for anything that requires extra verification. Currently only supports changing emails and
 * verifying emails but in the future could be extended to other tasks like deleting an account.
 */
export type VerifyOtpPayload = {
  __typename?: 'VerifyOtpPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type VideoRoomType = {
  __typename?: 'VideoRoomType';
  conversationId?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  maxParticipants: Scalars['Int'];
  professionalJoinedAt?: Maybe<Scalars['DateTime']>;
  recordParticipantsOnConnect: Scalars['Boolean'];
  roomType: Scalars['String'];
  status: Scalars['String'];
  transcribeVideo: Scalars['Boolean'];
  twilioSid: Scalars['String'];
  uniqueName?: Maybe<Scalars['String']>;
  userJoinedAt?: Maybe<Scalars['DateTime']>;
};

export type ViewCarePlanPetActionNode = ActionInterface & ConversationActionInterface & Node & PetTodoInterface & {
  __typename?: 'ViewCarePlanPetActionNode';
  conversation: ConversationType;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<ProfessionalNode>;
  ctaAction?: Maybe<TodoClientAction>;
  ctaText?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  extendedSubtitle?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  important: Scalars['Boolean'];
  label: Scalars['String'];
  lastEditedBy?: Maybe<ProfessionalNode>;
  pet: PetType;
  slug: Scalars['String'];
  status: ActionStatus;
  subtitle: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  viewingDraft: Scalars['Boolean'];
};

export type ViewIipQuote = {
  __typename?: 'ViewIIPQuote';
  iipOffer: IipOfferNode;
  quoteUrl: Scalars['String'];
};

export type VirtualVisitActionNode = ActionInterface & CarePlanActionInterface & ConversationActionInterface & Node & PetTodoInterface & VisitInterface & {
  __typename?: 'VirtualVisitActionNode';
  actionType: CarePlanActionType;
  carePlan: CarePlanNode;
  complianceStatus?: Maybe<ComplianceLevel>;
  complianceStatusRecords?: Maybe<CarePlanActionComplianceStatusRecordNodeConnection>;
  conversation: ConversationType;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<ProfessionalNode>;
  ctaAction?: Maybe<TodoClientAction>;
  ctaText?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  deadline?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  extendedSubtitle?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  important: Scalars['Boolean'];
  label: Scalars['String'];
  lastEditedBy?: Maybe<ProfessionalNode>;
  notes: Scalars['String'];
  pet: PetType;
  reasoningContent: Scalars['String'];
  reasoningTitle: Scalars['String'];
  slug: Scalars['String'];
  sortingWeight: Scalars['Int'];
  status: ActionStatus;
  subtitle: Scalars['String'];
  title: Scalars['String'];
  topicName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  viewingDraft: Scalars['Boolean'];
};


export type VirtualVisitActionNodeComplianceStatusRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type Visit = {
  __typename?: 'Visit';
  date: Scalars['DateTime'];
  id?: Maybe<Scalars['ID']>;
  professional?: Maybe<ProfessionalNode>;
  title: Scalars['String'];
  topicName: Scalars['String'];
  visitSource: VisitSource;
};

export type VisitInterface = {
  date: Scalars['DateTime'];
  title: Scalars['String'];
  topicName: Scalars['String'];
};

/** An enumeration. */
export enum VisitSource {
  CheckIn = 'CHECK_IN',
  Conversation = 'CONVERSATION',
  GenericCareAction = 'GENERIC_CARE_ACTION'
}

export type VisitsForPet = {
  __typename?: 'VisitsForPet';
  pastVisits?: Maybe<Array<Maybe<Visit>>>;
  upcomingVisits?: Maybe<Array<Maybe<Visit>>>;
};


export type VisitsForPetPastVisitsArgs = {
  petId: Scalars['ID'];
};


export type VisitsForPetUpcomingVisitsArgs = {
  petId: Scalars['ID'];
};

export type WeightRange = {
  __typename?: 'WeightRange';
  lower?: Maybe<Scalars['Decimal']>;
  lowerInclusive?: Maybe<Scalars['Boolean']>;
  upper?: Maybe<Scalars['Decimal']>;
  upperInclusive?: Maybe<Scalars['Boolean']>;
};

export type FreeTrialLandingDataQueryVariables = Exact<{ [key: string]: never; }>;


export type FreeTrialLandingDataQuery = { __typename?: 'Query', user?: (
    { __typename?: 'UserType' }
    & { ' $fragmentRefs'?: { 'AppsflyerLink_UserFragment': AppsflyerLink_UserFragment } }
  ) | null };

export type FooterDataQueryVariables = Exact<{ [key: string]: never; }>;


export type FooterDataQuery = { __typename?: 'Query', user?: (
    { __typename?: 'UserType' }
    & { ' $fragmentRefs'?: { 'AppsflyerLink_UserFragment': AppsflyerLink_UserFragment } }
  ) | null };

export type UserManagementDataQueryVariables = Exact<{ [key: string]: never; }>;


export type UserManagementDataQuery = { __typename?: 'Query', user?: { __typename?: 'UserType', id: string, email?: string | null, phoneNumber?: string | null, lastIosActivityAt?: any | null, firstName?: string | null, lastName?: string | null, externalAccessTokens?: { __typename?: 'ExternalAccesTokensType', intercomWeb?: string | null } | null, partner?: { __typename?: 'PartnerNode', id: string, slug: string } | null, userPlan?: { __typename?: 'UserPlanNode', id: string } | null } | null };

export type AppRouterDataQueryVariables = Exact<{ [key: string]: never; }>;


export type AppRouterDataQuery = { __typename?: 'Query', user?: { __typename?: 'UserType', id: string } | null };

export type QueryUserIdEmailQueryVariables = Exact<{ [key: string]: never; }>;


export type QueryUserIdEmailQuery = { __typename?: 'Query', user?: { __typename?: 'UserType', id: string, email?: string | null } | null };

export type AppsflyerLink_UserFragment = { __typename?: 'UserType', id: string, email?: string | null } & { ' $fragmentName'?: 'AppsflyerLink_UserFragment' };

export type CardPaymentMethodFragmentFragment = { __typename?: 'CardPaymentMethod', id: string, brand?: string | null, lastFour?: string | null, nickname?: string | null, isActive: boolean } & { ' $fragmentName'?: 'CardPaymentMethodFragmentFragment' };

export type PayPalPaymentMethodFragmentFragment = { __typename?: 'PayPalPaymentMethod', id: string, nickname?: string | null, isActive: boolean } & { ' $fragmentName'?: 'PayPalPaymentMethodFragmentFragment' };

export type AddPaymentMethodMutationVariables = Exact<{
  input: AddPaymentMethodInput;
}>;


export type AddPaymentMethodMutation = { __typename?: 'Mutation', addPaymentMethod?: { __typename?: 'AddPaymentMethodPayload', paymentMethod?: { __typename?: 'CardPaymentMethod', id: string, brand?: string | null, lastFour?: string | null, nickname?: string | null, isActive: boolean } | { __typename?: 'PayPalPaymentMethod', id: string, nickname?: string | null, isActive: boolean } | null } | null };

export type QueryUserPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type QueryUserPaymentMethodsQuery = { __typename?: 'Query', user?: { __typename?: 'UserType', id: string, paymentMethods?: { __typename?: 'OwnerPaymentMethodConnection', edges: Array<{ __typename?: 'OwnerPaymentMethodEdge', node?: (
          { __typename?: 'CardPaymentMethod' }
          & { ' $fragmentRefs'?: { 'CardPaymentMethodFragmentFragment': CardPaymentMethodFragmentFragment } }
        ) | (
          { __typename?: 'PayPalPaymentMethod' }
          & { ' $fragmentRefs'?: { 'PayPalPaymentMethodFragmentFragment': PayPalPaymentMethodFragmentFragment } }
        ) | null } | null> } | null } | null };

export type UserPhoneNumberAndIdentifierQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPhoneNumberAndIdentifierQuery = { __typename?: 'Query', user?: { __typename?: 'UserType', id: string, phoneNumber?: string | null, identifier?: string | null } | null };

export type LoginV2MutationVariables = Exact<{
  input: LoginV2Input;
}>;


export type LoginV2Mutation = { __typename?: 'Mutation', loginV2: { __typename?: 'LoginV2Payload', login: { __typename?: 'LoginType', idToken: string, accessToken: string, refreshToken?: string | null, user: { __typename?: 'UserType', id: string } } } };

export type LogoutMutationVariables = Exact<{
  refreshToken: Scalars['String'];
}>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: { __typename?: 'Logout', success?: boolean | null } | null };

export type RefreshTokensMutationVariables = Exact<{
  refreshToken: Scalars['String'];
}>;


export type RefreshTokensMutation = { __typename?: 'Mutation', refreshTokens?: { __typename?: 'RefreshTokens', idToken: string, accessToken: string, refreshToken: string } | null };

export type RequestGuestSessionMutationVariables = Exact<{
  interaction?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
}>;


export type RequestGuestSessionMutation = { __typename?: 'Mutation', requestGuestSession?: { __typename?: 'RequestGuestSession', identifier?: string | null, token?: string | null } | null };

export type SendOtpMutationVariables = Exact<{
  input: SendOtpInput;
}>;


export type SendOtpMutation = { __typename?: 'Mutation', sendOtp: { __typename?: 'SendOTPPayload', success?: boolean | null } };

export type SignupV2MutationVariables = Exact<{
  input: SignupV2Input;
}>;


export type SignupV2Mutation = { __typename?: 'Mutation', signupV2: { __typename?: 'SignupV2Payload', login?: { __typename?: 'LoginType', idToken: string, accessToken: string, refreshToken?: string | null } | null } };

export type AutoshipPlanFragmentFragment = { __typename?: 'AutoshipPlanNode', id: string, subscription: { __typename?: 'SubscriptionNode', id: string, nextInvoiceDate?: any | null, status: SubscriptionStatus, interval: number, period: Period, paymentMethod?: (
      { __typename?: 'CardPaymentMethod' }
      & { ' $fragmentRefs'?: { 'CardPaymentMethodFragmentFragment': CardPaymentMethodFragmentFragment } }
    ) | (
      { __typename?: 'PayPalPaymentMethod' }
      & { ' $fragmentRefs'?: { 'PayPalPaymentMethodFragmentFragment': PayPalPaymentMethodFragmentFragment } }
    ) | null }, latestOrder?: { __typename?: 'OrderNodeConnection', edges: Array<{ __typename?: 'OrderNodeEdge', node?: { __typename?: 'OrderNode', id: string, lineItems?: Array<{ __typename?: 'OrderLineItem', id: string, productVariant: { __typename?: 'ProductVariantNode', id: string, product: { __typename?: 'ProductNode', id: string, productDetails?: { __typename?: 'CoreMedicationNode', id: string, isPrescriptionRequired?: boolean | null } | null } } }> | null } | null } | null> } | null } & { ' $fragmentName'?: 'AutoshipPlanFragmentFragment' };

export type CartFragmentFragment = { __typename?: 'CartNode', id: string, subtotal: any, total: any, totalTax: any, totalDiscount?: any | null, lineItems: Array<{ __typename?: 'CartLineItem', id: string, discount: any, quantity: number, tax: any, subtotal: any, total: any, productVariant: (
      { __typename?: 'ProductVariantNode', id: string }
      & { ' $fragmentRefs'?: { 'ProductVariantFragmentFragment': ProductVariantFragmentFragment;'ProductVariantProductFragmentFragment': ProductVariantProductFragmentFragment } }
    ) }> } & { ' $fragmentName'?: 'CartFragmentFragment' };

export type CheckoutMutationVariables = Exact<{
  paymentMethodId: Scalars['ID'];
}>;


export type CheckoutMutation = { __typename?: 'Mutation', checkout?: { __typename?: 'Checkout', order: (
      { __typename?: 'OrderNode', id: string }
      & { ' $fragmentRefs'?: { 'OrderFragmentFragment': OrderFragmentFragment } }
    ) } | null };

export type PreCheckoutMutationVariables = Exact<{
  shippingAddressId: Scalars['ID'];
}>;


export type PreCheckoutMutation = { __typename?: 'Mutation', preCheckout?: { __typename?: 'PreCheckout', cart: (
      { __typename?: 'CartNode', id: string }
      & { ' $fragmentRefs'?: { 'CartFragmentFragment': CartFragmentFragment } }
    ) } | null };

export type UpdateCartMutationVariables = Exact<{
  lineItems: Array<InputMaybe<UpdateCartLineItemInput>> | InputMaybe<UpdateCartLineItemInput>;
}>;


export type UpdateCartMutation = { __typename?: 'Mutation', updateCart?: { __typename?: 'UpdateCart', cart: (
      { __typename?: 'CartNode', id: string }
      & { ' $fragmentRefs'?: { 'CartFragmentFragment': CartFragmentFragment } }
    ) } | null };

export type CurrentCartQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentCartQuery = { __typename?: 'Query', currentCart?: (
    { __typename?: 'CartNode', id: string }
    & { ' $fragmentRefs'?: { 'CartFragmentFragment': CartFragmentFragment } }
  ) | null };

export type ClinicFragmentFragment = { __typename?: 'CoreClinicNode', id: string, name: string, phoneNumber?: string | null, address?: { __typename?: 'AddressType', id: string, address1?: string | null, address2?: string | null, city?: string | null, state?: AddressState | null, zip?: string | null, formattedAddress?: string | null } | null } & { ' $fragmentName'?: 'ClinicFragmentFragment' };

export type InsertClinicMutationVariables = Exact<{
  googlePlaceId: Scalars['String'];
}>;


export type InsertClinicMutation = { __typename?: 'Mutation', insertClinicV2?: { __typename?: 'InsertClinicNodeV2', clinic?: (
      { __typename?: 'CoreClinicNode' }
      & { ' $fragmentRefs'?: { 'ClinicFragmentFragment': ClinicFragmentFragment } }
    ) | null } | null };

export type UserClinicsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserClinicsQuery = { __typename?: 'Query', user?: { __typename?: 'UserType', id: string, clinics?: Array<(
      { __typename?: 'CoreClinicNode' }
      & { ' $fragmentRefs'?: { 'ClinicFragmentFragment': ClinicFragmentFragment } }
    ) | null> | null, primaryClinic?: { __typename?: 'ClinicLocationType', id: string } | null } | null };

export type SubmitClinicLocationRatingMutationVariables = Exact<{
  clinicLocationObjectid?: InputMaybe<Scalars['ID']>;
  rating: Scalars['Int'];
  review?: InputMaybe<Scalars['String']>;
}>;


export type SubmitClinicLocationRatingMutation = { __typename?: 'Mutation', submitClinicLocationRating?: { __typename?: 'SubmitRating', rating?: { __typename?: 'ClinicLocationRatingType', id: string, rating: number, review?: string | null, clinicLocation: { __typename?: 'ClinicLocationType', id: string } } | null } | null };

export type FulfillmentFragmentFragment = { __typename?: 'FulfillmentNode', id: string, createdAt: any, updatedAt: any, shipmentStatus: FulfillmentShipmentStatus, trackingCompany: FulfillmentTrackingCompany, trackingNumbers?: Array<string> | null, trackingUrls?: Array<string> | null, order: { __typename?: 'OrderV2Node', id: string }, orderLineItems?: Array<{ __typename?: 'OrderLineItem', id: string, quantity: number, total: any, tax: any, subtotal: any, productVariant: (
      { __typename?: 'ProductVariantNode', id: string }
      & { ' $fragmentRefs'?: { 'ProductVariantFragmentFragment': ProductVariantFragmentFragment;'ProductVariantProductFragmentFragment': ProductVariantProductFragmentFragment } }
    ), fulfillmentLineItems?: Array<{ __typename?: 'FulfillmentNode', id: string, quantity: number }> | null }> | null } & { ' $fragmentName'?: 'FulfillmentFragmentFragment' };

export type OrderFragmentFragment = { __typename?: 'OrderNode', id: string, createdAt: any, updatedAt: any, canceledAt?: any | null, cancelReason?: OrderCancelReason | null, customerEmail: string, customerPhoneNumber?: string | null, orderNumber?: string | null, subtotal: any, totalPrice: any, totalShipping: any, totalTax: any, totalDiscount: any, shippingAddress: { __typename?: 'ShippingAddressType', id: string, firstName: string, lastName: string, formattedAddress?: string | null, address1: string, address2?: string | null, city: string, state: ShippingAddressState, zip: string, isPrimary: boolean }, meta?: { __typename?: 'OrderNodeMeta', stripeId?: string | null } | null, lineItems?: Array<{ __typename?: 'OrderLineItem', id: string, quantity: number, total: any, tax: any, subtotal: any, productVariant: (
      { __typename?: 'ProductVariantNode', id: string }
      & { ' $fragmentRefs'?: { 'ProductVariantFragmentFragment': ProductVariantFragmentFragment;'ProductVariantProductFragmentFragment': ProductVariantProductFragmentFragment } }
    ), prescription?: { __typename?: 'CorePrescriptionNode', id: string, clinic: { __typename?: 'CoreClinicNode', id: string, name: string, address?: { __typename?: 'AddressType', id: string, formattedAddress?: string | null } | null }, processedBy?: { __typename?: 'ProfessionalNode', id: string, jobTitle: string, professionalName?: string | null, firstName?: string | null } | null } | null }> | null, fulfillments?: Array<(
    { __typename?: 'FulfillmentNode' }
    & { ' $fragmentRefs'?: { 'FulfillmentFragmentFragment': FulfillmentFragmentFragment } }
  )> | null, paymentMethod?: { __typename?: 'CardPaymentMethod', id: string, brand?: string | null, lastFour?: string | null, nickname?: string | null, isActive: boolean } | { __typename?: 'PayPalPaymentMethod', id: string, nickname?: string | null, isActive: boolean } | null } & { ' $fragmentName'?: 'OrderFragmentFragment' };

export type OrdersQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type OrdersQuery = { __typename?: 'Query', ordersV2?: { __typename?: 'OrderNodeConnection', edges: Array<{ __typename?: 'OrderNodeEdge', node?: (
        { __typename?: 'OrderNode', id: string }
        & { ' $fragmentRefs'?: { 'OrderFragmentFragment': OrderFragmentFragment } }
      ) | null } | null> } | null };

export type PartnerFragmentFragment = { __typename?: 'PartnerNode', id: string, name: string, slug: string } & { ' $fragmentName'?: 'PartnerFragmentFragment' };

export type PetInfoFragmentFragment = { __typename?: 'PetType', id: string, name: string, type?: string | null, picture?: string | null, isSpayedOrNeutered?: boolean | null, weight?: number | null, gender?: string | null, profileCompletionPercentage?: number | null, breed?: { __typename?: 'BreedType', name: string, id: string, image?: string | null } | null, birthday?: { __typename?: 'PetBirthdayType', birthday?: string | null, accuracyLevel?: string | null } | null, age?: { __typename?: 'PetAgeObjectType', day?: number | null, month?: number | null, year?: number | null } | null } & { ' $fragmentName'?: 'PetInfoFragmentFragment' };

export type PetBasicsFragmentFragment = { __typename?: 'PetType', type?: string | null, gender?: string | null, isSpayedOrNeutered?: boolean | null, adoptionMethod?: string | null, nickname?: string | null, horoscope?: { __typename?: 'PetHoroscopeType', name: string, shortDescription?: string | null, link?: string | null } | null, microchip?: { __typename?: 'PetMicrochipType', id?: string | null, brand?: string | null } | null, hometown?: { __typename?: 'AddressType', city?: string | null, state?: AddressState | null } | null } & { ' $fragmentName'?: 'PetBasicsFragmentFragment' };

export type PetWellnessFragmentFragment = { __typename?: 'PetType', bodyType?: number | null, activityLevel?: number | null, vaccinations?: Array<{ __typename?: 'PetVaccinationType', id: string, administeredAt: any, vaccination: { __typename?: 'VaccinationType', name: string } } | null> | null } & { ' $fragmentName'?: 'PetWellnessFragmentFragment' };

export type PetFragmentFragment = (
  { __typename?: 'PetType' }
  & { ' $fragmentRefs'?: { 'PetInfoFragmentFragment': PetInfoFragmentFragment;'PetBasicsFragmentFragment': PetBasicsFragmentFragment;'PetWellnessFragmentFragment': PetWellnessFragmentFragment } }
) & { ' $fragmentName'?: 'PetFragmentFragment' };

export type PetVcprFragmentFragment = { __typename?: 'PetType', itchLevel?: number | null, hairLossLevel?: number | null, takenFleaTickMedication?: boolean | null, lastFleaTickMedication?: any | null, reasonForChangingFleaTickMedication: string, breedingPregnantLactating?: boolean | null, preExistingEpilepsyConditions?: boolean | null, inContactWithNonHouseholdPetsOrYard?: boolean | null, allHouseholdPetsTreatedForFleas?: boolean | null, waterConsumption: string, appetite: string, behavior: string } & { ' $fragmentName'?: 'PetVcprFragmentFragment' };

export type PetDetailedFragmentFragment = (
  { __typename?: 'PetType' }
  & { ' $fragmentRefs'?: { 'PetFragmentFragment': PetFragmentFragment;'PetVcprFragmentFragment': PetVcprFragmentFragment } }
) & { ' $fragmentName'?: 'PetDetailedFragmentFragment' };

export type CreatePetMutationVariables = Exact<{
  name: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  breed?: InputMaybe<Scalars['ID']>;
  isSpayedOrNeutered?: InputMaybe<Scalars['Boolean']>;
  weight?: InputMaybe<Scalars['Float']>;
  birthday?: InputMaybe<BirthdayInput>;
  picture?: InputMaybe<Scalars['ImageUpload']>;
}>;


export type CreatePetMutation = { __typename?: 'Mutation', createPet?: { __typename?: 'CreatePet', pet?: { __typename?: 'PetType', id: string, name: string, type?: string | null, gender?: string | null, isSpayedOrNeutered?: boolean | null, picture?: string | null, weight?: number | null, breed?: { __typename?: 'BreedType', id: string, name: string } | null, birthday?: { __typename?: 'PetBirthdayType', accuracyLevel?: string | null, birthday?: string | null } | null } | null } | null };

export type UpdatePetMutationVariables = Exact<{
  activityLevel?: InputMaybe<Scalars['Int']>;
  adoptionMethod?: InputMaybe<Scalars['String']>;
  adverseReactionsToMedicines?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  allHouseholdPetsTreatedForFleas?: InputMaybe<Scalars['Boolean']>;
  appetite?: InputMaybe<PetAppetite>;
  behavior?: InputMaybe<PetBehavior>;
  birthday?: InputMaybe<BirthdayInput>;
  bodyType?: InputMaybe<Scalars['Int']>;
  breed?: InputMaybe<Scalars['ID']>;
  breedingPregnantLactating?: InputMaybe<Scalars['Boolean']>;
  dateOfDeath?: InputMaybe<Scalars['Date']>;
  deletedFields?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  eyeColor?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  hairLossLevel?: InputMaybe<Scalars['Int']>;
  hometown?: InputMaybe<LocationInput>;
  inContactWithNonHouseholdPetsOrYard?: InputMaybe<Scalars['Boolean']>;
  isSpayedOrNeutered?: InputMaybe<Scalars['Boolean']>;
  itchLevel?: InputMaybe<Scalars['Int']>;
  lastFleaTickMedication?: InputMaybe<Scalars['DateTime']>;
  nameLastFleaTickMedication?: InputMaybe<Scalars['String']>;
  microchip?: InputMaybe<MicrochipInput>;
  name?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<Scalars['ImageUpload']>;
  pk: Scalars['ID'];
  preExistingEpilepsyConditions?: InputMaybe<Scalars['Boolean']>;
  rabies?: InputMaybe<RabiesInput>;
  reasonForChangingFleaTickMedication?: InputMaybe<Scalars['String']>;
  takenFleaTickMedication?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  waterConsumption?: InputMaybe<PetWaterConsumption>;
  weight?: InputMaybe<Scalars['Float']>;
}>;


export type UpdatePetMutation = { __typename?: 'Mutation', updatePet?: { __typename?: 'UpdatePet', pet?: (
      { __typename?: 'PetType' }
      & { ' $fragmentRefs'?: { 'PetFragmentFragment': PetFragmentFragment } }
    ) | null } | null };

export type PetsQueryVariables = Exact<{ [key: string]: never; }>;


export type PetsQuery = { __typename?: 'Query', pets: Array<(
    { __typename?: 'PetType' }
    & { ' $fragmentRefs'?: { 'PetInfoFragmentFragment': PetInfoFragmentFragment } }
  ) | null> };

export type PetsDetailedQueryVariables = Exact<{ [key: string]: never; }>;


export type PetsDetailedQuery = { __typename?: 'Query', pets: Array<(
    { __typename?: 'PetType' }
    & { ' $fragmentRefs'?: { 'PetDetailedFragmentFragment': PetDetailedFragmentFragment } }
  ) | null> };

export type BillingPlanNodeFragmentFragment = { __typename?: 'BillingPlanNode', id: string, createdAt: any, updatedAt: any, name: string, isActive: boolean, slug: string, conversationLimit?: number | null, conversationRefreshPeriod?: any | null, firstConversationDelay: any, freeTrialDuration?: any | null, addOns?: { __typename?: 'AddOnConnection', edges: Array<{ __typename?: 'AddOnEdge', node?: { __typename?: 'EmergencyFundAddOnNode', id: string, slug: string, name: string, pricing?: Array<{ __typename?: 'AddOnPriceNode', isActive: boolean, price: { __typename?: 'PriceNode', id: string, price: any, interval?: number | null, period?: Period | null } }> | null } | { __typename?: 'VCPRAddOnNode', id: string, isActive: boolean, slug: string, activationFee?: any | null, name: string, pricing?: Array<{ __typename?: 'AddOnPriceNode', isActive: boolean, price: { __typename?: 'PriceNode', id: string, price: any, interval?: number | null, period?: Period | null } }> | null } | null } | null> } | null } & { ' $fragmentName'?: 'BillingPlanNodeFragmentFragment' };

export type EmergencyFundStatusNodeFragmentFragment = { __typename?: 'EmergencyFundStatusNode', id: string, status: PlanStatus, isBundled: boolean, validUntil?: any | null, nextClaimDate?: any | null, coverageStartsAt?: any | null, currentCycleStart?: any | null, currentCycleEnd?: any | null, addOn: { __typename?: 'EmergencyFundAddOnNode', id: string, slug: string, name: string, maxPayout: any, pricing?: Array<{ __typename?: 'AddOnPriceNode', isActive: boolean, price: { __typename?: 'PriceNode', id: string, price: any, interval?: number | null, period?: Period | null } }> | null }, price?: { __typename?: 'PriceNode', id: string, period?: Period | null, price: any } | null, subscription?: { __typename?: 'SubscriptionNode', id: string, nextInvoiceDate?: any | null } | null } & { ' $fragmentName'?: 'EmergencyFundStatusNodeFragmentFragment' };

export type UserPlanFragmentFragment = { __typename?: 'UserPlanNode', id: string, status: PlanStatus, canStartConversation: boolean, canClaimEmergency: boolean, canClaimEmergencyAfter?: any | null, conversationsStartedThisCycle: number, effectiveAt: any, nextEmergencyActivationDate?: any | null, validUntil?: any | null, emergencyFund?: { __typename?: 'EmergencyFundStatusNode', id: string, status: PlanStatus, validUntil?: any | null, coverageStartsAt?: any | null, nextClaimDate?: any | null } | null, price?: { __typename?: 'PriceNode', id: string, createdAt: any, period?: Period | null, priceType: PriceTypeEnum, price: any, interval?: number | null } | null, plan: (
    { __typename?: 'BillingPlanNode' }
    & { ' $fragmentRefs'?: { 'BillingPlanNodeFragmentFragment': BillingPlanNodeFragmentFragment } }
  ), subsidizedBy?: { __typename?: 'PartnerNode', id: string, name: string } | null, subscription?: { __typename?: 'SubscriptionNode', id: string, nextInvoiceDate?: any | null, paymentMethod?: { __typename?: 'CardPaymentMethod', brand?: string | null, id: string, lastFour?: string | null, nickname?: string | null } | { __typename?: 'PayPalPaymentMethod', id: string, nickname?: string | null } | null } | null, availableAddOns?: Array<{ __typename?: 'EmergencyFundAddOnNode', id: string, slug: string, name: string, maxPayout: any, pricing?: Array<{ __typename?: 'AddOnPriceNode', isActive: boolean, price: { __typename?: 'PriceNode', id: string, price: any, interval?: number | null, period?: Period | null } }> | null } | { __typename?: 'VCPRAddOnNode', id: string, slug: string, name: string, pricing?: Array<{ __typename?: 'AddOnPriceNode', isActive: boolean, price: { __typename?: 'PriceNode', id: string, price: any, interval?: number | null, period?: Period | null } }> | null }> | null, addOns?: { __typename?: 'AddOnStatusConnection', edges: Array<{ __typename?: 'AddOnStatusEdge', node?: (
        { __typename?: 'EmergencyFundStatusNode' }
        & { ' $fragmentRefs'?: { 'EmergencyFundStatusNodeFragmentFragment': EmergencyFundStatusNodeFragmentFragment } }
      ) | (
        { __typename?: 'VCPRStatusNode' }
        & { ' $fragmentRefs'?: { 'VcprStatusNodeFragmentFragment': VcprStatusNodeFragmentFragment } }
      ) | null } | null> } | null } & { ' $fragmentName'?: 'UserPlanFragmentFragment' };

export type VcprStatusNodeFragmentFragment = { __typename?: 'VCPRStatusNode', id: string, status: PlanStatus, isBundled: boolean, validUntil?: any | null, pet: { __typename?: 'PetType', id: string, name: string, type?: string | null, picture?: string | null }, addOn: { __typename?: 'VCPRAddOnNode', id: string, name: string, slug: string, pricing?: Array<{ __typename?: 'AddOnPriceNode', isActive: boolean, price: { __typename?: 'PriceNode', id: string, price: any, interval?: number | null, period?: Period | null } }> | null }, price?: { __typename?: 'PriceNode', id: string, period?: Period | null, price: any } | null, prescriptions: { __typename?: 'PrescriptionNodeConnection', edges: Array<{ __typename?: 'PrescriptionNodeEdge', node?: { __typename?: 'PrescriptionNode', id: string, approvalStatus: PrescriptionStatus, processedAt?: any | null } | null } | null> }, autoshipPlan: (
    { __typename?: 'AutoshipPlanNode' }
    & { ' $fragmentRefs'?: { 'AutoshipPlanFragmentFragment': AutoshipPlanFragmentFragment } }
  ) } & { ' $fragmentName'?: 'VcprStatusNodeFragmentFragment' };

export type ActivateAddOnMutationVariables = Exact<{
  input: ActivateAddOnInput;
}>;


export type ActivateAddOnMutation = { __typename?: 'Mutation', activateAddOn?: { __typename?: 'ActivateAddOnPayload', userPlan: (
      { __typename?: 'UserPlanNode' }
      & { ' $fragmentRefs'?: { 'UserPlanFragmentFragment': UserPlanFragmentFragment } }
    ) } | null };

export type SetUserPlanMutationVariables = Exact<{
  input: SetUserPlanInput;
}>;


export type SetUserPlanMutation = { __typename?: 'Mutation', setUserPlan?: { __typename?: 'SetUserPlanPayload', userPlan: { __typename?: 'UserPlanNode', user: { __typename?: 'UserType', id: string, userPlan?: (
          { __typename?: 'UserPlanNode' }
          & { ' $fragmentRefs'?: { 'UserPlanFragmentFragment': UserPlanFragmentFragment } }
        ) | null } }, login?: { __typename?: 'LoginType', idToken: string, accessToken: string, refreshToken?: string | null } | null } | null };

export type QuoteSignupQueryVariables = Exact<{
  params: QuoteInput;
}>;


export type QuoteSignupQuery = { __typename?: 'Query', quoteSignup?: { __typename?: 'QuoteResponse', checkoutPrice: { __typename?: 'QuotePrice', subtotal: any, tax: any, discount: any, total: any, lineItems: Array<{ __typename?: 'QuoteLineItem', label: string, subtotal: any, discount: any, tax: any, total: any, price: { __typename?: 'PriceNode', period?: Period | null, price: any }, plan?: { __typename?: 'PlanQuoteConfiguration', isEligibleForTrial: boolean, trialLength?: any | null, plan: { __typename?: 'BillingPlanNode', id: string, name: string, slug: string } } | null, productVariant?: { __typename?: 'ProductVariantNode', id: string, slug: string, images?: Array<{ __typename?: 'ImageType', id: string, picture?: string | null } | null> | null, fullImages?: Array<{ __typename?: 'ImageType', id: string, picture?: string | null } | null> | null, product: { __typename?: 'ProductNode', id: string, title: string, vendor?: string | null, productDetails?: { __typename?: 'CoreMedicationNode', id: string, isPrescriptionRequired?: boolean | null } | null, images?: Array<{ __typename?: 'ImageType', id: string, picture?: string | null } | null> | null, fullImages?: Array<{ __typename?: 'ImageType', id: string, picture?: string | null } | null> | null } } | null } | null> } } | null };

export type PrescriptionNodeFragmentFragment = { __typename?: 'CorePrescriptionNode', id: string } & { ' $fragmentName'?: 'PrescriptionNodeFragmentFragment' };

export type InsertPrescriptionMutationVariables = Exact<{
  input: InsertPrescriptionNodeInput;
}>;


export type InsertPrescriptionMutation = { __typename?: 'Mutation', insertPrescription?: { __typename?: 'InsertPrescriptionNodePayload', prescription: (
      { __typename?: 'CorePrescriptionNode' }
      & { ' $fragmentRefs'?: { 'PrescriptionNodeFragmentFragment': PrescriptionNodeFragmentFragment } }
    ) } | null };

export type ProductV2FragmentFragment = { __typename?: 'ProductNode', id: string, title: string, description: string, targetPetTypes?: Array<PetTypes> | null, vendor?: string | null, vendorType: ProductVendorType, productCategoryDescriptor: string, shortDescription: string, productGuidance: string, images?: Array<{ __typename?: 'ImageType', id: string, picture?: string | null, extension?: string | null } | null> | null, fullImages?: Array<{ __typename?: 'ImageType', id: string, picture?: string | null, extension?: string | null } | null> | null, productDetails?: { __typename?: 'CoreMedicationNode', id: string, isPrescriptionRequired?: boolean | null, ingredientLineItems?: { __typename?: 'CoreIngredientLineNodeConnection', edges: Array<{ __typename?: 'CoreIngredientLineNodeEdge', node?: { __typename?: 'CoreIngredientLineNode', id: string, rank: number, ingredient: { __typename?: 'CoreIngredientNode', id: string, name: string, benefit?: string | null, isActive?: boolean | null } } | null } | null> } | null } | null, preferredSupplier?: { __typename?: 'PreferredSupplierDetails', url?: string | null, supplier: { __typename?: 'SupplierNode', id: string, name: string } } | null, meta?: { __typename?: 'CoreProductMeta', externalUrl?: string | null } | null } & { ' $fragmentName'?: 'ProductV2FragmentFragment' };

export type ProductVariantProductFragmentFragment = { __typename?: 'ProductVariantNode', product: (
    { __typename?: 'ProductNode', id: string }
    & { ' $fragmentRefs'?: { 'ProductV2FragmentFragment': ProductV2FragmentFragment } }
  ) } & { ' $fragmentName'?: 'ProductVariantProductFragmentFragment' };

export type ProductVariantFragmentFragment = { __typename?: 'ProductVariantNode', id: string, quantityType?: QuantityType | null, quantityValue?: any | null, isAvailable?: boolean | null, compareAtPrice?: any | null, price?: any | null, discountPrice?: any | null, slug: string, images?: Array<{ __typename?: 'ImageType', id: string, picture?: string | null, extension?: string | null } | null> | null, fullImages?: Array<{ __typename?: 'ImageType', id: string, picture?: string | null, extension?: string | null } | null> | null, product: { __typename?: 'ProductNode', id: string }, subscriptionPrices?: Array<{ __typename?: 'ProductVariantSubscriptionPriceNode', id: string, discountPercent: number, price?: { __typename?: 'PriceNode', id: string, priceType: PriceTypeEnum, interval?: number | null, period?: Period | null, price: any } | null } | null> | null, vcprAddons?: Array<{ __typename?: 'VCPRAddOnNode', id: string, slug: string, isActive: boolean, activationFee?: any | null } | null> | null } & { ' $fragmentName'?: 'ProductVariantFragmentFragment' };

export type ProductCollectionsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type ProductCollectionsQuery = { __typename?: 'Query', collections?: { __typename?: 'CollectionNodeConnection', edges: Array<{ __typename?: 'CollectionNodeEdge', node?: { __typename?: 'CollectionNode', id: string, name: string, products: Array<(
          { __typename?: 'ProductNode', id: string, variants: { __typename?: 'ProductVariantNodeConnection', edges: Array<{ __typename?: 'ProductVariantNodeEdge', node?: (
                { __typename?: 'ProductVariantNode', id: string }
                & { ' $fragmentRefs'?: { 'ProductVariantFragmentFragment': ProductVariantFragmentFragment } }
              ) | null } | null> } }
          & { ' $fragmentRefs'?: { 'ProductV2FragmentFragment': ProductV2FragmentFragment } }
        )> } | null } | null> } | null };

export type ProductV2QueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProductV2Query = { __typename?: 'Query', productV2?: (
    { __typename?: 'ProductNode', id: string, variants: { __typename?: 'ProductVariantNodeConnection', edges: Array<{ __typename?: 'ProductVariantNodeEdge', node?: (
          { __typename?: 'ProductVariantNode', id: string }
          & { ' $fragmentRefs'?: { 'ProductVariantFragmentFragment': ProductVariantFragmentFragment } }
        ) | null } | null> } }
    & { ' $fragmentRefs'?: { 'ProductV2FragmentFragment': ProductV2FragmentFragment } }
  ) | null };

export type ShippingAddressFragmentFragment = { __typename?: 'ShippingAddressType', id: string, firstName: string, lastName: string, formattedAddress?: string | null, address1: string, address2?: string | null, city: string, state: ShippingAddressState, zip: string, isPrimary: boolean } & { ' $fragmentName'?: 'ShippingAddressFragmentFragment' };

export type CreateShippingAddressMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
  city: Scalars['String'];
  state: Scalars['String'];
  isPrimary?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateShippingAddressMutation = { __typename?: 'Mutation', createShippingAddress?: { __typename?: 'CreateShippingAddress', shippingAddress?: (
      { __typename?: 'ShippingAddressType' }
      & { ' $fragmentRefs'?: { 'ShippingAddressFragmentFragment': ShippingAddressFragmentFragment } }
    ) | null } | null };

export type ShippingAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type ShippingAddressesQuery = { __typename?: 'Query', shippingAddresses?: Array<(
    { __typename?: 'ShippingAddressType' }
    & { ' $fragmentRefs'?: { 'ShippingAddressFragmentFragment': ShippingAddressFragmentFragment } }
  ) | null> | null };

export type UserInfoFragmentFragment = { __typename?: 'UserType', id: string, firstName?: string | null, lastName?: string | null, avatar?: string | null, isPayingCustomer?: boolean | null, identifier?: string | null } & { ' $fragmentName'?: 'UserInfoFragmentFragment' };

export type UserLocationFragmentFragment = { __typename?: 'UserType', location?: { __typename?: 'AddressType', id: string, formattedAddress?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: AddressState | null, zip?: string | null } | null } & { ' $fragmentName'?: 'UserLocationFragmentFragment' };

export type UserContactInfoFragmentFragment = (
  { __typename?: 'UserType', email?: string | null, phoneNumber?: string | null }
  & { ' $fragmentRefs'?: { 'UserLocationFragmentFragment': UserLocationFragmentFragment } }
) & { ' $fragmentName'?: 'UserContactInfoFragmentFragment' };

export type UserMetadataFragmentFragment = { __typename?: 'UserType', isVip: boolean, state?: any | null, lastPasswordSetAt?: any | null, identifiedAt?: any | null, insuranceEligibility?: boolean | null, requiresEmailVerification?: boolean | null, requiresFullAddress?: boolean | null, lastIosActivityAt?: any | null, shouldReceiveMarketingSms: boolean, shouldReceiveTransactionalSms: boolean, pendingNewEmail?: string | null, externalAccessTokens?: { __typename?: 'ExternalAccesTokensType', intercomWeb?: string | null } | null } & { ' $fragmentName'?: 'UserMetadataFragmentFragment' };

export type UserInsuranceFragmentFragment = { __typename?: 'UserType', insurancePolicy?: { __typename?: 'InsurancePolicy', id: string, certificateDocument?: string | null, policyDocument?: string | null, generatedAt?: any | null } | null } & { ' $fragmentName'?: 'UserInsuranceFragmentFragment' };

export type UserFragmentFragment = (
  { __typename?: 'UserType', userPlan?: (
    { __typename?: 'UserPlanNode' }
    & { ' $fragmentRefs'?: { 'UserPlanFragmentFragment': UserPlanFragmentFragment } }
  ) | null, experiments?: Array<{ __typename?: 'UserExperimentType', experiment?: string | null, variantName?: string | null, variantValue?: string | null } | null> | null, partner?: (
    { __typename?: 'PartnerNode' }
    & { ' $fragmentRefs'?: { 'PartnerFragmentFragment': PartnerFragmentFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'UserInfoFragmentFragment': UserInfoFragmentFragment;'UserContactInfoFragmentFragment': UserContactInfoFragmentFragment;'UserMetadataFragmentFragment': UserMetadataFragmentFragment;'UserInsuranceFragmentFragment': UserInsuranceFragmentFragment } }
) & { ' $fragmentName'?: 'UserFragmentFragment' };

export type RegisterDeviceMutationVariables = Exact<{
  input: RegisterDeviceInput;
}>;


export type RegisterDeviceMutation = { __typename?: 'Mutation', registerDevice?: { __typename?: 'RegisterDevicePayload', device: { __typename?: 'DeviceNode', id: string, deviceIdentifier: string } } | null };

export type UnsubscribeFromMarketingEmailsMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type UnsubscribeFromMarketingEmailsMutation = { __typename?: 'Mutation', unsubscribeFromMarketingEmails?: { __typename?: 'UnsubscribeFromMarketingEmails', success?: boolean | null } | null };

export type UpdateUserMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  interaction?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationInput>;
  avatar?: InputMaybe<Scalars['ImageUpload']>;
  shouldReceiveMarketingSms?: InputMaybe<Scalars['Boolean']>;
  shouldReceiveTransactionalSms?: InputMaybe<Scalars['Boolean']>;
  partner?: InputMaybe<Scalars['String']>;
  partnerCode?: InputMaybe<Scalars['String']>;
  partnerOauthCode?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UpdateUser', user?: { __typename?: 'UserType', id: string, email?: string | null, phoneNumber?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null, shouldReceiveMarketingSms: boolean, shouldReceiveTransactionalSms: boolean, requiresFullAddress?: boolean | null, insuranceEligibility?: boolean | null, requiresEmailVerification?: boolean | null, location?: { __typename?: 'AddressType', id: string, formattedAddress?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: AddressState | null, zip?: string | null } | null } | null } | null };

export type QueryUserQueryVariables = Exact<{ [key: string]: never; }>;


export type QueryUserQuery = { __typename?: 'Query', user?: (
    { __typename?: 'UserType', paymentMethods?: { __typename?: 'OwnerPaymentMethodConnection', edges: Array<{ __typename?: 'OwnerPaymentMethodEdge', node?: (
          { __typename?: 'CardPaymentMethod' }
          & { ' $fragmentRefs'?: { 'CardPaymentMethodFragmentFragment': CardPaymentMethodFragmentFragment } }
        ) | (
          { __typename?: 'PayPalPaymentMethod' }
          & { ' $fragmentRefs'?: { 'PayPalPaymentMethodFragmentFragment': PayPalPaymentMethodFragmentFragment } }
        ) | null } | null> } | null }
    & { ' $fragmentRefs'?: { 'UserFragmentFragment': UserFragmentFragment } }
  ) | null };

export const AppsflyerLink_UserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppsflyerLink_User"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]} as unknown as DocumentNode<AppsflyerLink_UserFragment, unknown>;
export const ProductVariantFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariantNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantityType"}},{"kind":"Field","name":{"kind":"Name","value":"quantityValue"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"compareAtPrice"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountPrice"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discountPercent"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vcprAddons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vcprAddons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activationFee"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]} as unknown as DocumentNode<ProductVariantFragmentFragment, unknown>;
export const ProductV2FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductV2Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetPetTypes"}},{"kind":"Field","name":{"kind":"Name","value":"productDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CoreMedicationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPrescriptionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"ingredientLineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"benefit"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preferredSupplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}},{"kind":"Field","name":{"kind":"Name","value":"vendorType"}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productCategoryDescriptor"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"productGuidance"}}]}}]} as unknown as DocumentNode<ProductV2FragmentFragment, unknown>;
export const ProductVariantProductFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantProductFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariantNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductV2Fragment"}}]}}]}}]} as unknown as DocumentNode<ProductVariantProductFragmentFragment, unknown>;
export const CartFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"totalTax"}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"productVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantProductFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<CartFragmentFragment, unknown>;
export const ClinicFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClinicFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CoreClinicNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]} as unknown as DocumentNode<ClinicFragmentFragment, unknown>;
export const FulfillmentFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FulfillmentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FulfillmentNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderLineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantProductFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"fulfillmentLineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipmentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"trackingCompany"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"trackingUrls"}}]}}]} as unknown as DocumentNode<FulfillmentFragmentFragment, unknown>;
export const OrderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"canceledAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelReason"}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"customerPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"orderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"totalShipping"}},{"kind":"Field","name":{"kind":"Name","value":"totalTax"}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantProductFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"prescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clinic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"professionalName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fulfillments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FulfillmentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CardPaymentMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"lastFour"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PayPalPaymentMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}}]} as unknown as DocumentNode<OrderFragmentFragment, unknown>;
export const PetInfoFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PetInfoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PetType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}},{"kind":"Field","name":{"kind":"Name","value":"isSpayedOrNeutered"}},{"kind":"Field","name":{"kind":"Name","value":"breed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"birthday"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"accuracyLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"age"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"profileCompletionPercentage"}}]}}]} as unknown as DocumentNode<PetInfoFragmentFragment, unknown>;
export const PetBasicsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PetBasicsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PetType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"isSpayedOrNeutered"}},{"kind":"Field","name":{"kind":"Name","value":"horoscope"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"microchip"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hometown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adoptionMethod"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}}]}}]} as unknown as DocumentNode<PetBasicsFragmentFragment, unknown>;
export const PetWellnessFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PetWellnessFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PetType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bodyType"}},{"kind":"Field","name":{"kind":"Name","value":"activityLevel"}},{"kind":"Field","name":{"kind":"Name","value":"vaccinations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vaccination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"administeredAt"}}]}}]}}]} as unknown as DocumentNode<PetWellnessFragmentFragment, unknown>;
export const PetFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PetType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PetInfoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PetBasicsFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PetWellnessFragment"}}]}}]} as unknown as DocumentNode<PetFragmentFragment, unknown>;
export const PetVcprFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PetVcprFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PetType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itchLevel"}},{"kind":"Field","name":{"kind":"Name","value":"hairLossLevel"}},{"kind":"Field","name":{"kind":"Name","value":"takenFleaTickMedication"}},{"kind":"Field","name":{"kind":"Name","value":"lastFleaTickMedication"}},{"kind":"Field","name":{"kind":"Name","value":"reasonForChangingFleaTickMedication"}},{"kind":"Field","name":{"kind":"Name","value":"breedingPregnantLactating"}},{"kind":"Field","name":{"kind":"Name","value":"preExistingEpilepsyConditions"}},{"kind":"Field","name":{"kind":"Name","value":"inContactWithNonHouseholdPetsOrYard"}},{"kind":"Field","name":{"kind":"Name","value":"allHouseholdPetsTreatedForFleas"}},{"kind":"Field","name":{"kind":"Name","value":"waterConsumption"}},{"kind":"Field","name":{"kind":"Name","value":"appetite"}},{"kind":"Field","name":{"kind":"Name","value":"behavior"}}]}}]} as unknown as DocumentNode<PetVcprFragmentFragment, unknown>;
export const PetDetailedFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PetDetailedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PetType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PetFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PetVcprFragment"}}]}}]} as unknown as DocumentNode<PetDetailedFragmentFragment, unknown>;
export const PrescriptionNodeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PrescriptionNodeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CorePrescriptionNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]} as unknown as DocumentNode<PrescriptionNodeFragmentFragment, unknown>;
export const ShippingAddressFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingAddressFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingAddressType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}}]}}]} as unknown as DocumentNode<ShippingAddressFragmentFragment, unknown>;
export const UserInfoFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isPayingCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}}]}}]} as unknown as DocumentNode<UserInfoFragmentFragment, unknown>;
export const UserLocationFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserLocationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}}]}}]} as unknown as DocumentNode<UserLocationFragmentFragment, unknown>;
export const UserContactInfoFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserContactInfoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserLocationFragment"}}]}}]} as unknown as DocumentNode<UserContactInfoFragmentFragment, unknown>;
export const UserMetadataFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserMetadataFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isVip"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"lastPasswordSetAt"}},{"kind":"Field","name":{"kind":"Name","value":"identifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"insuranceEligibility"}},{"kind":"Field","name":{"kind":"Name","value":"requiresEmailVerification"}},{"kind":"Field","name":{"kind":"Name","value":"requiresFullAddress"}},{"kind":"Field","name":{"kind":"Name","value":"lastIosActivityAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastPasswordSetAt"}},{"kind":"Field","name":{"kind":"Name","value":"shouldReceiveMarketingSms"}},{"kind":"Field","name":{"kind":"Name","value":"shouldReceiveTransactionalSms"}},{"kind":"Field","name":{"kind":"Name","value":"pendingNewEmail"}},{"kind":"Field","name":{"kind":"Name","value":"externalAccessTokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intercomWeb"}}]}}]}}]} as unknown as DocumentNode<UserMetadataFragmentFragment, unknown>;
export const UserInsuranceFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInsuranceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insurancePolicy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"certificateDocument"}},{"kind":"Field","name":{"kind":"Name","value":"policyDocument"}},{"kind":"Field","name":{"kind":"Name","value":"generatedAt"}}]}}]}}]} as unknown as DocumentNode<UserInsuranceFragmentFragment, unknown>;
export const BillingPlanNodeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BillingPlanNodeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingPlanNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"conversationLimit"}},{"kind":"Field","name":{"kind":"Name","value":"conversationRefreshPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"firstConversationDelay"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialDuration"}},{"kind":"Field","name":{"kind":"Name","value":"addOns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmergencyFundAddOnNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"period"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VCPRAddOnNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"activationFee"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"period"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BillingPlanNodeFragmentFragment, unknown>;
export const EmergencyFundStatusNodeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmergencyFundStatusNodeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmergencyFundStatusNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isBundled"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"nextClaimDate"}},{"kind":"Field","name":{"kind":"Name","value":"coverageStartsAt"}},{"kind":"Field","name":{"kind":"Name","value":"addOn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"period"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxPayout"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nextInvoiceDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentCycleStart"}},{"kind":"Field","name":{"kind":"Name","value":"currentCycleEnd"}}]}}]} as unknown as DocumentNode<EmergencyFundStatusNodeFragmentFragment, unknown>;
export const PayPalPaymentMethodFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PayPalPaymentMethodFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PayPalPaymentMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]} as unknown as DocumentNode<PayPalPaymentMethodFragmentFragment, unknown>;
export const CardPaymentMethodFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CardPaymentMethodFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CardPaymentMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"lastFour"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]} as unknown as DocumentNode<CardPaymentMethodFragmentFragment, unknown>;
export const AutoshipPlanFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AutoshipPlanFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AutoshipPlanNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nextInvoiceDate"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PayPalPaymentMethodFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CardPaymentMethodFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"period"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestOrder"},"name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"StringValue","value":"created_at","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CoreMedicationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPrescriptionRequired"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AutoshipPlanFragmentFragment, unknown>;
export const VcprStatusNodeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VCPRStatusNodeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VCPRStatusNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isBundled"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"pet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addOn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"period"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prescriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approvalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"processedAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"autoshipPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AutoshipPlanFragment"}}]}}]}}]} as unknown as DocumentNode<VcprStatusNodeFragmentFragment, unknown>;
export const UserPlanFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPlanFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserPlanNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"canStartConversation"}},{"kind":"Field","name":{"kind":"Name","value":"canClaimEmergency"}},{"kind":"Field","name":{"kind":"Name","value":"canClaimEmergencyAfter"}},{"kind":"Field","name":{"kind":"Name","value":"conversationsStartedThisCycle"}},{"kind":"Field","name":{"kind":"Name","value":"canStartConversation"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"nextEmergencyActivationDate"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"emergencyFund"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"coverageStartsAt"}},{"kind":"Field","name":{"kind":"Name","value":"nextClaimDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BillingPlanNodeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subsidizedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nextInvoiceDate"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CardPaymentMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastFour"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PayPalPaymentMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableAddOns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmergencyFundAddOnNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"period"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxPayout"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VCPRAddOnNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"period"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"addOns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmergencyFundStatusNodeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VCPRStatusNodeFragment"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserPlanFragmentFragment, unknown>;
export const PartnerFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PartnerFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PartnerNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]} as unknown as DocumentNode<PartnerFragmentFragment, unknown>;
export const UserFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserContactInfoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserMetadataFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInsuranceFragment"}},{"kind":"Field","name":{"kind":"Name","value":"userPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPlanFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"experiments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"experiment"}},{"kind":"Field","name":{"kind":"Name","value":"variantName"}},{"kind":"Field","name":{"kind":"Name","value":"variantValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PartnerFragment"}}]}}]}}]} as unknown as DocumentNode<UserFragmentFragment, unknown>;
export const FreeTrialLandingDataDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FreeTrialLandingData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppsflyerLink_User"}}]}}]}},...AppsflyerLink_UserFragmentDoc.definitions]} as unknown as DocumentNode<FreeTrialLandingDataQuery, FreeTrialLandingDataQueryVariables>;
export const FooterDataDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FooterData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppsflyerLink_User"}}]}}]}},...AppsflyerLink_UserFragmentDoc.definitions]} as unknown as DocumentNode<FooterDataQuery, FooterDataQueryVariables>;
export const UserManagementDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserManagementData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"lastIosActivityAt"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"externalAccessTokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intercomWeb"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UserManagementDataQuery, UserManagementDataQueryVariables>;
export const AppRouterDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppRouterData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AppRouterDataQuery, AppRouterDataQueryVariables>;
export const QueryUserIdEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryUserIdEmail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<QueryUserIdEmailQuery, QueryUserIdEmailQueryVariables>;
export const AddPaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddPaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddPaymentMethodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addPaymentMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CardPaymentMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"lastFour"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PayPalPaymentMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddPaymentMethodMutation, AddPaymentMethodMutationVariables>;
export const QueryUserPaymentMethodsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryUserPaymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PayPalPaymentMethodFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CardPaymentMethodFragment"}}]}}]}}]}}]}}]}},...PayPalPaymentMethodFragmentFragmentDoc.definitions,...CardPaymentMethodFragmentFragmentDoc.definitions]} as unknown as DocumentNode<QueryUserPaymentMethodsQuery, QueryUserPaymentMethodsQueryVariables>;
export const UserPhoneNumberAndIdentifierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserPhoneNumberAndIdentifier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}}]}}]}}]} as unknown as DocumentNode<UserPhoneNumberAndIdentifierQuery, UserPhoneNumberAndIdentifierQueryVariables>;
export const LoginV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoginV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginV2Input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"idToken"}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}}]}}]}}]}}]} as unknown as DocumentNode<LoginV2Mutation, LoginV2MutationVariables>;
export const LogoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Logout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refreshToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"refreshToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refreshToken"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>;
export const RefreshTokensDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RefreshTokens"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refreshToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshTokens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"refreshToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refreshToken"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idToken"}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}}]}}]}}]} as unknown as DocumentNode<RefreshTokensMutation, RefreshTokensMutationVariables>;
export const RequestGuestSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestGuestSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interaction"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestGuestSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"interaction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interaction"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"token"}}]}}]}}]} as unknown as DocumentNode<RequestGuestSessionMutation, RequestGuestSessionMutationVariables>;
export const SendOtpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendOtp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendOTPInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendOtp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<SendOtpMutation, SendOtpMutationVariables>;
export const SignupV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SignupV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SignupV2Input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signupV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idToken"}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}}]}}]}}]}}]} as unknown as DocumentNode<SignupV2Mutation, SignupV2MutationVariables>;
export const CheckoutDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Checkout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentMethodId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"paymentMethodId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentMethodId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderFragment"}}]}}]}}]}},...OrderFragmentFragmentDoc.definitions,...ProductVariantFragmentFragmentDoc.definitions,...ProductVariantProductFragmentFragmentDoc.definitions,...ProductV2FragmentFragmentDoc.definitions,...FulfillmentFragmentFragmentDoc.definitions]} as unknown as DocumentNode<CheckoutMutation, CheckoutMutationVariables>;
export const PreCheckoutDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PreCheckout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shippingAddressId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preCheckout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shippingAddressId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shippingAddressId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartFragment"}}]}}]}}]}},...CartFragmentFragmentDoc.definitions,...ProductVariantFragmentFragmentDoc.definitions,...ProductVariantProductFragmentFragmentDoc.definitions,...ProductV2FragmentFragmentDoc.definitions]} as unknown as DocumentNode<PreCheckoutMutation, PreCheckoutMutationVariables>;
export const UpdateCartDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineItems"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCartLineItemInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lineItems"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineItems"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartFragment"}}]}}]}}]}},...CartFragmentFragmentDoc.definitions,...ProductVariantFragmentFragmentDoc.definitions,...ProductVariantProductFragmentFragmentDoc.definitions,...ProductV2FragmentFragmentDoc.definitions]} as unknown as DocumentNode<UpdateCartMutation, UpdateCartMutationVariables>;
export const CurrentCartDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentCart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentCart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartFragment"}}]}}]}},...CartFragmentFragmentDoc.definitions,...ProductVariantFragmentFragmentDoc.definitions,...ProductVariantProductFragmentFragmentDoc.definitions,...ProductV2FragmentFragmentDoc.definitions]} as unknown as DocumentNode<CurrentCartQuery, CurrentCartQueryVariables>;
export const InsertClinicDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertClinic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"googlePlaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertClinicV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"googlePlaceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"googlePlaceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clinic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClinicFragment"}}]}}]}}]}},...ClinicFragmentFragmentDoc.definitions]} as unknown as DocumentNode<InsertClinicMutation, InsertClinicMutationVariables>;
export const UserClinicsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserClinics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clinics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClinicFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryClinic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},...ClinicFragmentFragmentDoc.definitions]} as unknown as DocumentNode<UserClinicsQuery, UserClinicsQueryVariables>;
export const SubmitClinicLocationRatingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitClinicLocationRating"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clinicLocationObjectid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rating"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"review"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitClinicLocationRating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clinicLocationObjectid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clinicLocationObjectid"}}},{"kind":"Argument","name":{"kind":"Name","value":"rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rating"}}},{"kind":"Argument","name":{"kind":"Name","value":"review"},"value":{"kind":"Variable","name":{"kind":"Name","value":"review"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clinicLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"review"}}]}}]}}]}}]} as unknown as DocumentNode<SubmitClinicLocationRatingMutation, SubmitClinicLocationRatingMutationVariables>;
export const OrdersDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Orders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ordersV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderFragment"}}]}}]}}]}}]}},...OrderFragmentFragmentDoc.definitions,...ProductVariantFragmentFragmentDoc.definitions,...ProductVariantProductFragmentFragmentDoc.definitions,...ProductV2FragmentFragmentDoc.definitions,...FulfillmentFragmentFragmentDoc.definitions]} as unknown as DocumentNode<OrdersQuery, OrdersQueryVariables>;
export const CreatePetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gender"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isSpayedOrNeutered"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weight"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"birthday"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BirthdayInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"picture"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ImageUpload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"gender"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gender"}}},{"kind":"Argument","name":{"kind":"Name","value":"breed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breed"}}},{"kind":"Argument","name":{"kind":"Name","value":"isSpayedOrNeutered"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isSpayedOrNeutered"}}},{"kind":"Argument","name":{"kind":"Name","value":"weight"},"value":{"kind":"Variable","name":{"kind":"Name","value":"weight"}}},{"kind":"Argument","name":{"kind":"Name","value":"birthday"},"value":{"kind":"Variable","name":{"kind":"Name","value":"birthday"}}},{"kind":"Argument","name":{"kind":"Name","value":"picture"},"value":{"kind":"Variable","name":{"kind":"Name","value":"picture"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"breed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSpayedOrNeutered"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accuracyLevel"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreatePetMutation, CreatePetMutationVariables>;
export const UpdatePetDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"adoptionMethod"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"adverseReactionsToMedicines"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allHouseholdPetsTreatedForFleas"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appetite"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PetAppetite"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"behavior"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PetBehavior"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"birthday"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BirthdayInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bodyType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breedingPregnantLactating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateOfDeath"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deletedFields"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"defaultValue":{"kind":"ListValue","values":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eyeColor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gender"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hairLossLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hometown"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inContactWithNonHouseholdPetsOrYard"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isSpayedOrNeutered"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itchLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastFleaTickMedication"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLastFleaTickMedication"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"microchip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MicrochipInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nickname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"picture"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ImageUpload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pk"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preExistingEpilepsyConditions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rabies"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RabiesInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reasonForChangingFleaTickMedication"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"takenFleaTickMedication"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"waterConsumption"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PetWaterConsumption"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weight"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"activityLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"adoptionMethod"},"value":{"kind":"Variable","name":{"kind":"Name","value":"adoptionMethod"}}},{"kind":"Argument","name":{"kind":"Name","value":"adverseReactionsToMedicines"},"value":{"kind":"Variable","name":{"kind":"Name","value":"adverseReactionsToMedicines"}}},{"kind":"Argument","name":{"kind":"Name","value":"allHouseholdPetsTreatedForFleas"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allHouseholdPetsTreatedForFleas"}}},{"kind":"Argument","name":{"kind":"Name","value":"appetite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appetite"}}},{"kind":"Argument","name":{"kind":"Name","value":"behavior"},"value":{"kind":"Variable","name":{"kind":"Name","value":"behavior"}}},{"kind":"Argument","name":{"kind":"Name","value":"birthday"},"value":{"kind":"Variable","name":{"kind":"Name","value":"birthday"}}},{"kind":"Argument","name":{"kind":"Name","value":"bodyType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bodyType"}}},{"kind":"Argument","name":{"kind":"Name","value":"breed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breed"}}},{"kind":"Argument","name":{"kind":"Name","value":"breedingPregnantLactating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breedingPregnantLactating"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateOfDeath"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateOfDeath"}}},{"kind":"Argument","name":{"kind":"Name","value":"deletedFields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deletedFields"}}},{"kind":"Argument","name":{"kind":"Name","value":"eyeColor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eyeColor"}}},{"kind":"Argument","name":{"kind":"Name","value":"gender"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gender"}}},{"kind":"Argument","name":{"kind":"Name","value":"hairLossLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hairLossLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"hometown"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hometown"}}},{"kind":"Argument","name":{"kind":"Name","value":"inContactWithNonHouseholdPetsOrYard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inContactWithNonHouseholdPetsOrYard"}}},{"kind":"Argument","name":{"kind":"Name","value":"isSpayedOrNeutered"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isSpayedOrNeutered"}}},{"kind":"Argument","name":{"kind":"Name","value":"itchLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itchLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastFleaTickMedication"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastFleaTickMedication"}}},{"kind":"Argument","name":{"kind":"Name","value":"nameLastFleaTickMedication"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLastFleaTickMedication"}}},{"kind":"Argument","name":{"kind":"Name","value":"microchip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"microchip"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"nickname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nickname"}}},{"kind":"Argument","name":{"kind":"Name","value":"picture"},"value":{"kind":"Variable","name":{"kind":"Name","value":"picture"}}},{"kind":"Argument","name":{"kind":"Name","value":"pk"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pk"}}},{"kind":"Argument","name":{"kind":"Name","value":"preExistingEpilepsyConditions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preExistingEpilepsyConditions"}}},{"kind":"Argument","name":{"kind":"Name","value":"rabies"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rabies"}}},{"kind":"Argument","name":{"kind":"Name","value":"reasonForChangingFleaTickMedication"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reasonForChangingFleaTickMedication"}}},{"kind":"Argument","name":{"kind":"Name","value":"takenFleaTickMedication"},"value":{"kind":"Variable","name":{"kind":"Name","value":"takenFleaTickMedication"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"waterConsumption"},"value":{"kind":"Variable","name":{"kind":"Name","value":"waterConsumption"}}},{"kind":"Argument","name":{"kind":"Name","value":"weight"},"value":{"kind":"Variable","name":{"kind":"Name","value":"weight"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PetFragment"}}]}}]}}]}},...PetFragmentFragmentDoc.definitions,...PetInfoFragmentFragmentDoc.definitions,...PetBasicsFragmentFragmentDoc.definitions,...PetWellnessFragmentFragmentDoc.definitions]} as unknown as DocumentNode<UpdatePetMutation, UpdatePetMutationVariables>;
export const PetsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Pets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PetInfoFragment"}}]}}]}},...PetInfoFragmentFragmentDoc.definitions]} as unknown as DocumentNode<PetsQuery, PetsQueryVariables>;
export const PetsDetailedDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PetsDetailed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PetDetailedFragment"}}]}}]}},...PetDetailedFragmentFragmentDoc.definitions,...PetFragmentFragmentDoc.definitions,...PetInfoFragmentFragmentDoc.definitions,...PetBasicsFragmentFragmentDoc.definitions,...PetWellnessFragmentFragmentDoc.definitions,...PetVcprFragmentFragmentDoc.definitions]} as unknown as DocumentNode<PetsDetailedQuery, PetsDetailedQueryVariables>;
export const ActivateAddOnDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ActivateAddOn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivateAddOnInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activateAddOn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPlanFragment"}}]}}]}}]}},...UserPlanFragmentFragmentDoc.definitions,...BillingPlanNodeFragmentFragmentDoc.definitions,...EmergencyFundStatusNodeFragmentFragmentDoc.definitions,...VcprStatusNodeFragmentFragmentDoc.definitions,...AutoshipPlanFragmentFragmentDoc.definitions,...PayPalPaymentMethodFragmentFragmentDoc.definitions,...CardPaymentMethodFragmentFragmentDoc.definitions]} as unknown as DocumentNode<ActivateAddOnMutation, ActivateAddOnMutationVariables>;
export const SetUserPlanDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetUserPlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetUserPlanInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setUserPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPlanFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"login"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idToken"}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}}]}}]}}]}},...UserPlanFragmentFragmentDoc.definitions,...BillingPlanNodeFragmentFragmentDoc.definitions,...EmergencyFundStatusNodeFragmentFragmentDoc.definitions,...VcprStatusNodeFragmentFragmentDoc.definitions,...AutoshipPlanFragmentFragmentDoc.definitions,...PayPalPaymentMethodFragmentFragmentDoc.definitions,...CardPaymentMethodFragmentFragmentDoc.definitions]} as unknown as DocumentNode<SetUserPlanMutation, SetUserPlanMutationVariables>;
export const QuoteSignupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QuoteSignup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteSignup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isEligibleForTrial"}},{"kind":"Field","name":{"kind":"Name","value":"trialLength"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}},{"kind":"Field","name":{"kind":"Name","value":"productDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CoreMedicationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPrescriptionRequired"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]} as unknown as DocumentNode<QuoteSignupQuery, QuoteSignupQueryVariables>;
export const InsertPrescriptionDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertPrescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertPrescriptionNodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertPrescription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PrescriptionNodeFragment"}}]}}]}}]}},...PrescriptionNodeFragmentFragmentDoc.definitions]} as unknown as DocumentNode<InsertPrescriptionMutation, InsertPrescriptionMutationVariables>;
export const ProductCollectionsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductCollections"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductV2Fragment"}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantFragment"}}]}}]}}]}}]}}]}}]}}]}}]}},...ProductV2FragmentFragmentDoc.definitions,...ProductVariantFragmentFragmentDoc.definitions]} as unknown as DocumentNode<ProductCollectionsQuery, ProductCollectionsQueryVariables>;
export const ProductV2Document = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductV2Fragment"}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantFragment"}}]}}]}}]}}]}}]}},...ProductV2FragmentFragmentDoc.definitions,...ProductVariantFragmentFragmentDoc.definitions]} as unknown as DocumentNode<ProductV2Query, ProductV2QueryVariables>;
export const CreateShippingAddressDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateShippingAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address1"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPrimary"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createShippingAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"address1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address1"}}},{"kind":"Argument","name":{"kind":"Name","value":"address2"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address2"}}},{"kind":"Argument","name":{"kind":"Name","value":"zip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zip"}}},{"kind":"Argument","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}},{"kind":"Argument","name":{"kind":"Name","value":"isPrimary"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPrimary"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingAddressFragment"}}]}}]}}]}},...ShippingAddressFragmentFragmentDoc.definitions]} as unknown as DocumentNode<CreateShippingAddressMutation, CreateShippingAddressMutationVariables>;
export const ShippingAddressesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ShippingAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shippingAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingAddressFragment"}}]}}]}},...ShippingAddressFragmentFragmentDoc.definitions]} as unknown as DocumentNode<ShippingAddressesQuery, ShippingAddressesQueryVariables>;
export const RegisterDeviceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RegisterDevice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RegisterDeviceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registerDevice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"device"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deviceIdentifier"}}]}}]}}]}}]} as unknown as DocumentNode<RegisterDeviceMutation, RegisterDeviceMutationVariables>;
export const UnsubscribeFromMarketingEmailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnsubscribeFromMarketingEmails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unsubscribeFromMarketingEmails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UnsubscribeFromMarketingEmailsMutation, UnsubscribeFromMarketingEmailsMutationVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interaction"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"avatar"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ImageUpload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldReceiveMarketingSms"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldReceiveTransactionalSms"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partner"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerOauthCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"interaction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interaction"}}},{"kind":"Argument","name":{"kind":"Name","value":"location"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}},{"kind":"Argument","name":{"kind":"Name","value":"avatar"},"value":{"kind":"Variable","name":{"kind":"Name","value":"avatar"}}},{"kind":"Argument","name":{"kind":"Name","value":"shouldReceiveMarketingSms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldReceiveMarketingSms"}}},{"kind":"Argument","name":{"kind":"Name","value":"shouldReceiveTransactionalSms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldReceiveTransactionalSms"}}},{"kind":"Argument","name":{"kind":"Name","value":"partner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partner"}}},{"kind":"Argument","name":{"kind":"Name","value":"partnerCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"partnerOauthCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerOauthCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"shouldReceiveMarketingSms"}},{"kind":"Field","name":{"kind":"Name","value":"shouldReceiveTransactionalSms"}},{"kind":"Field","name":{"kind":"Name","value":"requiresFullAddress"}},{"kind":"Field","name":{"kind":"Name","value":"insuranceEligibility"}},{"kind":"Field","name":{"kind":"Name","value":"requiresEmailVerification"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const QueryUserDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PayPalPaymentMethodFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CardPaymentMethodFragment"}}]}}]}}]}}]}}]}},...UserFragmentFragmentDoc.definitions,...UserInfoFragmentFragmentDoc.definitions,...UserContactInfoFragmentFragmentDoc.definitions,...UserLocationFragmentFragmentDoc.definitions,...UserMetadataFragmentFragmentDoc.definitions,...UserInsuranceFragmentFragmentDoc.definitions,...UserPlanFragmentFragmentDoc.definitions,...BillingPlanNodeFragmentFragmentDoc.definitions,...EmergencyFundStatusNodeFragmentFragmentDoc.definitions,...VcprStatusNodeFragmentFragmentDoc.definitions,...AutoshipPlanFragmentFragmentDoc.definitions,...PayPalPaymentMethodFragmentFragmentDoc.definitions,...CardPaymentMethodFragmentFragmentDoc.definitions,...PartnerFragmentFragmentDoc.definitions]} as unknown as DocumentNode<QueryUserQuery, QueryUserQueryVariables>;